export default {
  failed: 'La acción falló',
  success: 'La acción fue exitosa',
  common: {
    menu: 'Menú',
    save: 'Guardar',
    cancel: 'Cancelar',
    smsOptedOut: 'Este número ha optado por no recibir SMS. Pueden responder START para volver a suscribirse.',
    back: 'Volver',
    backToSettings: 'Volver a configuración',
    backToReports: 'Volver a informes',
    backToProducts: 'Volver a productos',
    edit: 'Editar',
    delete: 'Eliminar',
    loading: 'Cargando...',
    error: 'Error',
    success: 'Éxito',
    apply: 'Aplicar',
    yes: 'Sí',
    no: 'No',
    close: 'Cerrar'
  },
  cardCapture: {
    loadingOptions: 'Comprobando métodos de captura disponibles…',
    chooseMethod: '¿Cómo se agregará la tarjeta?',
    methodTerminal: 'Terminal',
    methodKeyed: 'Entrada manual',
    methodKeyedSecure: 'Los datos de la tarjeta se ingresan de forma segura.',
    terminalPanelHint: 'Use el terminal físico o el lector integrado en esta caja.',
    terminalPanelWalletHint: 'Se autoriza $1.00 para validar la tarjeta; la autorización se anula al guardar.',
    statusTokenizing: 'Protegiendo los datos de la tarjeta…',
    statusSaving: 'Guardando tarjeta…',
    statusTerminal: 'Complete la lectura de la tarjeta en el terminal…',
    statusIntegrated: 'Siga las indicaciones en el lector integrado…'
  },
  numpad: {
    open: 'Abrir teclado numérico',
    digit: 'Dígito {digit}',
    decimal: 'Punto decimal',
    backspace: 'Borrar',
    backspaceHint: 'Toque para borrar. Mantenga pulsado para limpiar.',
    cursorLeft: 'Mover cursor a la izquierda',
    cursorRight: 'Mover cursor a la derecha',
    done: 'Listo',
    cancel: 'Cancelar',
    overlayTitle: 'Ingresar monto'
  },
  tableColumns: {
    settingsTooltip: 'Columnas de la tabla',
    settingsAria: 'Configuración de columnas visibles',
    visibleColumns: 'Columnas visibles'
  },
  auth: {
    login: 'Iniciar sesión',
    logout: 'Cerrar sesión',
    email: 'Correo electrónico',
    password: 'Contraseña',
    forgotPassword: '¿Olvidaste tu contraseña?',
    resetPassword: 'Restablecer contraseña',
    setPassword: 'Establecer contraseña',
    appIconAlt: 'Icono de la app Blu'
  },
  profile: {
    title: 'Perfil',
    subtitle: 'Actualiza tus datos y preferencias de cuenta',
    personalInfo: 'Información personal',
    fullName: 'Nombre completo',
    emailAddress: 'Correo electrónico',
    language: 'Idioma',
    useBusinessDefault: 'Usar predeterminado del negocio',
    emailRequired: 'El correo es obligatorio',
    emailInvalid: 'Formato de correo inválido',
    emailChangesAffectLogin: 'Los cambios de correo afectan el inicio de sesión',
    emailChangesMessage: 'Cambiar tu correo también actualizará tus credenciales de acceso. Usa el nuevo correo la próxima vez que inicies sesión.',
    phoneNumber: 'Número de teléfono',
    phonePlaceholder: '+1 555 555 1212',
    security: 'Seguridad',
    changePassword: 'Cambiar contraseña',
    currentPassword: 'Contraseña actual',
    newPassword: 'Nueva contraseña',
    confirmNewPassword: 'Confirmar nueva contraseña',
    currentPasswordRequired: 'La contraseña actual es obligatoria',
    newPasswordRequired: 'La nueva contraseña es obligatoria',
    changeAvatar: 'Cambiar avatar',
    saveChanges: 'Guardar cambios',
    notifications: 'Notificaciones',
    notifyClientActivity: 'Notificarme sobre actividad de clientes en cotizaciones/facturas',
    ccReceiptsDefault: 'Enviarme copia de recibos por defecto',
    ccReceiptsDefaultDesc: 'Aplica a recibos de ventas por correo y correos de registro a eventos.',
    notifyEventRegistrations: 'Enviarme correo cuando alguien se registre a un evento',
    notifyEventRegistrationsDesc: 'Los registros pagados incluyen un PDF de recibo.',
    dashboardDigests: 'Resúmenes del panel',
    dashboardDigestsDesc: 'Resúmenes matutinos y de fin de día para las ubicaciones que puede ver en informes.',
    notifyMorningDigestEmail: 'Enviarme por correo el resumen matutino del panel',
    notifyMorningDigestEmailDesc: 'Resultados de ayer más el contexto de la meta de ingresos de hoy.',
    notifyEodDigestEmail: 'Enviarme por correo el resumen de fin de día',
    notifyEodDigestEmailDesc: 'El pulso final de hoy para cada ubicación a la que tiene acceso.',
    notifyMorningDigestPush: 'Notificarme el resumen matutino del panel',
    notifyMorningDigestPushDesc: 'Solo en la app nativa. Requiere permiso de notificaciones en este dispositivo.',
    pushUnavailableOnDevice: 'Las notificaciones push no están disponibles en este dispositivo (terminales Dejavoo sin Google Play Services). Use los resúmenes por correo.',
    notifyEodDigestPush: 'Notificarme el resumen de fin de día',
    notifyEodDigestPushDesc: 'Solo en la app nativa. Se envía al cerrar el día comercial.',
    digestSendNowTitle: 'Enviar resumen ahora',
    digestSendNowDesc: 'Encola los mismos trabajos de correo y push que el resumen programado para cada ubicación.',
    digestSendMorningNow: 'Enviar resumen matutino ahora',
    digestSendEodNow: 'Enviar resumen de fin de día ahora',
    digestSendChannelsRequired: 'Activa correo o push para este resumen antes de enviar.',
    digestSendCooldownActive: 'Espera antes de volver a enviar este resumen.',
    digestSendQueued: 'Resumen encolado para {count} ubicación(es).',
    digestSendFailed: 'No se pudo encolar el resumen del panel.',
    digestSendCooldownMinutes: 'Disponible de nuevo en {minutes}m {seconds}s',
    digestSendCooldownSeconds: 'Disponible de nuevo en {seconds}s',
    digestSendCooldownHours: 'Disponible de nuevo en {hours}h {minutes}m',
    developer: 'Desarrollador',
    disableShadows: 'Deshabilitar todas las sombras (dev)',
    disableShadowsDesc: 'Deshabilita todos los box-shadows de CSS en la app (solo dispositivo local).',
    localDevTools: 'Herramientas de desarrollo local',
    mockCardFlow: 'Flujo de tarjeta simulado',
    mockCardFlowDesc: 'Recorra pagos con tarjeta y división sin pasarela. Solo con el servidor de desarrollo Quasar en local (no en dev desplegado ni producción). Requiere API local (APP_ENV=local).',
    updateProfilePicture: 'Actualizar foto de perfil',
    chooseProfilePicture: 'Elegir foto de perfil',
    selectProfilePicture: 'Selecciona una foto de perfil',
    uploadPicture: 'Subir foto',
    loadFailed: 'Error al cargar el perfil',
    updated: 'Perfil actualizado correctamente',
    pictureUpdated: 'Foto de perfil actualizada correctamente',
    pictureFailed: 'Error al actualizar la foto de perfil',
    passwordUpdated: 'Contraseña actualizada correctamente',
    passwordsNoMatch: 'Las contraseñas no coinciden',
    english: 'English',
    spanish: 'Español',
    posPreferences: 'Punto de venta',
    posPreferencesDesc: 'Opciones para la caja registradora y pantallas relacionadas del POS.',
    touchNumpadMode: 'Teclado numérico táctil en campos numéricos',
    touchNumpadModeHelp: 'Controla el teclado numérico en pantalla en web y Electron. No disponible en la app móvil.',
    touchNumpadModeOff: 'Desactivado',
    touchNumpadModeAvailable: 'Disponible (tocar icono para abrir)',
    touchNumpadModeAlways: 'Siempre visible',
    touchNumpadFixedDecimal: 'Entrada de caja registradora en el teclado numérico',
    touchNumpadFixedDecimalHelp: 'Los dígitos se rellenan de derecha a izquierda (6, 5, 2 se convierte en 6,52). La tecla decimal desplaza dos lugares (2, 5, . se convierte en 25,00).',
    registerCustomerGridEnabled: 'Cuadrícula de clientes en caja',
    registerCustomerGridEnabledHelp: 'Reemplaza la búsqueda en línea con una cuadrícula a pantalla completa para desplazarse y tocar un cliente.',
    appearance: 'Apariencia',
    appearanceDesc: 'Ajuste el tamaño de botones y la apariencia de la cuadrícula en las pantallas de TPV que utilice.',
    openUiSettings: 'Configuración de interfaz',
    uiSettings: {
      title: 'Configuración de interfaz',
      subtitle: 'Elija el tamaño de botones del teclado numérico táctil, las acciones de venta, la cuadrícula de productos y la lista del carrito.',
      numpadTitle: 'Teclado numérico táctil',
      numpadHelp: 'Se aplica al teclado numérico en pantalla en web y Electron. No se muestra en la app móvil.',
      saleActionsTitle: 'Botones de acción de venta',
      saleActionsHelp: 'Iconos de suspender, reanudar y borrar venta junto al total del carrito en la caja.',
      gridTitle: 'Cuadrícula de productos',
      gridHelp: 'Tamaño y color de etiquetas de categorías y productos en la cuadrícula de la caja.',
      gridFontSizeTitle: 'Tamaño de fuente de la cuadrícula',
      gridFontColorTitle: 'Color de fuente de la cuadrícula',
      gridPreviewLabel: 'Etiqueta de vista previa',
      gridPreviewDefaultLabel: 'Especial de la casa',
      gridFontColorModes: {
        automatic: 'Automático',
        manual: 'Manual'
      },
      gridFontColors: {
        black: 'Negro',
        white: 'Blanco'
      },
      cartLineTitle: 'Lista del carrito',
      cartLineHelp: 'Tamaño, peso y fondo de fila para los artículos del carrito en la caja.',
      cartLineFontSizeTitle: 'Tamaño de fuente del carrito',
      cartLineFontWeightTitle: 'Peso de fuente del carrito',
      cartLineRowBackgroundColorTitle: 'Color de fondo de fila',
      cartLineRowBackgroundOpacityTitle: 'Opacidad de fondo de fila',
      cartLineRowPatternTitle: 'Patrón de filas',
      cartLineFontWeights: {
        regular: 'Regular',
        medium: 'Medio',
        semibold: 'Seminegrita'
      },
      cartLineRowBackgroundColors: {
        none: 'Ninguno',
        neutral: 'Neutro',
        primary: 'Primario',
        secondary: 'Secundario'
      },
      cartLineRowBackgroundOpacities: {
        percent: '{value}%'
      },
      cartLineRowPatterns: {
        flat: 'Plano',
        striped: 'Rayado'
      },
      cartLinePreviewItemName: 'Hamburguesa de la casa',
      cartLinePreviewDiscountName: 'Ensalada',
      cartLinePreviewUnitPrice: '${price} c/u',
      cartLinePreviewModifiers: 'Sin cebolla (+$0.00), Queso extra (+$1.50)',
      resetCartLineFontWeight: 'Restablecer peso',
      resetCartLineRowBackgroundColor: 'Restablecer color de fila',
      resetCartLineRowBackgroundOpacity: 'Restablecer opacidad',
      resetCartLineRowPattern: 'Restablecer patrón',
      preview: 'Vista previa',
      resetToDefault: 'Restablecer a {size}',
      sizes: {
        xs: 'XS',
        sm: 'SM',
        md: 'MD',
        lg: 'LG',
        xl: 'XL'
      }
    }
  },
  business: {
    title: 'Información del negocio',
    subtitle: 'Marca, dirección y preferencias',
    businessName: 'Nombre del negocio',
    defaultLanguage: 'Idioma predeterminado',
    defaultTimezone: 'Zona horaria predeterminada',
    defaultTimezoneHint: 'Busca por ciudad o región. Se usa en citas e informes cuando la ubicación no tiene zona propia.',
    digestCushion: {
      title: 'Horario de resúmenes del panel',
      hint: 'Los resúmenes por ubicación se envían antes de abrir y después de cerrar usando estos márgenes cuando hay horario configurado.',
      morning: 'Minutos antes de abrir',
      morningHint: 'Antelación del resumen matutino (predeterminado 30).',
      eod: 'Minutos después de cerrar',
      eodHint: 'Retraso del resumen de fin de día (predeterminado 120).'
    },
    dailyRevenueGoal: 'Meta diaria de ingresos',
    dailyRevenueGoalHint: 'Cada ubicación apunta a esta meta diaria. Déjela en blanco para ocultar el seguimiento en el panel.',
    yourBusiness: 'Tu negocio',
    businessDetails: 'Detalles del negocio',
    accountNumber: 'Número de cuenta',
    accountNumberCopied: 'Número de cuenta copiado al portapapeles.',
    accountNumberCopyFailed: 'No se pudo copiar. Cópialo manualmente.',
    accountNumberSecureContextWarning: 'El portapapeles requiere un contexto seguro (HTTPS).',
    brandColors: 'Colores de marca',
    primaryColor: 'Color primario',
    accentColor: 'Color de acento',
    address: 'Dirección',
    addressLine1: 'Línea de dirección 1',
    addressLine2: 'Línea de dirección 2',
    city: 'Ciudad',
    state: 'Estado',
    postalCode: 'Código postal',
    country: 'País',
    contactInformation: 'Información de contacto',
    estimates: 'Cotizaciones',
    requireEstimateApproval: 'Solicitar aprobación por defecto al enviar cotizaciones por correo',
    requireEstimateSignature: 'Requerir firma del cliente al aprobar cotizaciones',
    posGrid: 'Cuadrícula POS',
    preferProductImages: 'Preferir imágenes de productos en cuadrícula POS cuando estén disponibles',
    tabsSection: 'Cuentas de cliente',
    enableCustomerTabs: 'Activar cuentas (tabs) de cliente',
    enableCustomerTabsHint:
      'Permite abrir cuentas, cobrar ventas a cuenta y pagos de cuenta en el POS.',
    barTabOpeningPreauth: 'Retención de tarjeta al abrir cuenta bar',
    barTabOpeningPreauthHint: 'Monto opcional al verificar una tarjeta (0 guarda la tarjeta sin retención).',
    barTabSameCalendarDayOnly: 'Cuentas bar solo el mismo día calendario',
    barTabSameCalendarDayOnlyHint:
      'Cuando está activo, las cuentas bar solo pueden recibir cargos el día calendario en que se abrieron.',
    barTabRequireCardOnFile: 'Requerir tarjeta para cuentas bar',
    barTabRequireCardOnFileHint:
      'Cuando está activo, el personal debe verificar una tarjeta antes de registrar cargos en una cuenta bar. Si está desactivado, la configuración de tarjeta sigue disponible pero se puede omitir.',
    orderAheadSection: 'Pedidos anticipados (cola de recogida)',
    enableOrderAheadQueue: 'Activar cola de recogida para el personal',
    enableOrderAheadQueueHint:
      'Muestra la cola de recogida en el POS, el panel y la pantalla de cocina. Complételo con la configuración de pedidos anticipados para el menú público. Desactívela si no acepta pedidos por adelantado.',
    rentalsSection: 'Alquileres',
    enableRentals: 'Activar módulo de alquileres',
    enableRentalsHint:
      'Muestra alquileres en la navegación y herramientas para unidades, acuerdos y facturación. Desactivado por defecto.',
    bookingSection: 'Reservas',
    enableBookingModule: 'Activar módulo de reservas',
    enableBookingModuleHint:
      'Muestra reservas en la navegación, herramientas de personal y reservas en línea en su sitio web. Desactivado por defecto.',
    invoicesSection: 'Facturas / Cuentas por cobrar',
    enableInvoicesModule: 'Activar módulo de facturas',
    enableInvoicesModuleHint:
      'Muestra la navegación de facturas, flujos de presupuestos y facturas, condiciones de pago e informes de CxC. Desactívelo para comercios solo retail. Al desactivarlo también se desactivan los proyectos.',
    projectsSection: 'Proyectos / Trabajos',
    enableProjectsModule: 'Activar módulo de proyectos',
    enableProjectsModuleHint:
      'Seguimiento de rentabilidad por trabajo con facturas y gastos con recibo. Requiere facturas.',
    eventsSection: 'Eventos',
    enableEventsModule: 'Activar módulo de eventos',
    enableEventsModuleHint:
      'Muestra eventos en la navegación, gestión de eventos y portales públicos de inscripción. Desactivado por defecto.',
    leadsSection: 'Prospectos',
    enableLeadsModule: 'Activar módulo de prospectos',
    enableLeadsModuleHint:
      'Muestra prospectos en la navegación, configuración del formulario de admisión y un formulario de contacto para su sitio web. Desactivado por defecto.',
    suspendedSalesSection: 'Ventas suspendidas',
    suspendedSalesLocationWideResume:
      'Permitir que cualquier caja de esta ubicación reanude ventas suspendidas',
    suspendedSalesLocationWideResumeHint:
      'Si está desactivado, solo la caja que suspendió la venta puede listarla o reanudarla. Si está activado, cualquier caja de la misma ubicación puede reanudar.',
    suspendedSalesPromptForNote: 'Solicitar una nota al suspender una venta',
    suspendedSalesPromptForNoteHint:
      'Si está activado, el cajero ve un campo opcional de nota antes de poner la venta en espera. Las notas siempre se pueden agregar o editar desde la lista de ventas suspendidas.',
    paymentsSection: 'Pagos',
    enableCashPennyRounding: 'Redondeo de centavos en efectivo',
    enableCashPennyRoundingHint:
      'Cuando está activado, los pagos en efectivo redondean el total final al múltiplo de cinco centavos más cercano después de impuestos y descuentos. Tarjeta y pagos electrónicos permanecen exactos.',
    receiptsSection: 'Recibos',
    showCashierOnReceipt: 'Mostrar cajero en el recibo',
    showCashierOnReceiptHint:
      'Cuando está activado, los recibos térmicos de venta incluyen el nombre del cajero. Los recibos PDF y por correo no cambian.',
    saveChanges: 'Guardar cambios',
    updateLogo: 'Actualizar logo del negocio',
    chooseLogo: 'Elegir logo',
    selectLogo: 'Selecciona un logo',
    uploadLogo: 'Subir logo',
    changeLogo: 'Cambiar logo',
    logoSelectRequired: 'Selecciona un archivo de logo',
    logoUpdated: 'Logo actualizado correctamente',
    logoFailed: 'Error al actualizar el logo',
    infoUpdated: 'Información del negocio actualizada correctamente',
    infoFailed: 'Error al actualizar la información del negocio',
    emailInvalid: 'Formato de correo inválido',
    english: 'English',
    spanish: 'Español'
  },
  login: {
    welcomeBack: 'Bienvenido de nuevo',
    signInToAccount: 'Inicia sesión en tu cuenta',
    accountSubdomain: 'Subdominio de la cuenta',
    subdomainRequired: 'El subdominio es obligatorio',
    subdomainOptionalDev: 'Déjalo en blanco para usar la API local (solo en desarrollo).',
    subdomainInvalid: 'Usa solo letras, números y guiones',
    emailAddress: 'Correo electrónico',
    emailRequired: 'El correo es obligatorio',
    password: 'Contraseña',
    passwordRequired: 'La contraseña es obligatoria',
    forgotPassword: '¿Olvidaste tu contraseña?',
    signInFailed: 'Error al iniciar sesión',
    signIn: 'Iniciar sesión',
    invalidSubdomain: 'Ingresa un subdominio de cuenta válido',
    invalidCredentials: 'Correo o contraseña incorrectos',
    csrfFailed: 'Falló la verificación de seguridad al iniciar sesión. Cierra y vuelve a abrir la app e inténtalo de nuevo.',
    csrfDesktopFailed: 'La app de escritorio no pudo preparar un token seguro para iniciar sesión. Reinicia la app o borra las cookies de esta cuenta e inténtalo de nuevo.',
    signUpPrompt: '¿Nuevo en Blu? ',
    signUpLink: 'Regístrate en nuestro sitio web',
    kdsSetup: 'Configuración de pantalla de cocina'
  },
  staffPassword: {
    required: 'La contraseña es obligatoria',
    minLength: 'La contraseña debe tener al menos 8 caracteres',
    uppercase: 'La contraseña debe tener al menos una mayúscula',
    lowercase: 'La contraseña debe tener al menos una minúscula',
    number: 'La contraseña debe tener al menos un número'
  },
  forgotPassword: {
    title: 'Olvidé mi contraseña',
    subtitle: 'Ingresa tu correo para restablecer tu contraseña',
    emailRequired: 'El correo es obligatorio',
    emailInvalid: 'Ingresa un correo válido',
    sendFailed: 'No se pudo enviar el enlace',
    checkEmail: 'Revisa tu correo',
    successMessage: 'Las instrucciones para restablecer tu contraseña han sido enviadas a tu correo',
    sendResetLink: 'Enviar enlace',
    backToLogin: 'Volver al inicio de sesión',
    failedGeneric: 'No se pudieron enviar las instrucciones. Intenta de nuevo.'
  },
  resetPassword: {
    tokenMissing: 'Falta el token de restablecimiento',
    emailMissing: 'El enlace no es válido o está incompleto. Solicita un nuevo correo de restablecimiento.',
    title: 'Restablecer contraseña',
    subtitle: 'Ingresa tu nueva contraseña',
    newPassword: 'Nueva contraseña',
    confirmPassword: 'Confirmar contraseña',
    passwordRequired: 'La contraseña es obligatoria',
    passwordMinLength: 'La contraseña debe tener al menos 8 caracteres',
    passwordUppercase: 'La contraseña debe tener al menos una mayúscula',
    passwordLowercase: 'La contraseña debe tener al menos una minúscula',
    passwordNumber: 'La contraseña debe tener al menos un número',
    confirmRequired: 'Confirma tu contraseña',
    passwordsNoMatch: 'Las contraseñas no coinciden',
    resetFailed: 'No se pudo restablecer la contraseña',
    resetButton: 'Restablecer contraseña',
    successNotify: 'La contraseña se restableció correctamente',
    failedGeneric: 'No se pudo restablecer la contraseña. Intenta de nuevo.'
  },
  setPassword: {
    title: 'Establecer contraseña',
    subtitle: 'Establece una nueva contraseña para tu cuenta',
    newPassword: 'Nueva contraseña',
    confirmPassword: 'Confirmar contraseña',
    passwordRequired: 'La contraseña es obligatoria',
    passwordMinLength: 'La contraseña debe tener al menos 8 caracteres',
    passwordUppercase: 'La contraseña debe tener al menos una mayúscula',
    passwordLowercase: 'La contraseña debe tener al menos una minúscula',
    passwordNumber: 'La contraseña debe tener al menos un número',
    confirmRequired: 'Confirma tu contraseña',
    passwordsNoMatch: 'Las contraseñas no coinciden',
    setFailed: 'No se pudo establecer la contraseña',
    setButton: 'Establecer contraseña',
    failedGeneric: 'No se pudo establecer la contraseña. Intenta de nuevo.'
  },
  layout: {
    offline: 'Estás sin conexión',
    offlineMessage: 'Este dispositivo no tiene conexión a internet. Blu muestra datos en caché; algunas acciones están deshabilitadas hasta que vuelvas a conectarte.',
    offlineNetwork: 'Red: {type}',
    terminalReady: 'Terminal listo',
    terminalIssue: 'Problema con terminal',
    terminalLoading: 'Cargando...',
    terminalNoStatus: 'Sin estado de terminal',
    terminalNoRegister: 'Sin registro',
    terminalNoTerminal: 'Sin terminal',
    terminalRefreshTitle: 'Haz clic para actualizar el estado de conexión del terminal',
    registerManageTitle: 'Haz clic para gestionar el registro',
    sessionInfo: 'Información de sesión',
    sessionId: 'ID de sesión',
    user: 'Usuario',
    name: 'Nombre',
    email: 'Correo electrónico',
    id: 'ID',
    authentication: 'Autenticación',
    status: 'Estado',
    authenticated: 'Autenticado',
    notAuthenticated: 'No autenticado',
    token: 'Token',
    present: 'Presente',
    none: 'Ninguno',
    currentLocation: 'Ubicación actual',
    currentRegister: 'Registro actual',
    address: 'Dirección',
    open: 'Abierto',
    closed: 'Cerrado',
    loading: 'Cargando',
    yes: 'Sí',
    no: 'No',
    registerCount: 'Cantidad de registros',
    openRegisters: 'Registros abiertos',
    cookies: 'Cookies',
    totalCookies: 'Total de cookies',
    cookieData: 'Datos de cookies',
    noCookiesFound: 'No se encontraron cookies',
    serverResponse: 'Respuesta del servidor',
    origin: 'Origen',
    cookiesReceived: 'Cookies recibidas',
    lastUpdated: 'Última actualización',
    refreshSession: 'Actualizar sesión',
    refreshRegisters: 'Actualizar registros',
    close: 'Cerrar',
    runtimeEnvironment: 'Entorno de ejecución',
    runtimeEnvironmentHint: 'Valores de compilación desde .env / quasar.config.js. Reinicia quasar dev tras cambiar .env.',
    dejavooTopNativeDiagnostics: 'Tap to Pay en iPhone (nativo)',
    dejavooTopNativeDiagnosticsHint: 'Environment resuelto en Info.plist para IposgoSDK (UAT vs PROD). Compáralo con el entorno de la API en el asistente o PoC Dejavoo.',
    clickViewSession: 'Haz clic para ver detalles de la sesión',
    refreshSessionInfo: 'Actualizar información de sesión',
    orderAheadPickup: 'Cola de recogida',
    storeOrderPickup: 'Pedidos de recogida en tienda',
    orderAheadOpenFull: 'Pantalla completa',
    desktopUpdate: {
      updateNow: 'Actualizar ahora',
      restartToUpdate: 'Reiniciar para actualizar',
      downloading: 'Descargando actualización ({percent}%)',
      checking: 'Buscando actualizaciones…',
      versionAvailable: 'La versión {version} está disponible',
      latest: 'Está usando la última versión de escritorio.',
      notPackaged: 'Las actualizaciones solo están disponibles en la aplicación de escritorio instalada.',
      checkFailed: 'No se pudo buscar actualizaciones: {msg}',
      checkTimedOut: 'La búsqueda de actualizaciones expiró. Inténtelo de nuevo.',
      downloadFailed: 'Falló la descarga de la actualización: {msg}',
      installFailed: 'No se pudo instalar la actualización: {msg}',
      error: 'Error de actualización: {msg}'
    },
    userMenu: 'Cuenta',
    support: 'Soporte',
    roles: {
      owner: 'Propietario',
      manager: 'Gerente',
      cashier: 'Cajero',
      inventory_clerk: 'Encargado de inventario',
      accountant: 'Contador'
    }
  },
  settings: {
    title: 'Configuración',
    subtitle: 'Gestiona la configuración del negocio, equipos, lealtad y preferencias de cuenta',
    version: 'Blu versión {version}',
    deviceIdentityLabel: 'Este dispositivo',
    runtimeEnv: {
      development: 'Desarrollo',
      staging: 'Pruebas',
      production: 'Producción'
    },
    checkForUpdates: 'Buscar actualizaciones',
    open: 'Abrir',
    businessInfo: 'Información del negocio',
    businessInfoDesc: 'Marca, dirección y preferencias',
    locations: 'Ubicaciones',
    locationsDesc: 'Gestiona ubicaciones de tiendas y predeterminados',
    taxes: 'Impuestos',
    taxesDesc: 'Gestiona reglas de impuestos por ubicación y vista previa de resultados',
    integrations: 'Integraciones',
    integrationsDesc: 'Conecta lealtad, pagos y aplicaciones de terceros',
    paymentProcessing: 'Procesamiento de pagos',
    paymentProcessingDesc: 'Gestiona la configuración del procesador de pagos',
    iphoneTopTapToPay: 'Tap to Pay en iPhone',
    iphoneTopTapToPayDesc: 'Configuración única para aceptar pagos sin contacto en este iPhone',
    equipment: 'Equipos',
    equipmentDesc: 'Gestiona terminales de pago y hardware',
    equipmentCustomerDisplay: 'Pantalla para el cliente',
    equipmentCustomerDisplayDesc: 'Refleja el carrito en una segunda pantalla (Android o escritorio Windows)',
    equipmentReceiptPrinter: 'Impresora de recibos',
    equipmentReceiptPrinterDesc: 'Impresora térmica Volcora USB y cajón monedero (app de escritorio Windows)',
    receiptPrinterPageTitle: 'Impresora de recibos',
    receiptPrinterPageSubtitle: 'Recibo térmico Volcora y cajón monedero (SDK o ESC/POS de Windows)',
    receiptPrinterWindowsOnly: 'La integración de la impresora de recibos solo está disponible en la aplicación de Windows.',
    receiptPrinterDllMissing: 'No se encontró POS_SDK.dll. Cópielo del SDK de Volcora en la carpeta de recursos de la app (vea src-electron/resources/volcora/README.txt) y vuelva a compilar.',
    receiptPrinterConfigHeading: 'Configuración',
    receiptPrinterEnableVolcora: 'Imprimir recibos con impresora térmica Volcora',
    receiptPrinterEnableHint:
      'Si está desactivado, la caja usa la impresión normal del sistema. Si está activado, las ventas finalizadas pueden imprimirse en la impresora térmica configurada en la app de Windows.',
    receiptPrinterDriverMode: 'Controlador / transporte',
    receiptPrinterDriverSdk: 'SDK Volcora (50020X USB)',
    receiptPrinterDriverEscpos: 'ESC/POS de Windows (V-WRP-A1 / V-WLRP-A1)',
    receiptPrinterWindowsName: 'Impresora de Windows',
    receiptPrinterWindowsNameManual: 'Nombre de impresora (manual)',
    receiptPrinterWindowsNameHint: 'Nombre exacto en Configuración → Impresoras y escáneres',
    receiptPrinterWindowsDefault: 'predeterminada',
    receiptPrinterUsbName: 'Nombre del puerto USB',
    receiptPrinterUsbNameHint:
      'El ejemplo VC de Volcora usa SP-USB1 para USB. Pruebe también SP-USB001 o el valor de la herramienta/controlador Volcora.',
    receiptPrinterPaperWidth: 'Ancho del papel',
    receiptPrinterPaper80: '80 mm',
    receiptPrinterPaper58: '58 mm',
    receiptPrinterCutType: 'Tipo de corte',
    receiptPrinterCutPartial: 'Corte parcial',
    receiptPrinterCutFull: 'Corte total',
    receiptPrinterFeedLines: 'Líneas de avance antes del corte',
    receiptPrinterDrawerHeading: 'Cajón monedero',
    receiptPrinterDrawerEnable: 'Activar cajón monedero (RJ11 vía impresora)',
    receiptPrinterDrawerAutoCash: 'Abrir automáticamente en ventas en efectivo',
    receiptPrinterDrawerConnector: 'Conector del cajón',
    receiptPrinterDrawerPin1: 'Cajón 1',
    receiptPrinterDrawerPin2: 'Cajón 2',
    receiptPrinterDrawerBoth: 'Ambos cajones',
    receiptPrinterDrawerTime1: 'Pulso de apertura (×2 ms, 0–255)',
    receiptPrinterDrawerTime2: 'Pulso de cierre (×2 ms, 0–255)',
    receiptPrinterActionsHeading: 'Acciones',
    receiptPrinterSave: 'Guardar',
    receiptPrinterSaved: 'Configuración de la impresora guardada',
    receiptPrinterSaveFailed: 'No se pudo guardar la configuración',
    receiptPrinterStorageUnavailable: 'El almacenamiento local no está disponible en este entorno.',
    receiptPrinterTestSdk: 'Imprimir página de prueba del SDK',
    receiptPrinterTestThermal: 'Imprimir recibo de prueba',
    receiptPrinterOpenDrawer: 'Abrir cajón monedero',
    receiptPrinterCheckPaper: 'Comprobar estado del papel',
    receiptPrinterTestOk: 'Comando de impresora completado',
    receiptPrinterTestFailed: 'Comando de impresora falló',
    receiptPrinterDrawerOk: 'Comando del cajón enviado',
    receiptPrinterDrawerFailed: 'Comando del cajón falló',
    receiptPrinterPaperOk: 'Estado del papel: OK (hay papel)',
    receiptPrinterPaperLow: 'Estado del papel: casi agotado (casi al final)',
    receiptPrinterPaperOut: 'Estado del papel: agotado o bajo',
    receiptPrinterPaperStatusCode: 'Estado del papel: la impresora devolvió el código {code}',
    receiptPrinterPaperUnknown: 'No se pudo leer el estado del papel',
    receiptPrinterBidirectionalFailed:
      'No se pudo leer el estado del papel (E/S bidireccional). Use Diagnósticos o active soporte bidireccional en el puerto de la impresora.',
    receiptPrinterDiagOpen: 'Diagnósticos',
    receiptPrinterDiagTitle: 'Diagnósticos de impresora',
    receiptPrinterDiagConnection: 'Conexión',
    receiptPrinterDiagRefreshPrinters: 'Actualizar lista de impresoras',
    receiptPrinterDiagCopyLog: 'Copiar registro',
    receiptPrinterDiagCopied: 'Registro de diagnóstico copiado',
    receiptPrinterDiagCopyFailed: 'No se pudo copiar el registro',
    receiptPrinterDiagPrintTests: 'Pruebas de impresión',
    receiptPrinterDiagDrawerTests: 'Pruebas de cajón',
    receiptPrinterDiagStatusTests: 'Pruebas de estado',
    receiptPrinterDiagLog: 'Registro de diagnóstico',
    receiptPrinterDiagLogEmpty: 'Ejecute una prueba para llenar el registro.',
    receiptPrinterDiagAlign: 'Muestra de alineación',
    receiptPrinterDiagFonts: 'Muestra de estilos',
    receiptPrinterDiagLogo: 'Muestra de logo BMP',
    receiptPrinterDiagQr: 'Muestra de código QR',
    receiptPrinterDiagCutPartial: 'Prueba de corte (parcial)',
    receiptPrinterDiagCutFull: 'Prueba de corte (alternativo)',
    receiptPrinterDiagFeed: 'Solo avance',
    receiptPrinterDiagStatusPaper: 'DLE EOT papel (n=4)',
    receiptPrinterDiagStatusOffline: 'DLE EOT fuera de línea (n=2)',
    receiptPrinterDiagStatusPrinter: 'DLE EOT impresora (n=1)',
    receiptPrinterDiagStatusError: 'DLE EOT error (n=3)',
    receiptPrinterDiagStatusSdk: 'Estado del papel SDK',
    receiptPrinterDocsNote:
      'El modo SDK requiere POS_SDK.dll (50020X). El modo ESC/POS usa el controlador de Windows y no necesita la DLL.',
    receiptPrinterLblPhone: 'Teléfono',
    receiptPrinterLblTaxId: 'ID fiscal',
    receiptPrinterLblDate: 'Fecha',
    receiptPrinterLblSale: 'Venta',
    receiptPrinterLblCashier: 'Cajero',
    receiptPrinterLblCustomer: 'Cliente',
    receiptPrinterLblUnknownProduct: 'Artículo',
    receiptPrinterLblLineTotal: 'Línea',
    receiptPrinterLblSubtotal: 'Subtotal',
    receiptPrinterLblDiscount: 'Descuento',
    receiptPrinterLblAfterDiscount: 'Tras descuento',
    receiptPrinterLblTax: 'Impuesto',
    receiptPrinterLblTip: 'Propina',
    receiptPrinterLblFee: 'Cargo',
    receiptPrinterLblTotal: 'TOTAL',
    receiptPrinterLblPayments: 'Pagos',
    receiptPrinterLblReceived: 'Recibido',
    receiptPrinterLblChange: 'Cambio',
    receiptPrinterLblPaymentApproved: 'APROBADO',
    receiptPrinterLblPaymentDeclined: 'RECHAZADO',
    receiptPrinterLblAuthShort: 'Aut',
    receiptPrinterLblRefShort: 'Ref',
    receiptPrinterLblEntryModeChip: 'Chip',
    receiptPrinterLblEntryModeContactless: 'Sin contacto',
    receiptPrinterLblEntryModeSwipe: 'Deslizar',
    receiptPrinterLblEntryModeManual: 'Manual',
    receiptPrinterLblEntryModeKeyed: 'Teclado',
    receiptPrinterLblEntryModeUnknown: 'Tarjeta',
    receiptPrinterLblThankYou: '¡Gracias!',
    receiptPrinterLblTestBanner: 'Blu POS - prueba de impresora',
    receiptPrinterLblTestFooter: 'Fin de prueba',
    receiptPrinterLblPortOk: 'Puerto OK',
    customerDisplayPageTitle: 'Pantalla para el cliente',
    customerDisplayPageSubtitle: 'Para tabletas POS con Android o escritorio Windows con monitor para el cliente',
    customerDisplayHardwareType: 'Tipo de hardware',
    customerDisplayHardwareGeneric: 'Android genérico (HDMI / USB‑C / pantalla extendida)',
    customerDisplayHardwareSunmi: 'Sunmi (pantalla secundaria / API Presentation)',
    customerDisplayHardwareHint:
      'En dispositivos Sunmi de doble pantalla suele hacer falta el modo Presentation para que la pantalla del cliente muestre su propio contenido en lugar de duplicar la interfaz del cajero.',
    customerDisplayHardwareWindows: 'Windows - escritorio extendido (segundo monitor)',
    customerDisplayHardwareHintWindows:
      'Blu abre una ventana dedicada en el monitor secundario. Amplíe el escritorio en la configuración de pantalla de Windows (Win + P) para que se detecte la pantalla del cliente.',
    customerDisplayEnable: 'Activar pantalla para el cliente',
    customerDisplayEnableHint:
      'Si está activada y hay una segunda pantalla, el mostrador refleja el carrito y los totales para el cliente. Funciona en la app Android o en la app de escritorio Windows.',
    customerDisplayStatusHeading: 'Estado de la pantalla',
    customerDisplayStatusEnabled: 'Función activada en la app',
    customerDisplayStatusDisabled: 'Función desactivada',
    customerDisplayStatusSecondary: 'Pantallas secundarias detectadas: {count}',
    customerDisplayStatusPresentation: 'Pantallas de presentación: {count}',
    customerDisplayStatusTouch: 'Pantalla del cliente con tacto: {value}',
    customerDisplayStatusWindow: 'Ventana de pantalla del cliente abierta: {value}',
    customerDisplayStatusUnavailable:
      'Use la app Android o la de escritorio Windows para conectar una pantalla del cliente. Esta sesión del navegador no puede controlar la segunda pantalla.',
    customerDisplayPlatformNote:
      'Conecte la pantalla del cliente antes de abrir el mostrador. Desactívela en Equipos cuando no se use.',
    customerDisplayMirrorIdle: 'Sus artículos aparecerán aquí.',
    customerDisplayMirrorThankYou: '¡Gracias!',
    customerDisplayMirrorReceiptEmail: 'Recibo por correo',
    customerDisplayMirrorReceiptSms: 'Recibo por SMS',
    customerDisplayMirrorReceiptPrint: 'Imprimir recibo',
    customerDisplayMirrorReceiptNone: 'Sin recibo',
    customerDisplayMirrorReceiptPrompt: '¿Cómo desea su recibo?',
    customerDisplayMirrorProcessing: 'Enviando…',
    customerDisplayMirrorError: 'No se pudo completar la solicitud.',
    customerDisplayMirrorTryAgain: 'Intentar de nuevo',
    customerDisplayMirrorQtyEach: '{qty} × {price}',
    loyalty: 'Lealtad',
    loyaltyDesc: 'Configura tasas de ganancia y modelo de canje',
    intakeForm: 'Formulario de admisión',
    intakeFormDesc: 'Formulario de contacto para su sitio web y bandeja de prospectos',
    intakeFormPreview: 'Vista previa',
    intakeFormBack: 'Volver a configuración',
    intakeFormEnable: 'Activar formulario de admisión',
    intakeFormShowProducts: 'Mostrar selección de producto en el formulario',
    intakeFormShowProductsHint: 'Cuando está activo, los clientes pueden elegir un producto o servicio en el formulario',
    intakeFormScopeAll: 'Todos los productos',
    intakeFormScopeSpecific: 'Productos específicos',
    intakeFormAllProductsHint: 'Todos los productos estarán disponibles para selección.',
    intakeFormProductsLabel: 'Productos a mostrar',
    intakeFormProductsHint: 'Busque y seleccione productos para ofrecer en el formulario',
    intakeFormTitle: 'Título del formulario (opcional)',
    intakeFormTitleHint: 'Título personalizado sobre el formulario',
    intakeFormSuccessMessage: 'Mensaje de éxito (opcional)',
    intakeFormSuccessMessageHint: 'Mensaje mostrado tras el envío exitoso',
    intakeFormAddressCollection: 'Recolección de dirección',
    intakeFormAddressCollectionHint: 'Si se solicita dirección a los visitantes',
    intakeFormAddressNone: 'No solicitar',
    intakeFormAddressOptional: 'Opcional',
    intakeFormAddressRequired: 'Obligatoria',
    intakeFormEmbedTitle: 'Código para su sitio web',
    intakeFormCopyEmbed: 'Copiar',
    intakeFormSaved: 'Configuración guardada',
    intakeFormSaveFailed: 'Error al guardar la configuración',
    intakeFormLoadFailed: 'Error al cargar la configuración',
    intakeFormEmbedCopied: 'Código copiado',
    intakeFormEmbedCopyFailed: 'Error al copiar',
    onlineStore: 'Pedidos anticipados',
    onlineStoreDesc: 'Menú público y pago para recoger (cafés, food trucks, servicio rápido)',
    ecomEnable: 'Activar menú de pedidos anticipados',
    ecomEnableHint:
      'Activa el menú y el pago para clientes. También active la cola de pedidos anticipados en Información del negocio para que el personal vea la cola de recogida. El acceso de clientes a facturas y tabs no cambia.',
    ecomStoreTitle: 'Título del menú',
    ecomTagline: 'Eslogan',
    ecomCheckoutNotice: 'Mensaje en el pago (antes de elegir hora de recogida)',
    ecomPreviewShop: 'Vista previa del menú',
    ecomSaved: 'Configuración de pedidos anticipados guardada',
    ecomSaveFailed: 'No se pudo guardar la configuración de pedidos anticipados',
    retailStore: 'Blu Store',
    retailStoreDesc: 'Tienda en línea para productos — catálogo, carrito y envío o recogida',
    storeEnable: 'Activar Blu Store',
    storeThemePreset: 'Tema predefinido',
    storePreview: 'Vista previa de la tienda',
    storeSaved: 'Configuración de Blu Store guardada',
    storeSaveFailed: 'No se pudo guardar la configuración de Blu Store',
    storePublicUrlHint: 'Cuando está activa y publicada, los clientes acceden a su tienda desde la dirección web de su negocio.',
    storeHomepageSections: 'Secciones de inicio',
    storeHomepageSectionsHint: 'Las secciones aparecen en orden en la página de inicio (cuando no hay búsqueda).',
    storeSectionAdd: 'Añadir sección',
    storeSectionHero: 'Hero',
    storeSectionFeatured: 'Productos destacados',
    storeSectionProductCarousel: 'Carrusel de productos',
    storeSectionFeaturedCollections: 'Colecciones destacadas',
    storeSectionImageText: 'Imagen + texto',
    storeSectionRichText: 'Texto enriquecido',
    storeSectionFaqAccordion: 'Preguntas frecuentes',
    storeSectionImageRow: 'Fila de imágenes',
    storeSectionProductDetails: 'Detalles del producto',
    storeThemeClassic: 'Clásico',
    storeThemeBayou: 'Bayou (cálido, redondeado)',
    storeThemeStudio: 'Studio (minimalista)',
    storeSectionCollectionSlugs: 'Colecciones',
    storeSectionImageTextBody: 'Cuerpo (HTML)',
    storeSectionImageSide: 'Lado de la imagen',
    storeSectionHeroTitle: 'Titular',
    storeSectionHeroSubtitle: 'Subtítulo',
    storeSectionBlockTitle: 'Título de sección',
    storeSectionFeaturedProducts: 'Productos',
    storeSectionRichTextBody: 'Cuerpo (HTML)',
    storeSectionRichTextBodyHint: 'HTML básico: p, strong, em, listas, enlaces',
    storeSectionFaqQuestion: 'Pregunta',
    storeSectionFaqAnswer: 'Respuesta (HTML)',
    storeSectionFaqAddItem: 'Agregar pregunta',
    storeSectionFaqRemoveItem: 'Eliminar',
    storeSectionImageUrl: 'URL de imagen',
    storeSectionImageAlt: 'Texto alternativo',
    storeSectionImageLink: 'Enlace (opcional)',
    storeSectionAddImage: 'Añadir imagen',
    storeSeo: 'SEO de la tienda',
    storeSeoTitle: 'Título de inicio',
    storeSeoDescription: 'Descripción de inicio',
    storeCheckoutShipping: 'Envío en checkout (piloto)',
    storeCheckoutShippingHint: 'Tarifa plana opcional en el checkout de Blu Store. Tarifas de transportistas en vivo aún no están disponibles.',
    storeCheckoutShippingEnabled: 'Ofrecer envío a domicilio en checkout',
    storeCheckoutFlatRate: 'Tarifa plana de envío ($)',
    storeCheckoutFreeShippingThreshold: 'Umbral de envío gratis ($, opcional)',
    storeIndexableFacetAxes: 'Filtros de catálogo indexables (SEO)',
    storeIndexableFacetAxesHint:
      'Las URLs de la tienda con un solo filtro de estas opciones pueden indexarse en buscadores. Otras combinaciones siguen siendo compartibles pero usan noindex.',
    storeIndexableFacetAxisSize: 'Talla',
    storeIndexableFacetAxisColor: 'Color',
    storeIndexableFacetAxisCategory: 'Categoría',
    storeIndexableFacetAxisBrand: 'Marca',
    storeMerchandisedCollections: 'Colecciones manuales',
    storeMerchandisedCollectionsHint:
      'Listas de productos curadas para su tienda (p. ej. Favoritos del equipo). Cada colección tiene su propio enlace para compartir. Si el slug coincide con una categoría, la colección tiene prioridad.',
    storeMerchandisedCollectionTitle: 'Título visible',
    storeMerchandisedCollectionSlug: 'Slug de URL',
    storeMerchandisedCollectionSlugHint: 'Minúsculas, números y guiones (p. ej. staff-picks).',
    storeMerchandisedCollectionImage: 'URL de imagen de portada (opcional)',
    storeMerchandisedCollectionProducts: 'Productos',
    storeMerchandisedCollectionAdd: 'Añadir colección',
    storeMerchandisedCollectionRemove: 'Eliminar',
    storeMerchandisedCollectionUntitled: 'Colección {n}',
    storeMerchandisedCollectionMax: 'Máximo {max} colecciones.',
    storeMerchandisedCollectionIncomplete:
      'Cada colección manual necesita título, slug y al menos un producto visible en la tienda.',
    storePolicyPages: 'Páginas de políticas',
    storePolicyPagesHint:
      'Páginas de envíos, devoluciones, privacidad y términos de su tienda. Publique desde el editor visual cuando esté listo para los clientes.',
    storePolicyPageTitle: 'Título de la página',
    storePolicyPageBody: 'Cuerpo (HTML)',
    storePolicyPageBodyHint: 'Solo HTML básico (párrafos, listas, enlaces, encabezados). Sin scripts.',
    storePolicyPageSlug: {
      shipping: 'Política de envíos',
      returns: 'Política de devoluciones',
      privacy: 'Política de privacidad',
      terms: 'Términos del servicio',
    },
    storeUrlRedirects: 'Redirecciones URL',
    storeUrlRedirectsHint: 'Mapea rutas heredadas (p. ej. Shopify /products/handle) a URLs de Blu Store.',
    storeRedirectFrom: 'Ruta origen',
    storeRedirectTo: 'Ruta destino',
    storeRedirectStatus: 'Estado',
    storeRedirectAdd: 'Añadir redirección',
    storeBulkImportHint: '¿Necesita migrar un catálogo grande desde Shopify u otra plataforma? Contacte al soporte de Blu para importación asistida.',
    paymentTerms: 'Términos de pago',
    paymentTermsDesc: 'Gestiona términos de pago de facturas y predeterminados',
    tabs: 'Tabs',
    tabsDesc: 'Configura tabs de house y bar',
    tabsHousePanelTitle: 'House tabs',
    tabsHousePanelDesc: 'Tabs AR de clientes y grupos, modo house en caja y el ítem Tabs en la navegación.',
    tabsHouseEnable: 'Activar house tabs',
    tabsBarPanelTitle: 'Bar tabs',
    tabsBarPanelDesc: 'Tabs bar para walk-in y clientes en caja, incluida la verificación de tarjeta.',
    tabsBarEnable: 'Activar bar tabs',
    tabsSaved: 'Configuración de tabs guardada',
    tabsSaveFailed: 'No se pudo guardar la configuración de tabs',
    invoices: 'Facturas',
    invoicesDesc: 'Valores predeterminados de estimaciones y términos de pago',
    booking: 'Reservas',
    bookingDesc: 'Reservas en línea, depósitos, widget web y enlace con la caja',
    rentals: 'Alquileres',
    rentalsDesc: 'Políticas, edificios, unidades y facturación de alquileres',
    scheduling: 'Agenda',
    schedulingDesc: 'Herramientas de agenda anteriores (use Reservas cuando esté disponible)',
    invoicesEstimatesPanelTitle: 'Estimaciones',
    invoicesEstimatesPanelDesc: 'Comportamiento predeterminado al crear nuevas estimaciones.',
    invoicesPortalPanelTitle: 'Portal de pago',
    invoicesPortalPanelDesc: 'Opciones para enlaces de pago de facturas.',
    invoicePortalTippingEnabled: 'Permitir propinas en enlaces de pago de facturas',
    customerAcceptanceGate: 'Aceptación del cliente requerida',
    customerAcceptanceGateHint: 'Indique cuándo el cliente debe aprobar o firmar antes de emitir o cobrar.',
    customerAcceptanceGateNone: 'Ninguna',
    customerAcceptanceGateEstimate: 'En la cotización (antes de emitir factura)',
    customerAcceptanceGateInvoice: 'En la factura (antes del pago)',
    requireCustomerSignature: 'Requerir firma del cliente cuando la aceptación esté activa',
    estimateDefaultValidityDays: 'Validez predeterminada de cotización (días)',
    estimateDefaultValidityDaysHint: 'Deje en blanco para no vencer automáticamente.',
    invoiceRemindersPanelTitle: 'Recordatorios de pago',
    invoiceRemindersPanelDesc: 'Recordatorios automáticos por correo para facturas impagas.',
    invoiceRemindersEnabled: 'Enviar recordatorios automáticos',
    invoiceRemindersEmail: 'Correo',
    invoiceRemindersIntervalDays: 'Días mínimos entre recordatorios',
    invoiceRemindersMax: 'Máximo de recordatorios por factura',
    invoiceRemindersOnlyOverdue: 'Solo cuando esté vencida',
    invoiceLabelsTitle: 'Etiquetas de factura',
    invoiceLabelsDesc: 'Cree etiquetas opcionales para organizar y filtrar facturas.',
    invoiceLabelsEmpty: 'Aún no hay etiquetas.',
    invoiceLabelsAdd: 'Agregar etiqueta',
    invoiceLabelsEdit: 'Editar etiqueta',
    invoiceLabelsName: 'Nombre',
    invoiceLabelsColor: 'Color',
    invoiceLabelsIcon: 'Icono',
    invoiceLabelsIconPlaceholder: 'Elegir un icono',
    invoiceLabelsIconNoMatch: 'Sin iconos coincidentes',
    invoiceLabelsNameRequired: 'El nombre es obligatorio',
    invoiceLabelIcons: {
      tag: 'Etiqueta',
      folder: 'Carpeta',
      install: 'Instalación / servicio',
      repair: 'Reparación',
      warranty: 'Garantía',
      retail: 'Retail / revendedor',
      delivery: 'Entrega',
      project: 'Proyecto',
      plumbing: 'Plomería',
      electrical: 'Eléctrico',
      hvac: 'HVAC',
      water: 'Agua',
      residential: 'Residencial',
      commercial: 'Comercial',
      priority: 'Prioridad',
      construction: 'Construcción'
    },
    invoiceLabelsSaved: 'Etiqueta guardada',
    invoiceLabelsSaveFailed: 'No se pudo guardar la etiqueta',
    invoiceLabelsLoadFailed: 'No se pudieron cargar las etiquetas',
    invoiceLabelsDeleteTitle: '¿Eliminar etiqueta?',
    invoiceLabelsDeleteMessage: '¿Eliminar “{name}”? Se desvinculará de las facturas.',
    invoiceLabelsArchived: 'Etiqueta eliminada',
    invoiceLabelsArchiveFailed: 'No se pudo eliminar la etiqueta',
    invoicesSaved: 'Configuración de facturas guardada',
    invoicesSaveFailed: 'No se pudo guardar la configuración de facturas',
    paymentTermsPanelTitle: 'Términos de pago',
    paymentTermsNew: 'Nuevos términos',
    paymentTermsEdit: 'Editar términos',
    paymentTermsName: 'Nombre',
    paymentTermsDays: 'Días',
    paymentTermsDefault: 'Predeterminado',
    paymentTermsSaveFailed: 'No se pudieron guardar los términos de pago',
    paymentTermsDeleteTitle: '¿Eliminar términos de pago?',
    paymentTermsDeleteMessage: '¿Eliminar "{name}"? Esta acción no se puede deshacer.',
    paymentTermsDeleteFailed: 'No se pudieron eliminar los términos de pago',
    userManagement: 'Gestión de usuarios',
    userManagementDesc: 'Invita al equipo y asigna roles',
    profile: 'Perfil',
    profileDesc: 'Actualiza tu nombre, correo y contraseña',
    updateAvailable: 'Hay una nueva versión de Blu disponible.',
    updateCurrentLatest: 'Actual: {current} · Última: {latest}',
    reloadNow: 'Recargar ahora',
    later: 'Después',
    latestVersion: 'Estás usando la última versión de Blu.',
    versionLabel: 'Versión {version}',
    updateCheckFailed: 'Error al buscar actualizaciones. Intenta de nuevo.'
  },
  customers: {
    title: 'Clientes',
    subtitle: 'Gestiona perfiles de clientes y lealtad',
    manageGroups: 'Gestionar grupos',
    exportCsv: 'Exportar CSV',
    comingSoon: 'Próximamente',
    newCustomer: 'Nuevo cliente',
    loadFailed: 'No se pudieron cargar los clientes',
    customerUpdated: 'Cliente actualizado correctamente',
    customerCreated: 'Cliente creado correctamente',
    saveFailed: 'Error al guardar el cliente',
    emailInUseHint: 'Ese correo pertenece a otro cliente. Fusione perfiles o elija otro correo.',
    merge: {
      action: 'Fusionar cliente',
      title: 'Fusionar otro cliente en este perfil',
      subtitle: 'Mueva historial, correos y acceso del portal desde un perfil duplicado. El otro perfil se archivará.',
      sourceLabel: 'Cliente a fusionar',
      confirm: 'Fusionar perfiles',
      success: 'Clientes fusionados correctamente',
      failed: 'No se pudieron fusionar los clientes'
    },
    astroLinked: 'Vinculado a Astro',
    astroUnlinked: 'Desvinculado de Astro',
    retry: 'Reintentar',
    search: 'Buscar',
    searchPlaceholder: 'Nombre, correo, teléfono, ciudad...',
    searchHint: 'Búsqueda en servidor (coincide con resultados del backend)',
    hasEmail: 'Tiene correo',
    hasPhone: 'Tiene teléfono',
    minLoyalty: 'Mín. lealtad',
    pts: 'pts',
    apply: 'Aplicar',
    clear: 'Limpiar',
    noCustomers: 'No se encontraron clientes.',
    editCustomer: 'Editar cliente',
    loyaltyHistory: 'Historial de lealtad',
    openInAstro: 'Abrir en Astro',
    deleteCustomer: 'Archivar cliente',
    editCustomerTitle: 'Editar cliente',
    newCustomerTitle: 'Nuevo cliente',
    editCustomerSubtitle: 'Actualizar perfil, información de contacto y notas',
    newCustomerSubtitle: 'Crear un perfil de cliente para facturas y lealtad',
    basicInfo: 'Información básica',
    addressInfo: 'Información de dirección',
    contactInfo: 'Información de contacto',
    schedulingAppointments: 'Citas',
    schedulingAppointmentsEmpty: 'Sin citas recientes.',
    firstName: 'Nombre',
    lastName: 'Apellido',
    suffix: 'Sufijo',
    suffixPlaceholder: 'ej., Jr., Sr., III',
    taxId: 'ID fiscal',
    firstNameRequired: 'El nombre es obligatorio',
    lastNameRequired: 'El apellido es obligatorio',
    stateProvince: 'Estado/Provincia',
    notes: 'Notas',
    additionalInfo: 'Información adicional',
    astro: 'Astro',
    astroCustomerId: 'ID de cliente Astro',
    astroLinkPlaceholder: 'Ingresa ID de Astro para vincular',
    link: 'Vincular',
    unlink: 'Desvincular',
    confirmDelete: 'Confirmar archivo',
    confirmDeleteMessage: '¿Archivar a {name}? Los clientes archivados se ocultan de las listas pero permanecen en ventas e facturas históricas.',
    deleted: 'Cliente archivado correctamente',
    deleteFailed: 'Error al archivar el cliente',
    moreActions: 'Más acciones',
    restoreArchivedCustomers: 'Restaurar clientes archivados',
    restoreModeTitle: 'Clientes archivados',
    restoreModeSubtitle: 'Revise clientes archivados y restáurelos a la lista activa',
    backToCustomers: 'Volver a clientes',
    archivedAt: 'Archivado',
    archivedBy: 'Archivado por',
    noArchivedCustomers: 'No se encontraron clientes archivados.',
    restoreCustomer: 'Restaurar cliente',
    confirmRestore: 'Confirmar restauración',
    confirmRestoreMessage: '¿Restaurar a {name} en la lista activa de clientes?',
    restored: 'Cliente restaurado correctamente',
    restoreFailed: 'Error al restaurar el cliente',
    currentBalance: 'Saldo actual',
    pointsAvailable: 'Puntos disponibles',
    totalPointsEarned: 'Total de puntos ganados',
    cashRedemptions: 'Canjes en efectivo',
    productRedemptions: 'Canjes de productos',
    transactionHistory: 'Historial de transacciones',
    noLoyaltyTransactions: 'No se encontraron transacciones de lealtad',
    loyaltyLoadFailed: 'Error al cargar el historial de lealtad',
    tableName: 'Nombre',
    tablePhoto: 'Foto',
    tableContactInfo: 'Información de contacto',
    tableCity: 'Ciudad',
    tableState: 'Estado',
    tableActions: 'Acciones',
    viewProfile: 'Ver perfil',
    profile: {
      title: 'Perfil del cliente',
      subtitle: 'Datos, historial y lealtad de un vistazo',
      loyaltyTabHint: 'Consulte puntos, canjes e historial completo de transacciones.',
      back: 'Volver a clientes',
      loadFailed: 'No se pudo cargar el perfil del cliente',
      scopeAll: 'Todas las ubicaciones',
      scopeCurrent: 'Esta ubicación',
      totalVisits: 'Visitas totales',
      totalVisitsHint: 'Ventas completadas que cuentan en ingresos (excluye cargo a cuenta).',
      totalSpent: 'Total gastado',
      totalSpentHint: 'Suma de mercancía en ventas contadas; el pago de cuenta cuenta una sola vez.',
      loyaltyPoints: 'Puntos de lealtad',
      lastVisit: 'Última visita',
      memberSince: 'Cliente desde',
      onlineAccess: {
        title: 'Cuenta en línea',
        notEligible: 'Agregue un correo principal para habilitar el acceso en línea.',
        neverInvited: 'Puede iniciar sesión en línea — aún no se ha enviado un enlace.',
        linkSent: 'Enlace enviado — aún no se ha usado',
        linkSentAt: 'Último enlace enviado {date}',
        active: 'Ha iniciado sesión en línea',
        lastSignIn: 'Último acceso {date}',
        sendLink: 'Enviar enlace de acceso',
        resendLink: 'Reenviar enlace de acceso',
        sendSuccess: 'Enlace de acceso enviado por correo.',
        sendFailed: 'No se pudo enviar el enlace de acceso.',
        firstInviteTitle: '¿Enviar el primer enlace de acceso?',
        firstInviteMessage: 'Este cliente no ha solicitado acceso en línea antes. Envíelo solo si lo pidió (por ejemplo en tienda o por teléfono). El correo es un enlace seguro de acceso, no un mensaje promocional.',
        firstInviteConfirm: 'Enviar enlace'
      },
      favoriteCategory: 'Categoría favorita',
      topProductsCaption: 'Compra a menudo: {names}',
      notesPreferences: 'Notas y preferencias',
      noNotes: 'Sin notas.',
      recentPurchases: 'Compras recientes',
      viewAllPurchases: 'Ver todo',
      noPurchases: 'Aún no hay historial de compras.',
      loyaltyProgress: '{points} puntos',
      pointsToReward: '{count} puntos para la siguiente recompensa',
      rewardReady: 'Listo para canjear',
      openFullProfile: 'Abrir perfil completo',
      tabOverview: 'Resumen',
      tabPurchases: 'Compras',
      purchasesListHint: 'Hasta {count} artículos recientes.',
      purchaseQtyLine: '{qty} × {price}',
      tabTabs: 'Cuentas',
      tabInvoices: 'Facturas',
      tabBooking: 'Reservas',
      tabLoyalty: 'Lealtad',
      openTabs: 'Cuentas abiertas',
      openInvoices: 'Facturas abiertas',
      noOpenTabs: 'No hay cuentas abiertas.',
      noInvoices: 'No se encontraron facturas.',
      noAppointments: 'No se encontraron citas.',
      averageTicket: 'Ticket prom.'
    },
    profilePhoto: 'Foto de perfil',
    profilePhotoHint: 'Ayuda al personal a reconocer al cliente.',
    photoChooseFile: 'Elegir archivo',
    photoAddPhoto: 'Añadir foto',
    photoTakePicture: 'Tomar foto',
    photoUseWebcam: 'Usar cámara web',
    photoRemove: 'Quitar foto',
    photoViewOnly: 'Puedes ver la foto; solo quienes gestionan clientes pueden cambiarla.',
    photoUploadSuccess: 'Foto actualizada',
    photoUploadFailed: 'No se pudo subir la foto',
    photoRemoveSuccess: 'Foto eliminada',
    photoRemoveFailed: 'No se pudo eliminar la foto',
    webcamTitle: 'Cámara web',
    webcamHelp: 'Inicia la cámara y luego captura un fotograma.',
    webcamStart: 'Iniciar cámara',
    webcamCapture: 'Capturar',
    webcamNotSupported: 'Este navegador no admite la cámara web. Use Elegir archivo o Tomar foto.',
    webcamPermissionDenied: 'Se denegó el acceso a la cámara. Revise los permisos o use Elegir archivo.',
    webcamWaitForVideo: 'Espere a que aparezca la vista previa e inténtelo de nuevo.',
    loyaltyDate: 'Fecha',
    loyaltyType: 'Tipo',
    loyaltyBalanceBefore: 'Saldo anterior',
    loyaltyPoints: 'Puntos',
    loyaltyBalanceAfter: 'Saldo posterior',
    loyaltySale: 'Venta',
    loyaltySaleNumber: 'Venta #{id}',
    loyaltyProductDetails: 'Detalles del producto',
    loyaltyProductFallback: 'Producto',
    loyaltyNotes: 'Notas',
    loyaltyFilterAll: 'Todos',
    loyaltyFilterEarned: 'Ganados',
    loyaltyFilterCashRedeemed: 'Canje en efectivo',
    loyaltyFilterProductRedeemed: 'Canje de producto',
    loyaltyTypeEarned: 'Ganados',
    loyaltyTypeCashRedeemed: 'Canje en efectivo',
    loyaltyTypeProductRedeemed: 'Canje de producto',
    more: 'más',
    manageCards: 'Gestionar tarjetas',
    paymentMethods: {
      title: 'Tarjetas guardadas',
      addCard: 'Agregar tarjeta',
      addCardTitle: 'Agregar tarjeta guardada',
      addCardHint: 'Se autoriza $1.00 para validar la tarjeta; la autorización se anula inmediatamente después de guardarla.',
      addCardKeyedEntry: 'Agregar tarjeta (entrada manual)',
      empty: 'Aún no hay tarjetas guardadas.',
      setDefault: 'Establecer como predeterminada',
      editLabel: 'Editar etiqueta',
      editLabelTitle: 'Etiqueta de tarjeta',
      remove: 'Eliminar',
      removeTitle: 'Eliminar tarjeta',
      removeMessage: '¿Eliminar {card} de este cliente?',
      removed: 'Tarjeta eliminada',
      removeFailed: 'No se pudo eliminar la tarjeta',
      cardSaved: 'Tarjeta guardada',
      defaultUpdated: 'Tarjeta predeterminada actualizada',
      labelUpdated: 'Etiqueta actualizada',
      updateFailed: 'No se pudo actualizar la tarjeta',
      captureUnavailable: 'La captura de tarjeta no está disponible. Configure Dejavoo CNP o un terminal SPIn.'
    }
  },
  locations: {
    title: 'Ubicaciones',
    subtitle: 'Gestiona ubicaciones de tiendas y la ubicación de sesión actual',
    newLocation: 'Nueva ubicación',
    loadFailed: 'No se pudieron cargar las ubicaciones',
    retry: 'Reintentar',
    search: 'Buscar',
    searchPlaceholder: 'Nombre, ciudad, estado…',
    state: 'Estado',
    stateAll: 'Todos',
    currentOnly: 'Solo actual',
    apply: 'Aplicar',
    clear: 'Limpiar',
    noLocations: 'No se encontraron ubicaciones.',
    editLocation: 'Editar ubicación',
    deleteLocation: 'Eliminar ubicación',
    current: 'Actual',
    setAsCurrent: 'Establecer como ubicación actual',
    editTitle: 'Editar ubicación',
    newTitle: 'Nueva ubicación',
    editSubtitle: 'Actualiza dirección, contacto, zona horaria y horario de esta tienda.',
    newSubtitle: 'Agrega una ubicación con dirección, contacto y horario.',
    section: {
      details: 'Detalles de la ubicación',
      detailsHint: 'Nombre y teléfono que aparecen en recibos e informes internos.',
      address: 'Dirección',
      addressHint: 'Dirección física usada para impuestos, facturas y contexto de ubicación.',
      schedule: 'Horario y zona horaria',
      scheduleHint: 'La zona horaria y el horario definen los resúmenes del panel y los reportes locales.'
    },
    locationName: 'Nombre de ubicación',
    locationNameRequired: 'El nombre de la ubicación es obligatorio',
    addressRequired: 'La dirección es obligatoria',
    cityRequired: 'La ciudad es obligatoria',
    stateRequired: 'El estado es obligatorio',
    postalCodeRequired: 'El código postal es obligatorio',
    phoneRequired: 'El número de teléfono es obligatorio',
    timezone: 'Zona horaria',
    timezoneHint: 'Opcional. Busca por ciudad o región. Vacío usa el valor predeterminado del negocio.',
    operatingHours: {
      title: 'Horario de operación',
      hint: 'Se usa para programar los resúmenes del panel antes de abrir y después de cerrar en esta ubicación.',
      open24_7: 'Abierto 24/7',
      open24_7Hint: 'Usa horarios predeterminados de resúmenes en lugar de apertura/cierre.',
      fallbackHint: 'Los resúmenes usan los horarios predeterminados: mañana (7:00) y fin del día (20:00).',
      emptyFallbackHint: 'Deja todos los días cerrados para usar el horario predeterminado hasta configurar horas.',
      columnDay: 'Día',
      columnStatus: 'Estado',
      closed: 'Cerrado',
      open: 'Apertura',
      close: 'Cierre',
      weekdays: {
        sunday: 'Domingo',
        monday: 'Lunes',
        tuesday: 'Martes',
        wednesday: 'Miércoles',
        thursday: 'Jueves',
        friday: 'Viernes',
        saturday: 'Sábado'
      }
    },
    update: 'Actualizar',
    create: 'Crear',
    deleteTitle: 'Eliminar ubicación',
    confirmDelete: '¿Estás seguro de que deseas eliminar "{name}"? Esta acción no se puede deshacer.',
    deleted: 'Ubicación eliminada correctamente',
    updated: 'Ubicación actualizada correctamente',
    created: 'Ubicación creada correctamente',
    saveFailed: 'Error al guardar la ubicación',
    loadFailedGeneric: 'Error al cargar las ubicaciones',
    setCurrentSuccess: '{name} establecida como ubicación actual',
    setCurrentFailed: 'Error al establecer ubicación actual: {message}',
    tableName: 'Nombre de ubicación',
    tableAddress: 'Dirección',
    tablePhone: 'Teléfono',
    tableCurrent: 'Actual',
    tableActions: 'Acciones'
  },
  invoices: {
    title: 'Facturas',
    invoiceLabel: 'Factura',
    documentTitle: {
      draft: 'Borrador',
      draftUntitled: 'Borrador',
      estimate: 'Cotización',
      invoice: 'Factura'
    },
    documentStatus: {
      unpaid: 'Impaga',
      unpaidAcceptanceHint: 'El cliente debe aceptar antes de pagar'
    },
    subtitle: 'Ver, crear y gestionar facturas de clientes',
    recurringNav: 'Facturación recurrente',
    recurring: {
      listTitle: 'Facturas recurrentes',
      listSubtitle: 'Administra programaciones de facturación recurrente',
      schedulesTableTitle: 'Programaciones recurrentes',
      templateColumn: 'Plantilla',
      templateBadge: 'Plantilla recurrente',
      editSchedule: 'Editar programación',
      editTemplate: 'Editar plantilla',
      viewTemplate: 'Ver plantilla',
      generatedInvoices: 'Facturas generadas',
      noGeneratedInvoices: 'Aún no hay facturas generadas.',
      generatedFromTemplate: 'Generada desde plantilla recurrente.',
      nextRun: 'Próxima ejecución',
      statusActive: 'Activa',
      statusPaused: 'Pausada',
      statusEnded: 'Finalizada',
      editScheduleTitle: 'Editar programación recurrente',
      editScheduleSubtitle: 'Actualiza horario, frecuencia y correo automático',
      saveSchedule: 'Guardar programación',
      scheduleSaved: 'Programación recurrente guardada',
      scheduleSaveFailed: 'No se pudo guardar la programación recurrente',
      scheduleActivated: 'Programación recurrente activada',
      saveTemplate: 'Guardar plantilla',
      templateSaved: 'Plantilla guardada',
      templateContentsSubtitle: 'Contenido de la plantilla',
      saveAndActivateSchedule: 'Guardar y activar programación',
      disableRecurringTitle: '¿Desactivar recurrencia?',
      disableRecurringMessage: 'Esto finalizará la programación recurrente al guardar.',
      frequency: 'Frecuencia',
      startDate: 'Fecha de inicio',
      timeOfDay: 'Hora del día',
      endDateOptional: 'Fecha de fin (opcional)',
      autoEmail: 'Enviar facturas por correo automáticamente',
      every: 'Cada',
      daysOfWeek: 'Días de la semana',
      dayOfMonth: 'Día del mes',
      upcomingRuns: 'Próximas ejecuciones',
      issueDate: 'Fecha de emisión',
      dueDate: 'Fecha de vencimiento',
      modeSimple: 'Simple',
      modeAdvanced: 'Avanzado',
      planName: 'Nombre del plan o servicio',
      cadencePreset: 'Frecuencia de facturación',
      presetMonthly: 'Mensual',
      presetQuarterly: 'Trimestral',
      presetAnnual: 'Anual',
      collectionMode: 'Cobro',
      collectionInvoiceOnly: 'Factura cada ciclo',
      collectionAutopay: 'Pago automático (tarjeta guardada)',
      paymentMethodOnFile: 'Tarjeta guardada',
      defaultCard: 'predeterminada',
      autopayStatus: 'Pago automático',
      autopayReady: 'Tarjeta guardada',
      autopayNeedsCard: 'Requiere configurar tarjeta',
      autopayFailed: 'Último cargo falló',
      sendEnrollmentLink: 'Enviar enlace de pago automático',
      sendEnrollmentLinkHint: 'Envíe un enlace seguro para que el cliente guarde una tarjeta.',
      enrollmentLinkSent: 'Enlace de pago automático enviado',
      enrollmentLinkFailed: 'No se pudo enviar el enlace',
      bulkImport: 'Importación masiva',
      bulkImportTitle: 'Importar suscriptores',
      bulkImportHint: 'Encabezado CSV: email, plan_name, amount, frequency, interval, collection_mode, start_date',
      bulkImportCsvLabel: 'Filas CSV',
      bulkSendEnrollmentLinks: 'Enviar enlaces de autopago para filas autopay sin tarjeta',
      bulkImportRun: 'Importar',
      bulkImportDone: 'Se crearon {created} calendario(s). {errors} error(es) de fila.',
      freqDaily: 'Diaria',
      freqWeekly: 'Semanal',
      freqMonthly: 'Mensual',
      freqYearly: 'Anual',
      firstRunStartDate: 'Primera ejecución en fecha de inicio',
      firstRunNow: 'Primera ejecución ahora',
      firstRunAfterPeriod: 'Después del periodo inicial',
      weekdaySun: 'Dom',
      weekdayMon: 'Lun',
      weekdayTue: 'Mar',
      weekdayWed: 'Mié',
      weekdayThu: 'Jue',
      weekdayFri: 'Vie',
      weekdaySat: 'Sáb'
    },
    newInvoice: 'Nueva factura',
    search: 'Buscar',
    searchPlaceholder: 'Número, cliente, estado…',
    status: 'Estado',
    issueFrom: 'Emisión desde',
    issueTo: 'Emisión hasta',
    assignedDay: 'Día asignado',
    apply: 'Aplicar',
    clear: 'Limpiar',
    rentalOnly: 'Solo facturas de alquiler',
    rentalBadge: 'Alquiler',
    setDay: 'Establecer día',
    applyDay: 'Aplicar día',
    startRoute: 'Iniciar ruta',
    view: 'Ver',
    directions: 'Direcciones',
    edit: 'Editar',
    cancel: 'Cancelar',
    statusAll: 'Todos',
    statusDraft: 'Borrador',
    statusEstimate: 'Cotización',
    statusIssued: 'Emitida',
    statusPartiallyPaid: 'Parcialmente pagada',
    statusPaid: 'Pagada',
    statusOverdue: 'Vencida',
    statusPastDue: 'Vencida',
    statusCancelled: 'Cancelada',
    statusExpired: 'Vencida (cotización)',
    statusVoided: 'Anulada',
    statusUnknown: 'Desconocido',
    tableNumber: 'Número',
    tableCustomer: 'Cliente',
    tableIssueDate: 'Fecha de emisión',
    tableDueDate: 'Fecha de vencimiento',
    tableTotal: 'Total',
    tableLabels: 'Etiquetas',
    labelsFilter: 'Etiquetas',
    labelsField: 'Etiquetas',
    tableStop: 'Parada #',
    editInvoice: 'Editar factura',
    newInvoiceTitle: 'Nueva factura',
    recurringTimezone: 'Zona horaria',
    recurringTimezoneHint: 'Busca por ciudad o región. Por defecto usa la zona horaria del negocio.',
    editRecurring: 'Editar programa de factura recurrente',
    newRecurring: 'Nuevo programa de factura recurrente',
    issueDate: 'Fecha de emisión',
    terms: 'Términos',
    termsRequired: 'Términos obligatorios',
    paymentDueDate: 'Fecha de pago',
    poNumber: 'Número de orden',
    headerDescription: 'Descripción',
    headerDescriptionHint: 'Visible para el cliente en la factura, el portal de pago, el PDF y el correo.',
    billTo: 'Facturar a',
    shipTo: 'Enviar a',
    lineItems: 'Líneas',
    selectProduct: 'Seleccionar producto',
    productIdFallback: 'Producto #{id}',
    lineDescriptionPlaceholder: 'Agregar una descripción',
    noResults: 'Sin resultados.',
    addNewProduct: 'Agregar nuevo producto',
    addNewProductCaption: 'Si no está en los resultados',
    createNewTerms: 'Crear nuevos términos',
    createNewTermsCaption: 'Se guardan para usar en futuras facturas',
    createNewTermsSubtitle: 'Se aplican a esta factura al guardar',
    noTermsConfigured: 'Aún no hay términos de pago.',
    termsName: 'Nombre de términos',
    termsNameRequired: 'El nombre es obligatorio',
    termsDays: 'Vence en (días)',
    termsDaysRequired: 'Ingrese cero o más días',
    termsSetDefault: 'Establecer como predeterminado para facturas nuevas',
    createTermsFailed: 'No se pudieron crear los términos de pago',
    termsCreatedAndSelected: 'Términos de pago creados y seleccionados',
    invoicePreview: 'Vista previa de factura',
    previewViewer: {
      subtitle: 'Vista para el cliente',
      deviceMobile: 'Móvil',
      deviceTablet: 'Tablet',
      deviceDesktop: 'Escritorio',
      portrait: 'Vertical',
      landscape: 'Horizontal',
      zoom: '{percent}%',
      zoomIn: 'Acercar',
      zoomOut: 'Alejar',
      resetView: 'Restablecer'
    },
    estimate: 'Cotización',
    emailInvoice: 'Enviar factura por correo',
    emailInvoiceSubtitle: 'Enviar al correo del cliente en archivo (o reemplazar abajo)',
    to: 'Para',
    subject: 'Asunto',
    attachPdf: 'Adjuntar PDF',
    requestApproval: 'Solicitar aprobación',
    send: 'Enviar',
    approved: 'Aprobado',
    by: 'por',
    viewSignature: 'Ver firma',
    customer: 'Cliente',
    billToAnchor: {
      modeCustomer: 'Facturar a cliente',
      modeProject: 'Facturar a proyecto',
      project: 'Proyecto',
      searchProject: 'Buscar proyectos',
      projectNeedsCustomer: 'Este proyecto no tiene cliente — seleccione uno para la factura.',
      viewProject: 'Ver proyecto',
      creatingForProject: 'Creando factura para {project}',
      backToProject: 'Volver al proyecto',
      projectRequired: 'Seleccione un proyecto',
      customerRequired: 'Seleccione un cliente'
    },
    billToEntity: {
      company: 'Empresa',
      ownerContact: 'Contacto del titular: {name}'
    },
    recipient: {
      groupBilling: 'Facturación del grupo',
      groupMember: 'Miembro del grupo',
      custom: 'Dirección personalizada'
    },
    void: 'Anular',
    refund: 'Reembolso',
    preview: 'Vista previa',
    text: 'Texto',
    applyPayment: 'Aplicar pago',
    addFulfillment: 'Agregar cumplimiento',
    fulfillmentHistory: 'Historial de cumplimiento',
    undoFulfillment: 'Eliminar',
    undoFulfillmentConfirmTitle: '¿Eliminar cumplimiento?',
    undoFulfillmentConfirmMessage: 'Esto elimina el registro de cumplimiento y actualiza las cantidades de línea. No se modifican pagos ni inventario.',
    undoFulfillmentLinkedSale: 'Vinculado a una venta — no se puede eliminar manualmente',
    reviseBlockedFulfillments: 'Elimine todos los cumplimientos antes de editar las líneas de la factura.',
    convert: {
      fromTabBanner: 'Esta factura se creó a partir de una cuenta corriente.',
      viewTab: 'Ver cuenta'
    },
    editIssuedInvoice: 'Editar factura (emitida)',
    saveInvoice: 'Guardar',
    rentalCustomerLocked: 'El cliente está bloqueado para facturas de alquiler.',
    issue: 'Emitir',
    issueNow: 'Emitir ahora',
    saveDraft: 'Guardar borrador',
    draftSaved: 'Factura guardada',
    includeDrafts: 'Incluir borradores',
    promoteToEstimate: 'Guardar como cotización',
    promoteToEstimateSuccess: 'Cotización guardada con número asignado',
    promoteToEstimateFailed: 'No se pudo guardar como cotización',
    deleteDraftTitle: '¿Eliminar borrador?',
    deleteDraftMessage: 'Esto elimina el borrador permanentemente y no se puede deshacer.',
    filters: {
      title: 'Buscar facturas',
      subtitle: 'Busque, filtre por etapa o acote por etiquetas y fechas.',
      subtitleV2: 'Busque por cliente o número y filtre por estado o etiquetas.',
      stageLabel: 'Etapa',
      stageColumn: 'Etapa',
      deliveryLabel: 'Entrega al cliente',
      moreLabel: 'Fechas y entrega',
      active: 'Filtros activos',
      labelsCount: '{count} etiqueta(s)',
      groupDraftQuotes: 'Borradores y cotizaciones',
      groupInvoices: 'Facturas y pago',
      groupClosed: 'Cerradas'
    },
    lifecycle: {
      filterLabel: 'Etapa',
      reminderCount: '{count} recordatorio(s) enviado(s)',
      draft: 'Borrador',
      estimate_not_sent: 'Cotización no enviada',
      estimate_sent: 'Cotización enviada',
      estimate_viewed: 'Cotización vista',
      estimate_approved: 'Cotización aprobada',
      expired: 'Vencida',
      cancelled: 'Cancelada',
      issued_not_sent: 'Factura no enviada',
      invoice_sent: 'Factura enviada',
      invoice_viewed: 'Factura vista',
      awaiting_acceptance: 'Pendiente de aceptación',
      awaiting_payment: 'Pendiente de pago',
      partially_paid: 'Parcialmente pagada',
      overdue: 'Vencida',
      paid: 'Pagada',
      voided: 'Anulada',
      tooltip: {
        draft: 'Borrador interno — no visible para clientes',
        estimate_not_sent: 'Cotización creada pero no enviada',
        estimate_sent: 'Enviada al cliente; aún no abierta',
        estimate_viewed: 'El cliente abrió el enlace de la cotización',
        estimate_approved: 'El cliente aprobó o firmó',
        expired: 'Venció el plazo de la cotización',
        cancelled: 'Cotización cancelada',
        issued_not_sent: 'Factura emitida pero no enviada',
        invoice_sent: 'Factura enviada; aún no abierta',
        invoice_viewed: 'El cliente abrió la factura',
        awaiting_acceptance: 'Debe aceptar antes de pagar',
        awaiting_payment: 'Saldo pendiente',
        partially_paid: 'Pago parcial recibido',
        overdue: 'Pasó la fecha de vencimiento',
        paid: 'Pagada en totalidad',
        voided: 'Anulada'
      }
    },
    engagement: {
      columnLabel: 'Cliente',
      filterLabel: 'Interacción del cliente',
      filterNotSent: 'No enviado al cliente',
      filterSentNotViewed: 'Enviado, no visto',
      filterViewed: 'Visto por el cliente',
      filterApproved: 'Presupuesto aprobado',
      panelTitle: 'Entrega al cliente',
      panelDesc: 'Si se entregó al cliente y si lo abrió o aprobó.',
      summaryEmpty: 'Aún no hay actividad de entrega registrada.',
      summaryNotSent: 'Aún no se envió al cliente',
      summarySent: 'Enviado al cliente',
      summaryEmailed: 'Correo enviado {at}',
      summaryTexted: 'SMS enviado {at}',
      summaryViewed: 'Abierto {at}',
      summaryNotViewedYet: 'Aún no abierto',
      summaryApproved: 'Aprobado {at}',
      summaryApprovalPending: 'Aprobación pendiente',
      viewTimeline: 'Ver línea de actividad',
      sentShort: 'Enviado',
      notSentShort: 'No enviado',
      viewedShort: 'Visto',
      notViewedShort: 'No visto',
      approvedShort: 'Aprobado',
      notApprovedShort: 'Pendiente',
      sentTooltip: 'Enviado al cliente',
      notSentTooltip: 'Sin correo ni SMS aún',
      notViewedTooltip: 'El cliente no ha abierto el enlace',
      emailedAt: 'Correo {at}',
      textedAt: 'SMS {at}',
      viewedAt: 'Visto {at}',
      approvedAt: 'Aprobado {at}'
    },
    activity: {
      deliverySummaryTitle: 'Resumen',
      loadMore: 'Cargar más',
      loadFailed: 'No se pudo cargar la actividad.',
      lastEmailed: 'Último correo {at}',
      lastSms: 'Último SMS {at}',
      lastViewed: 'Cliente vio {at}',
      approvedAt: 'Aprobado {at}',
      notSentEstimate: 'Aún no enviada',
      notSentInvoice: 'Aún no enviada',
      emptyTitleEstimate: 'Sin actividad del cliente',
      emptyTitleInvoice: 'Sin actividad del cliente',
      emptySubtitleEstimate: 'Envíe la cotización o comparta el enlace de aprobación para ver aperturas y aprobaciones aquí.',
      emptySubtitleInvoice: 'Envíe la factura o comparta el enlace de pago para ver aperturas y pagos aquí.',
      toRecipient: 'Para {to}',
      paymentAmount: 'Monto ${amount}',
      approvedBy: 'Firmado por {name}',
      kind: {
        issued: 'Factura emitida',
        email_sent: 'Correo enviado',
        sms_sent: 'SMS enviado',
        email_opened: 'Correo abierto',
        link_viewed: 'Enlace visto',
        estimate_approved: 'Cotización aprobada',
        payment_submitted: 'Pago recibido',
        reminder_email_sent: 'Recordatorio por correo',
        reminder_sms_sent: 'Recordatorio por SMS'
      }
    },
    detail: {
      tabDetails: 'Detalles',
      tabDetailsDesc: 'Partidas, pagos, notas y adjuntos de este documento.',
      tabClientActivity: 'Actividad del cliente',
      tabClientActivityDesc: 'Envíos, aperturas, aprobaciones y pagos desde la perspectiva del cliente.',
      back: 'Volver a facturas',
      balanceDue: 'Saldo pendiente',
      paidProgress: '{percent}% pagado',
      subtotal: 'Subtotal',
      tax: 'Impuesto',
      details: 'Detalles',
      routeOrder: 'Parada de ruta',
      addresses: 'Direcciones',
      rentalContext: 'Alquiler',
      servicePeriod: 'Período de servicio: {start} – {end}',
      viewAgreement: 'Ver contrato de alquiler',
      colItem: 'Artículo',
      colLineNumber: '#',
      colProduct: 'Producto',
      colDescription: 'Descripción',
      colQty: 'Cant.',
      colUnitPrice: 'Precio unitario',
      colDiscount: 'Descuento',
      colExtPrice: 'Precio ext.',
      colLineTotal: 'Total línea',
      colAmount: 'Importe',
      colFulfillment: 'Cumplimiento',
      colDate: 'Fecha',
      colMethod: 'Método',
      colReference: 'Referencia',
      colTip: 'Propina',
      paymentHistory: 'Historial de pagos',
      noPayments: 'Aún no hay pagos aplicados.',
      internalNotes: 'Notas internas',
      staffOnly: 'Solo personal — no visible para clientes',
      attachments: 'Adjuntos',
      manageAttachments: 'Administrar adjuntos',
      attachmentsHint: 'Sube imágenes o PDF para conservar con esta factura',
      uploadFiles: 'Subir archivos',
      noAttachments: 'Aún no hay adjuntos.',
      recurringSchedule: 'Programación recurrente',
      pauseRecurring: 'Pausar',
      resumeRecurring: 'Reanudar',
      endRecurring: 'Finalizar',
      upcomingRuns: 'Próximas ejecuciones',
      noUpcomingRuns: 'No hay ejecuciones programadas.',
      recurringStart: 'Inicio',
      recurringEnd: 'Fin',
      recurringNoEnd: 'Sin fecha de fin',
      fulfillmentShipment: 'Envío',
      fulfillmentPos: 'Venta POS',
      fulfillmentAdjustment: 'Ajuste',
      more: 'Más',
      menuShare: 'Compartir',
      menuCollect: 'Cobrar',
      menuField: 'Campo',
      menuAdmin: 'Administrar',
      downloadPdf: 'Descargar PDF',
      email: 'Correo',
      loadFailed: 'No se pudo cargar la factura',
      retry: 'Reintentar',
      textInvoice: 'Enviar por SMS',
      textInvoiceSubtitle: 'Enviar al teléfono del cliente registrado (o cambiar abajo)',
      phoneRequired: 'El número de teléfono es obligatorio',
      phoneUsOnly: 'Los SMS solo se pueden enviar a números de EE. UU.',
      phoneUsHint: 'Solo números de teléfono de EE. UU.',
      cancelEstimateTitle: '¿Cancelar factura?',
      cancelEstimateMessage: 'Esto cancelará el presupuesto e impedirá emitirlo.',
      voidTitle: '¿Anular factura?',
      voidMessage: 'Esto anulará la factura e impedirá que se pague.',
      refundTitle: '¿Crear reembolso?',
      refundMessage: 'Esto creará una nota de crédito por el importe total de la factura.',
      creditMemoCreated: 'Nota de crédito creada',
      emailSent: 'Correo enviado',
      smsSent: 'Factura enviada por SMS',
      previewFailed: 'No se pudo cargar la vista previa',
      attachmentOpenFailed: 'No se pudo abrir el adjunto',
      directionsFailed: 'No hay una dirección válida para indicaciones',
      endRecurringTitle: '¿Finalizar programación recurrente?',
      endRecurringMessage: 'Esto detendrá la generación de facturas futuras.',
      uploadFailed: 'Error al subir adjunto(s)',
      deleteAttachmentFailed: 'Error al eliminar adjunto',
      sendEmailFailed: 'Error al enviar correo',
      sendSmsFailed: 'Error al enviar SMS'
    },
    recordPayment: {
      action: 'Registrar pago',
      title: 'Registrar pago',
      subtitle: 'Registre un pago recibido fuera de la caja',
      balanceDue: 'Saldo pendiente',
      amount: 'Importe',
      payFullBalance: 'Pagar saldo completo',
      method: 'Método de pago',
      receivedDate: 'Fecha de recepción',
      reference: 'Referencia (opcional)',
      notes: 'Notas (opcional)',
      checkNumber: 'Número de cheque (opcional)',
      bankName: 'Nombre del banco (opcional)',
      authCode: 'Código de autorización / referencia (opcional)',
      cardLast4: 'Últimos 4 dígitos (opcional)',
      methodCash: 'Efectivo',
      methodCheck: 'Cheque',
      methodCardExternal: 'Tarjeta (ya procesada)',
      methodBankTransfer: 'Transferencia bancaria',
      methodOther: 'Otro',
      cardExternalHint: 'Esto registra un pago ya cobrado fuera de Blu. No ejecuta una transacción con tarjeta. Para cobrar con tarjeta ahora, use Pagar en caja.',
      submit: 'Registrar pago',
      success: 'Pago registrado',
      failed: 'Error al registrar el pago',
      remove: 'Eliminar',
      removeTitle: '¿Eliminar pago registrado?',
      removeMessage: 'Esto elimina el registro del pago y restaura el saldo de la factura. Use esto solo para corregir un error.',
      removeSuccess: 'Pago eliminado',
      removeFailed: 'Error al eliminar el pago',
      methodLabels: {
        cash: 'Efectivo',
        check: 'Cheque',
        card_online: 'Tarjeta (en línea)',
        card_external: 'Tarjeta (ya procesada)',
        bank_transfer: 'Transferencia bancaria',
        klarna: 'Klarna',
        other: 'Otro'
      }
    }
  },
  sales: {
    title: 'Ventas',
    subtitle: 'Historial de ventas y acceso a recibos',
    newSale: 'Nueva venta',
    loadFailed: 'No se pudieron cargar las ventas',
    retry: 'Reintentar',
    search: 'Buscar',
    searchPlaceholder: 'Venta #, cliente, notas...',
    status: 'Estado',
    saleStatusAll: 'Todos los estados',
    saleStatusPending: 'Pendiente',
    saleStatusCompleted: 'Completada',
    saleStatusVoid: 'Anulada',
    saleStatusRefunded: 'Reembolsada',
    saleStatusUnknown: 'Desconocido',
    voidedFilter: 'Ventas anuladas',
    voidedFilterExclude: 'Ocultar anuladas',
    voidedFilterInclude: 'Incluir anuladas',
    voidedFilterOnly: 'Solo anuladas',
    voidedFilterHint: 'Incluye ventas anuladas del servidor',
    payment: 'Pago',
    paymentAll: 'Todos los pagos',
    location: 'Ubicación',
    locationAll: 'Todas las ubicaciones',
    noLocationsAvailable: 'No hay ubicaciones disponibles',
    from: 'Desde',
    to: 'Hasta',
    apply: 'Aplicar',
    clear: 'Limpiar',
    salesHistory: 'Historial de ventas',
    viewReceipt: 'Ver recibo',
    receipt: 'Recibo',
    emailReceipt: 'Enviar recibo por correo',
    textReceipt: 'Enviar recibo por texto',
    ccMe: 'Enviarme copia',
    print: 'Imprimir',
    cfdGreetingMorning: '¡Buenos días!',
    cfdGreetingAfternoon: '¡Buenas tardes!',
    cfdGreetingEvening: '¡Buenas noches!',
    cfdGreetingMorningName: '¡Buenos días, {name}!',
    cfdGreetingAfternoonName: '¡Buenas tardes, {name}!',
    cfdGreetingEveningName: '¡Buenas noches, {name}!',
    cfdDiscountCaptionSale: 'incluye descuento de venta ({label})',
    receiptShareFailed: 'No se pudo abrir el recibo. Inténtalo de nuevo.',
    receiptThermalFallback: 'Falló la impresora térmica; se usará la impresión del sistema.',
    postSaleReceiptTitle: 'Opciones de recibo',
    postSaleReceiptSubtitle: '¿Cómo desea manejar el recibo de esta venta?',
    postSaleReceiptNone: 'Sin recibo',
    postSaleReceiptView: 'Ver recibo',
    postSaleReceiptSaveToCustomer: 'Guardar en el registro del cliente',
    postSaleReceiptMissingSale: 'La información de la venta ya no está disponible.',
    postSaleReceiptInvalidEmail: 'Ingrese un correo electrónico válido.',
    postSaleReceiptInvalidPhone: 'Ingrese un número de teléfono válido de EE. UU.',
    postSaleReceiptFailed: 'No se pudo completar la acción del recibo.',
    postSaleReceiptEmailed: 'Recibo enviado por correo',
    postSaleReceiptTexted: 'Recibo enviado por mensaje',
    postSaleReceiptBrowserPrintHint: 'Use Ver recibo para imprimir desde el navegador si es necesario.',
    postSaleReceiptUnknownChoice: 'Opción de recibo desconocida.',
    finishReceiptBeforeNextSale: 'Termine las opciones de recibo de la venta actual antes de iniciar otro pago.',
    postSaleTipHeading: 'Propina en terminal',
    postSaleTipHint: 'El cliente agregó propina en la terminal de tarjeta.',
    postSaleCashChangeTitle: 'Pago en efectivo completado',
    postSaleCashChangeSubtitle: 'Entregue el cambio al cliente y luego continúe.',
    postSaleCashChangeNoChangeDue: 'Sin cambio',
    postSaleCashChangeContinue: 'Continuar',
    postSaleCompleteTitle: 'Venta completada',
    postSaleCompleteSubtitle: 'Entregue el cambio si corresponde y elija una opción de recibo.',
    postSaleReceiptHandledPrint: 'Recibo enviado a la impresora.',
    postSaleReceiptHandledEmail: 'Recibo enviado por correo.',
    postSaleReceiptHandledSms: 'Recibo enviado por mensaje.',
    postSaleReceiptHandledNone: 'No se seleccionó recibo.',
    postSaleReceiptHandledOnDisplay: 'El cliente eligió una opción de recibo en la pantalla.',
    saleReceiptSubtitle: 'Resumen de la venta y del pago',
    saleReceiptSaleDetails: 'Detalle de venta',
    saleReceiptType: 'Tipo de recibo',
    saleReceiptCustomerDetails: 'Cliente',
    saleReceiptItems: 'Artículos',
    saleReceiptPaymentDetails: 'Detalle de pago',
    saleReceiptActions: 'Acciones',
    saleReceiptLoyalty: 'Programa de lealtad',
    saleReceiptItemsRedeemed: 'Artículos canjeados',
    saleReceiptTableProduct: 'Producto',
    saleReceiptTableQty: 'Cant.',
    saleReceiptTablePrice: 'Precio',
    saleReceiptTableDiscount: 'Dto.',
    saleReceiptTableLineTotal: 'Subtotal línea',
    saleReceiptDate: 'Fecha',
    saleReceiptSaleNumber: 'Venta n.º',
    saleReceiptCustomerLabel: 'Cliente',
    saleReceiptWalkIn: 'Sin cliente',
    saleReceiptPaymentMethod: 'Forma de pago',
    tabPaymentReceipt: {
      lineItem: 'Pago de tab — Tab #{id}',
      itemsTitle: 'Compras en la tab',
      ledgerHint: 'Artículos cargados a esta tab',
      entryQty: 'Cant. {qty}',
      entryQtyPrice: 'Cant. {qty} × {price}',
      summaryTitle: 'Resumen del pago de tab',
      receiptTitle: 'Recibo de pago de tab',
      tabAccountSection: 'Cuenta del tab',
      thisPaymentSection: 'Este pago',
      itemsChargedToTab: 'Artículos cargados al tab',
      tabChargesTotal: 'Total de cargos del tab',
      priorPayments: 'Pagos anteriores',
      amountPaid: 'Monto pagado',
      paidInFull: 'Pagado en su totalidad',
      balanceBefore: 'Saldo antes del pago',
      thisPayment: 'Este pago',
      paymentAmount: 'Monto del pago',
      remainingBalance: 'Saldo restante',
      totalCharged: 'Total cobrado',
      badge: 'Pago de tab'
    },
    invoicePaymentReceipt: {
      receiptTitle: 'Recibo de pago de factura',
      itemsTitle: 'Facturas pagadas'
    },
    saleReceiptSaleSource: 'Origen de la venta',
    saleSourcePos: 'Registro en la app',
    saleSourceTerminalFeed: 'Terminal (FEED)',
    salesColumnSaleSource: 'Origen de la venta',
    saleReceiptName: 'Nombre',
    saleReceiptPhoneLabel: 'Teléfono',
    saleReceiptEmailLabel: 'Correo',
    saleReceiptTaxId: 'RFC / ID fiscal',
    saleReceiptSubtotal: 'Subtotal',
    saleReceiptSaleDiscount: 'Descuento de venta',
    saleReceiptDiscountedSubtotal: 'Subtotal tras descuento',
    saleReceiptTax: 'Impuesto',
    saleReceiptTip: 'Propina',
    saleReceiptConvenienceFee: 'Comisión',
    saleReceiptPennyRounding: 'Redondeo de centavos',
    saleReceiptCashTotal: 'Total (efectivo)',
    saleReceiptTotal: 'Total',
    saleReceiptAmountReceived: 'Importe recibido',
    saleReceiptChangeGiven: 'Cambio',
    saleReceiptCardType: 'Tipo de tarjeta',
    saleReceiptCardNumber: 'Número de tarjeta',
    saleReceiptAuthorization: 'Autorización',
    saleReceiptTransactionId: 'ID de transacción',
    saleReceiptSplitPayments: 'Pagos divididos',
    saleReceiptCfTotal: 'Total comisión',
    saleReceiptPrevBalance: 'Saldo anterior',
    saleReceiptPointsEarned: 'Puntos ganados',
    saleReceiptPointsRedeemed: 'Puntos canjeados',
    saleReceiptNewBalance: 'Nuevo saldo',
    saleReceiptBusinessPhone: 'Teléfono',
    saleReceiptBusinessEmail: 'Correo',
    saleReceiptPaymentCard: 'Tarjeta',
    saleReceiptVoidPayment: 'Anular pago',
    saleReceiptRefundPayment: 'Reembolsar pago',
    saleReceiptConfirmVoidTitle: 'Confirmar anulación',
    saleReceiptConfirmRefundTitle: 'Confirmar reembolso',
    saleReceiptConfirmVoidMessage: '¿Seguro que desea anular este pago? Se cancelará la transacción del mismo día.',
    saleReceiptConfirmRefundMessage: '¿Seguro que desea reembolsar este pago? Se creará un reembolso en el procesador.',
    saleReceiptVoidRequested: 'Solicitud de anulación enviada',
    saleReceiptRefundRequested: 'Solicitud de reembolso enviada',
    saleReceiptRefundRequestFailed: 'No se pudo enviar la solicitud',
    searchProducts: 'Buscar productos',
    scanBarcode: 'Escanear código de barras',
    quickCreate: 'Creación rápida',
    quickCreateProduct: 'Crear producto rápido',
    myGrid: 'Mi cuadrícula',
    globalGrid: 'Cuadrícula global',
    rentalGrid: 'Cuadrícula de alquileres',
    refreshRentalGridTooltip: 'Recargar edificios y mapa de unidades desde el servidor',
    customizeGrid: 'Personalizar cuadrícula',
    customizeMyGrid: 'Personalizar mi cuadrícula',
    customizeGlobalGrid: 'Personalizar cuadrícula global',
    refreshGrid: 'Actualizar cuadrícula',
    refreshGridTooltip: 'Volver a cargar productos, categorías y diseño de cuadrícula desde el servidor',
    statusActive: 'Activo',
    statusVoided: 'Anulado',
    statusAll: 'Todos',
    paymentCash: 'Efectivo',
    paymentCard: 'Tarjeta',
    paymentKlarna: 'Klarna',
    paymentSplit: 'Dividido',
    paymentTab: 'Cuenta',
    paymentTabHouse: 'Cuenta de casa',
    paymentTabBar: 'Barra',
    paymentTabPortal: 'Cuenta en línea',
    paymentTabPaymentBar: 'Pago de barra',
    paymentCheck: 'Cheque',
    paymentUnknown: 'Pago',
    openRegisterBeforeCardPayment: 'Abra la caja asignada antes de procesar pagos con tarjeta.',
    tapToPayPreparingTitle: 'Preparando Tap to Pay',
    tapToPayPreparingHint: 'Espere…',
    cardSettlementProcessingTitle: 'Procesando el pago con tarjeta',
    cardSettlementProcessingHint: 'Espere…',
    tapToPaySaleMissing: 'No se pudo crear la venta para el pago con tarjeta. Compruebe la conexión e inténtelo de nuevo.',
    inventoryOversoldLine: 'El stock registrado era bajo para "{product}": {available} disponible(s), {requested} vendido(s). Se ajustó el inventario.',
    inventoryOversoldLinkedModifier: 'El stock registrado era bajo para el complemento "{product}": {available} disponible(s), {requested} deducido(s). Se ajustó el inventario.',
    inventoryOversoldGeneric: 'Aviso de inventario: {code}',
    inventoryOversoldUnknownProduct: 'Artículo',
    cardModeIntegratedUnavailable: 'La terminal integrada (DvPayLite) no está disponible en este dispositivo o en el terminal de esta registradora. Elija otro modo de pago o abra el cuadro de pago.',
    cardModePhysicalTerminalUnavailable: 'Esta caja necesita un terminal activo listo para tarjetas físicas. Revise el terminal o la configuración de la caja.',
    iphoneTopSetupButton: 'Configurar Tap to Pay',
    iphoneTopSetupButtonTooltip: 'Complete la configuración única de Tap to Pay en iPhone antes de cobrar con tarjeta en este dispositivo.',
    cardModeTapOnPhoneUnavailable: 'Tap on Phone no se puede usar en esta configuración. Instale la app Android de Blu POS y configure Tap on Phone, o elija otro modo de tarjeta.',
    cardModeKeyedUnavailable: 'La captura manual no está disponible. Habilítela en su pasarela o elija otro modo.',
    cardPaymentsUnavailable: 'Los pagos con tarjeta no están disponibles en esta caja. Use efectivo o contacte a su administrador.',
    tableSaleNumber: 'Venta #',
    tableDate: 'Fecha',
    tableCustomer: 'Cliente',
    tableTotal: 'Total',
    tablePaymentMethod: 'Método de pago',
    tableStatus: 'Estado',
    tableActions: 'Acciones',
    noProductsFound: 'No se encontraron productos',
    noProductsMatchHint: 'No encontramos productos que coincidan con tu búsqueda.',
    quickCreateHintBefore: '¿No encuentras lo que buscas? Haz clic en el botón',
    quickCreateHintAfter: 'Creación rápida arriba para agregar un nuevo producto.',
    customerHasOpenTabs: 'El cliente tiene cuenta(s) abierta(s)',
    recommendUseTab: 'Se recomienda usar una cuenta existente cuando sea posible.',
    tabOwner: 'Propietario',
    moreTabs: 'más',
    loadingCart: 'Cargando carrito...',
    cartConcurrentActivity:
      'El carrito también se actualizó desde otro dispositivo o pestaña. Tus cambios se combinaron.',
    posLowStockAddWarning:
      'Stock bajo para {product}. Verifique la disponibilidad.',
    posLowStockQuantityWarning:
      'Solo {available} registrados en stock. Cantidad actualizada de todos modos.',
    pendingTabPayment: 'Pago de cuenta pendiente',
    amount: 'Monto',
    noItemsInCart: 'No hay artículos en el carrito',
    redeeming: 'CANJEANDO',
    modifiers: 'Modificadores:',
    removeItem: 'Quitar artículo',
    ringByAmountTitle: 'Ingresar monto',
    ringByAmountLabel: 'Monto total',
    ringByAmountMin: 'Ingrese al menos $0.01',
    ringByAmountUnitPrice: 'Precio unitario',
    ringByAmountQuantity: 'Cantidad',
    ringByAmountConfirm: 'Agregar al carrito',
    ringByAmountEdit: 'Editar monto',
    ringByAmountLineCaption: '${total} total at ${unit}/unidad',
    cartLineEntryQuantityTitle: 'Ingresar cantidad',
    cartLineEntryLineTitle: 'Editar línea',
    cartLineEntryQuantityLabel: 'Cantidad',
    cartLineEntryUnitPriceLabel: 'Precio unitario',
    cartLineEntryLineTotal: 'Total de línea',
    cartLineEntryQuantityRequired: 'Ingrese una cantidad',
    cartLineEntryQuantityMinFractional: 'Ingrese al menos 0.0001',
    cartLineEntryQuantityMinInteger: 'Ingrese un número entero de al menos 1',
    cartLineEntryPriceMin: 'El precio debe ser cero o mayor',
    cartLineEntryAdd: 'Agregar al carrito',
    cartLineEntrySave: 'Guardar',
    cartLineEntryRemove: 'Quitar del carrito',
    cartLineEntryRemoveHint: 'Cantidad cero quita esta línea del carrito.',
    openPriceTitle: 'Ingresar precio',
    openPriceConfirm: 'Agregar al carrito',
    openPriceMin: 'Ingrese al menos $0.01',
    decreaseQuantity: 'Disminuir cantidad',
    increaseQuantity: 'Aumentar cantidad',
    setDiscount: 'Establecer descuento',
    discountFormat: 'Formato',
    save: 'Guardar',
    original: 'Original',
    discounted: 'Con descuento',
    subtotal: 'Subtotal',
    subtotalAndTax: 'Subtotal e impuesto',
    barTabTotal: 'Total de cuenta de bar',
    saleDiscount: 'Descuento de venta',
    showSaleDiscount: 'Mostrar descuento de venta',
    hideSaleDiscount: 'Ocultar descuento de venta',
    clearDiscount: 'Limpiar descuento',
    discountedSubtotal: 'Subtotal con descuento',
    tax: 'Impuesto',
    loyaltyPoints: 'Puntos de fidelidad',
    available: 'disponibles',
    redeemPoints: 'Canjear puntos',
    clearPoints: 'Limpiar puntos',
    pointsValue: 'Valor en puntos',
    pointsToEarn: 'Puntos a ganar:',
    itemsToRedeem: 'Artículos a canjear:',
    redeemProducts: 'Canjear productos',
    redeemProductsFor: 'Canjear productos — {name}',
    redemptionAvailablePoints: 'Puntos disponibles',
    redemptionPointsUnit: 'puntos',
    redemptionLoadingProducts: 'Cargando productos canjeables…',
    redemptionCanAfford: 'Puede permitírselo',
    redemptionInsufficientPoints: 'Puntos insuficientes',
    redemptionQuantityMin: 'La cantidad debe ser al menos 1',
    redemptionNotesOptional: 'Notas (opcional)',
    redemptionAddToCart: 'Añadir al carrito',
    redemptionLoadFailed: 'Error al cargar productos canjeables',
    redemptionNotEnoughPoints: 'El cliente no tiene suficientes puntos para este producto',
    addProductsForRedemption: 'Agregar productos al carrito para canje de fidelidad',
    loyaltyDisabledBlockPayment:
      'El programa de fidelidad está desactivado. Quita los artículos canjeados y los puntos del carrito, o activa la fidelidad en Configuración.',
    sendToAstro: 'Enviar a Astro',
    total: 'Total',
    cash: 'Efectivo',
    card: 'Tarjeta',
    split: 'Dividido',
    chargeToTab: 'Cobrar a cuenta',
    selectCustomerForTab: 'Selecciona un cliente para cobrar a una cuenta',
    selectCustomerForRental: 'Selecciona un cliente en la caja antes de alquilar una unidad',
    registerTabsEntry: 'Cuentas',
    barTab: 'Cuenta de bar',
    barTabCustomerShortcut: 'Abrir cuenta de bar del cliente',
    barTabCustomerShortcutVerify: 'Verificar tarjeta para cuenta de bar',
    barTabCustomerShortcutAttach: 'Vincular cuenta de bar al registro',
    barTabCustomerShortcutCharge: 'Cargar carrito a cuenta de bar',
    barTabAttachOrChargeTitle: 'Cuenta de bar lista',
    barTabAttachOrChargeMessage: '¿Solo vincular la cuenta a este registro o cargar el carrito actual a la cuenta ahora?',
    barTabAttachOrChargeAttachOnly: 'Solo vincular cuenta',
    barTabAttachOrChargeChargeNow: 'Cargar carrito ahora',
    barTabAddRounds: 'Añadir a la cuenta',
    barTabAddRoundsSuccess: 'Artículos añadidos a la cuenta de bar',
    cfdBarTabAddRoundsSuccess: '{amount} añadidos a su cuenta',
    cfdBarTabAddRoundsSuccessShort: 'Añadido a su cuenta',
    barTabAddRoundsNeedItems: 'Añada artículos al carrito primero',
    barTabAddRoundsNeedItemsOrChanges: 'Añada artículos al carrito o actualice los de la cuenta primero',
    barTabUpdateTab: 'Guardar cambios en la cuenta',
    barTabUpdateTabSuccess: 'Cuenta actualizada',
    barTabUpdateTabFailed: 'No se pudo actualizar la cuenta',
    barTabLedgerUnsaved: 'sin guardar',
    barTabModeEntered: 'Modo cuenta de bar: {label}',
    barTabModeDetach: 'Desvincular cuenta de bar',
    barTabReleaseTab: 'Salir de cuenta de bar',
    barTabReleaseTabTooltip: 'Salir del modo cuenta de bar — la cuenta sigue abierta',
    barTabRemoveCustomerTooltip: 'Quitar el cliente del registro y desvincular la cuenta de bar',
    barTabModeFlipBack: 'Cliente',
    barTabModeBlockedPendingPayment: 'Complete o cancele el pago de cuenta pendiente antes de entrar en modo cuenta de bar',
    barTabModeBlockedPendingCredit: 'Complete o cancele el crédito de cuenta pendiente antes de entrar en modo cuenta de bar',
    barTabModeBlockedHouseTabActive: 'Salga del modo cuenta de casa antes de iniciar el modo cuenta de bar',
    barTabOnTabSection: 'En la cuenta',
    barTabNewItemsSection: 'Artículos nuevos',
    barTabLedgerLoading: 'Cargando cuenta…',
    barTabCloseOutAdding: 'Añadiendo artículos a la cuenta…',
    barTabCloseOutCollecting: 'Cobrando…',
    barTabCloseOutNoBalance: 'El saldo de la cuenta ya es cero',
    barTabCloseOutFailed: 'No se pudo cerrar la cuenta de bar',
    barTabCloseOutCashTooltip: 'Cargue artículos nuevos (si hay) y cobre el saldo total en efectivo',
    barTabCloseOutCardTooltip: 'Cargue artículos nuevos (si hay) y cobre el saldo total con tarjeta',
    barTabCloseOutSplitTooltip: 'Cargue artículos nuevos (si hay) y cobre el saldo total con pago dividido',
    barTabCloseOutPreauthReleased: 'Cuenta pagada en efectivo. Cualquier retención de tarjeta de verificación fue liberada, no cobrada.',
    suspendBlockedBarTabMode: 'Salga del modo cuenta de bar o complete el cobro antes de suspender',
    barTabStripVerified: 'Verificada',
    barTabCardVerifiedBadge: 'Tarjeta verificada',
    barTabOpenedAt: 'Abierta {datetime}',
    tabPrint: 'Imprimir',
    tabPrintSuccess: 'Estado de cuenta enviado a la impresora',
    tabPrintFailed: 'No se pudo imprimir el estado de cuenta',
    barTabStripCardRequired: 'Tarjeta requerida',
    barTabStripDetach: 'Desvincular cuenta de bar del registro',
    barTabGridTitle: 'Cuentas de bar abiertas',
    barTabGridSubtitle: 'Seleccione una cuenta abierta para continuar en este registro o cree una nueva sin cliente.',
    barTabGridSelectHint: 'Toque una cuenta abajo para abrirla en este registro.',
    barTabGridFilterPlaceholder: 'Buscar por nombre o tarjeta…',
    barTabGridEmpty: 'No hay cuentas de bar abiertas en esta ubicación.',
    barTabGridRemove: 'Eliminar',
    barTabGridRemoveConfirmTitle: '¿Eliminar cuenta de bar?',
    barTabGridRemoveConfirmMessage: '¿Eliminar {label} de las cuentas de bar abiertas? Esto cierra la cuenta sin venta.',
    barTabGridRemoveSuccess: 'Cuenta de bar eliminada',
    barTabGridRemoveFailed: 'No se pudo eliminar la cuenta de bar',
    barTabNew: 'Nueva cuenta de bar',
    barTabNewWalkIn: 'Nueva cuenta de bar sin cliente',
    barTabNewForCustomer: 'Nueva cuenta de bar para el cliente',
    barTabNeedCartItems: 'Agregue artículos al carrito antes de cargar a una cuenta de bar.',
    barTabChargeTitle: 'Cargar a cuenta de bar',
    barTabChargeHint: 'Seleccione una cuenta abierta o cree una nueva y asegure la tarjeta.',
    barTabSelectExisting: 'Cuentas de bar abiertas',
    barTabContinue: 'Continuar',
    barTabAttach: 'Asociar',
    barTabPay: 'Cobrar cuenta',
    barTabCharge: 'Cargar',
    barTabAttached: 'Cuenta de bar: {label}',
    barTabChargeSuccess: 'Artículos cargados a la cuenta de bar',
    barTabChargeSuccessDetail: 'Cargado a la cuenta de bar #{id}',
    barTabInferredName: 'Nombre en tarjeta: {name}',
    barTabVerifyCard: 'Verificar tarjeta',
    barTabSimulateCard: 'Simular verificación de tarjeta',
    barTabWizardSubtitle: 'Adjunte una cuenta, cargue el carrito, verifique una tarjeta o pague el saldo.',
    barTabWizardDevBanner: 'Modo dev de bar tab: la verificación de tarjeta es simulada (no se requiere pasarela de pago).',
    barTabWizardIntentTitle: '¿Qué desea hacer?',
    barTabWizardIntentAttach: 'Adjuntar cuenta',
    barTabWizardIntentCharge: 'Cargar carrito',
    barTabWizardIntentVerify: 'Verificar tarjeta',
    barTabWizardIntentPay: 'Pagar saldo',
    barTabWizardProgressIntent: 'Elija una acción',
    barTabWizardProgressSelect: 'Seleccione una bar tab',
    barTabWizardProgressCard: 'Verificar tarjeta registrada',
    barTabWizardProgressConfirm: 'Confirmar cargo',
    barTabWizardConfirmTitle: '¿Cargar carrito a la bar tab?',
    barTabWizardConfirmHint: 'Estos artículos se agregarán al saldo de la cuenta.',
    barTabWizardCartTotal: 'Total del carrito',
    barTabWizardDoneTitle: 'Listo',
    barTabWizardVerifySuccess: 'Tarjeta verificada para la bar tab',
    barTabWizardPayNeedsVerify: 'Verifique una tarjeta antes de pagar esta bar tab.',
    barTabWizardPayQueued: 'Pago de cuenta listo: complete el cobro cuando esté listo.',
    barTabWizardSelectTabFirst: 'Seleccione una bar tab primero.',
    houseTab: 'Tab de casa',
    houseTabCustomerShortcut: 'Abrir tab de casa del cliente',
    houseTabCustomerShortcutAttach: 'Adjuntar tab de casa al registro',
    houseTabCustomerShortcutCharge: 'Cargar carrito al tab de casa',
    houseTabCustomerShortcutPay: 'Pagar saldo del tab de casa',
    houseTabAddToTab: 'Agregar al tab',
    houseTabAddToTabSuccess: 'Artículos agregados al tab de casa',
    houseTabAddToTabNeedItemsOrChanges: 'Agregue artículos al carrito o actualice el tab primero',
    houseTabUpdateTab: 'Guardar cambios del tab',
    houseTabUpdateTabSuccess: 'Tab actualizado',
    houseTabUpdateTabFailed: 'No se pudo actualizar el tab',
    houseTabLedgerUnsaved: 'sin guardar',
    houseTabLedgerUnsavedBadge: 'Sin guardar',
    houseTabModeEntered: 'Modo tab de casa: {label}',
    houseTabReleaseTab: 'Salir del tab de casa',
    houseTabReleaseTabTooltip: 'Salir del modo tab — el tab sigue abierto',
    houseTabModeBlockedPendingPayment: 'Complete o cancele el pago pendiente del tab antes de entrar al modo tab de casa',
    houseTabModeBlockedPendingCredit: 'Complete o cancele el crédito pendiente del tab antes de entrar al modo tab de casa',
    houseTabModeBlockedBarTabActive: 'Salga del modo cuenta de bar antes de iniciar el modo cuenta de casa',
    houseTabOnTabSection: 'En el tab',
    houseTabNewItemsSection: 'Artículos nuevos',
    houseTabLedgerLoading: 'Cargando tab…',
    houseTabCloseOutAdding: 'Agregando artículos al tab…',
    houseTabCloseOutCollecting: 'Cobrando…',
    houseTabCloseOutNoBalance: 'El saldo del tab ya es cero',
    houseTabCloseOutFailed: 'No se pudo pagar el tab de casa',
    houseTabCloseOutCashTooltip: 'Cargue artículos nuevos (si hay) y aplique un pago en efectivo a la cuenta (parcial o total)',
    houseTabCloseOutCardTooltip: 'Cargue artículos nuevos (si hay) y aplique un pago con tarjeta a la cuenta (parcial o total)',
    houseTabCloseOutSplitTooltip: 'Cargue artículos nuevos (si hay) y aplique un pago dividido a la cuenta (parcial o total)',
    tabPaymentAmountLabel: 'Monto del pago',
    tabPaymentAmountHint: 'Saldo pendiente: ${max}',
    tabPaymentCashRoundingHint: 'Saldo pendiente: ${balance} · Efectivo a cobrar: ${cashDue}',
    tabPaymentAmountRequired: 'Ingrese un monto de pago mayor que cero',
    tabPaymentCashBelowRoundedDue: 'El monto debe ser al menos ${min} con redondeo de centavos',
    tabPaymentAmountExceedsBalance: 'El pago no puede superar ${max}',
    houseTabMoreActions: 'Más',
    houseTabPrintTab: 'Imprimir cuenta',
    houseTabPrintTabSuccess: 'Estado de cuenta enviado a la impresora',
    houseTabPrintTabFailed: 'No se pudo imprimir el estado de cuenta',
    houseTabTotal: 'Saldo del tab',
    houseTabPickerTitle: 'Abrir tab de casa',
    houseTabPickerSubtitle: 'Seleccione un cliente con un tab de casa abierto',
    houseTabPickerFilterPlaceholder: 'Buscar clientes con tabs de casa',
    houseTabPickerEmpty: 'No hay clientes con tabs de casa abiertos en esta ubicación',
    houseTabPickerNoTabForCustomer: 'Este cliente no tiene un tab de casa abierto',
    houseTabPickerSegmentCustomers: 'Clientes',
    houseTabPickerSegmentGroupTabs: 'Tabs de grupo',
    houseTabPickerGroupTabsTitle: 'Tabs de casa de grupo',
    houseTabPickerGroupTabsSubtitle: 'Elige un tab de grupo y luego quién compra',
    houseTabPickerGroupTabsFilterPlaceholder: 'Buscar nombre o teléfono del grupo',
    houseTabPickerGroupTabsEmpty: 'No hay tabs de casa de grupo abiertos en esta ubicación',
    houseTabGroupMembersTitle: '¿Quién compra?',
    houseTabGroupMembersSubtitle: 'Cargo a {group} en nombre de un miembro',
    houseTabGroupMembersSubtitleGeneric: 'Selecciona un miembro del grupo para este cargo',
    houseTabGroupMembersFilterPlaceholder: 'Buscar miembros del grupo',
    houseTabGroupMembersEmpty: 'No se encontraron miembros para este grupo',
    houseTabGroupMembersLoadFailed: 'No se pudieron cargar los miembros del grupo',
    houseTabParticipantSyncFailed: 'No se pudo agregar este miembro al tab de grupo',
    houseTabGroupTabLine: 'Tab #{id}',
    houseTabGroupFallbackName: 'Grupo #{id}',
    houseTabGroupUnknown: 'Tab de grupo',
    houseTabTargetPickerTitle: '¿A qué tab cargar?',
    houseTabTargetPickerSubtitle: 'Cuenta personal o de grupo para {name}',
    houseTabTargetPersonal: 'Personal',
    houseTabTargetPersonalOpen: 'Tab de casa personal abierto',
    houseTabTargetPersonalNew: 'Abre un nuevo tab de casa personal',
    suspendBlockedHouseTabMode: 'Salga del modo tab de casa o complete el cobro antes de suspender',
    tabOnTabSection: 'En el tab',
    tabLedgerLoading: 'Cargando tab…',
    tabLedgerUnsaved: 'sin guardar',
    registerTabsBalanceSummary: '{count} abiertas · {amount} {currency}',
    registerTabsCreditDisplay: 'Cr {amount}',
    registerTabActionsTitle: 'Acciones de cuenta',
    registerTabActionsHint:
      'Cobra esta venta a la cuenta del cliente, agrega crédito prepago o paga un saldo existente.',
    registerTabActionsOpenList: 'Cuentas abiertas',
    registerTabLine: 'Cuenta #{id} · {owner}',
    registerTabChargeNeedItems: 'Agrega al menos una línea al carrito para cobrar a una cuenta.',
    registerTabPaySelectCustomer: 'Selecciona un cliente para administrar cuentas abiertas.',
    registerTabPayNeedEmptyCart:
      'Vacía el carrito antes de pagar una cuenta. Los pagos de cuenta se procesan por separado.',
    registerTabPayPending:
      'Ya hay un pago de cuenta pendiente. Complétalo o cancélalo antes de iniciar otro.',
    registerTabCreditPending:
      'Ya hay un crédito de cuenta pendiente. Complétalo o cancélalo antes de iniciar otro.',
    registerTabCreditNeedEmptyCart:
      'Vacía el carrito antes de agregar crédito. Los prepagos se procesan por separado.',
    addTabCredit: 'Agregar crédito',
    addTabCreditTitle: 'Agregar crédito a cuenta',
    addTabCreditHint:
      'Registra un prepago en la cuenta del cliente. Completa el cobro con efectivo o tarjeta para aplicar el crédito.',
    createNewTabForCredit: 'Crear cuenta nueva',
    tabCreditAmount: 'Monto del crédito',
    tabCreditDescription: 'Descripción (opcional)',
    tabCreditPreviewLabel: 'Cuenta seleccionada',
    tabCreditAvailable: 'Crédito en cuenta: {amount}',
    tabLineBalanceOnly: 'Saldo {balance}',
    tabLineBalanceAndCredit: 'Saldo {balance} · Crédito {credit}',
    tabLineCreditOnly: 'Crédito {credit}',
    queueTabCredit: 'Encolar crédito',
    tabCreditQueued: 'Crédito encolado. Usa Efectivo o Tarjeta para completar el pago.',
    tabPaymentQueued: 'Pago de cuenta encolado. Usa Efectivo o Tarjeta para completar el pago.',
    tabCreditAppliedSuccess: 'Crédito de cuenta aplicado correctamente',
    tabCreditAppliedFailed: 'El pago se registró, pero no se pudo aplicar como crédito de cuenta. Comuníquese con soporte con el número de venta.',
    tabPaymentAppliedSuccess: 'Pago de cuenta aplicado correctamente',
    tabPaymentItemizedPrintTitle: '¿Imprimir lista de artículos de la cuenta?',
    tabPaymentItemizedPrintMessage: '¿Imprimir una lista detallada de todos los cargos de esta cuenta?',
    tabPaymentItemizedPrintYes: 'Imprimir lista',
    tabPaymentItemizedPrintNo: 'Omitir',
    tabLinkageRecoveryTitle: 'Error al vincular cuenta — pago registrado',
    tabLinkageRecoveryBody: 'La venta #{saleId} se registró pero no se pudo vincular a la cuenta #{tabId}. Reintente el enlace o contacte soporte si persiste.',
    tabLinkageRecoveryHint: 'El pago se registró (Venta #{saleId}) pero no se pudo vincular a la cuenta. Use Reintentar enlace abajo.',
    tabLinkageRetry: 'Reintentar enlace a cuenta',
    dismiss: 'Descartar',
    payInvoice: 'Pagar factura',
    payInvoiceDialogHint:
      'Seleccione una o más facturas abiertas y cobre en caja (efectivo, tarjeta u otro).',
    pendingInvoicePayment: 'Pago de factura pendiente',
    invoicePaymentQueued: 'Pago de factura en cola. Use Efectivo o Tarjeta para completar.',
    invoicePaymentAppliedSuccess: 'Pago de factura aplicado correctamente',
    registerInvoicePayPending: 'Termine o cancele el pago de factura pendiente primero.',
    noOpenInvoices: 'No hay facturas abiertas para este cliente.',
    invoiceLinkageRecoveryTitle: 'Enlace de factura falló — pago registrado',
    invoiceLinkageRecoveryBody: 'La venta #{saleId} se registró pero no se pudo aplicar a la(s) factura(s). Reintente o contacte soporte.',
    invoiceLinkageRecoveryHint: 'El pago (Venta #{saleId}) no se pudo aplicar a la(s) factura(s). Use Reintentar abajo.',
    invoiceLinkageRetry: 'Reintentar enlace a factura(s)',
    payAtRegister: 'Pagar en caja',
    pendingTabCredit: 'Crédito de cuenta pendiente',
    payCloseTab: 'Pagar / Cerrar cuenta',
    payTabDialogHint:
      'Selecciona una cuenta abierta y registra un pago en caja (efectivo, tarjeta u otro). Esto reduce el saldo y puede cerrar la cuenta cuando esté pagada.',
    payTabBalancePreview: 'Saldo pendiente',
    or: 'o',
    barcodeNotFound: 'Código de barras no encontrado',
    alsoIngestImage: 'También incorporar imagen del producto a la galería',
    quickCreateInstead: 'Creación rápida en su lugar',
    lookUpProduct: 'Buscar producto',
    importAddToCart: 'Importar y agregar al carrito',
    openTabsForCustomer: 'Cuentas abiertas del cliente',
    noOpenTabs: 'No hay cuentas abiertas para este cliente',
    paymentAmount: 'Monto del pago',
    closeTabAuto: 'Cerrar cuenta automáticamente si esto paga el saldo por completo',
    applyPayment: 'Aplicar pago',
    close: 'Cerrar',
    email: 'Correo',
    text: 'Texto',
    send: 'Enviar',
    dropHere: 'Soltar aquí',
    cellColor: 'Color de celda',
    clearColor: 'Borrar color',
    gridEditorHint: 'Arrastra elementos de los selectores a las celdas para configurar el diseño inicial de la cuadrícula.',
    gridEditorGlobalHint: 'Los cambios se aplican a la Cuadrícula global para todos los usuarios de esta cuenta.',
    gridEditorUserScope: 'Editando: Mi cuadrícula',
    gridEditorGlobalScope: 'Editando: Cuadrícula global (todos los usuarios)',
    gridEditorRoot: 'Cuadrícula raíz',
    gridEditorGroups: 'Grupos',
    gridEditorPresets: 'Preajustes',
    gridEditorPresetsDragHint: 'Arrastra un preajuste a la cuadrícula. Créalos con el botón copiar en un producto.',
    gridEditorPresetsEmpty: 'Aún no hay preajustes. Usa el botón copiar en un producto para crear uno.',
    gridEditorClonePreset: 'Crear preajuste',
    gridEditorEditPreset: 'Editar preajuste',
    gridEditorPresetCreated: 'Preajuste guardado. Arrástralo desde la lista de Preajustes a la cuadrícula.',
    gridEditorDeletePreset: 'Eliminar preajuste',
    gridEditorPresetDisplayName: 'Nombre para mostrar',
    gridEditorPresetFeeMode: 'Comisión por conveniencia',
    gridEditorPresetFeeModeHint: 'Si la comisión con tarjeta aplica cuando se registra este preajuste.',
    gridEditorPresetLinkedProduct: 'Producto: {name}',
    gridEditorPresetDialogConfirm: 'Guardar preajuste',
    gridEditorPresetDialogCreateTitle: 'Nuevo preajuste de producto',
    gridEditorPresetDialogEditTitle: 'Editar preajuste de producto',
    gridEditorPresetDialogDeleteTitle: '¿Eliminar preajuste?',
    gridEditorPresetDialogDeleteMessage: 'Esto quita el preajuste del diseño. Las casillas que lo usen se borrarán al guardar.',
    gridEditorNewGroup: 'Nuevo grupo',
    gridEditorNewGroupDragHint: 'Arrastra a una celda vacía de la cuadrícula para crear y configurar un grupo.',
    gridEditorCategoryContents: 'Contenido de {name}',
    gridEditorCategorySpatialHint: 'Arrastra categorías y productos desde los selectores a las celdas de la cuadrícula.',
    gridEditorCategoryDefaultHint: 'Sin diseño personalizado: el registro usa el orden automático del catálogo. Arrastra elementos aquí para personalizar.',
    gridEditorResetCategoryLayout: 'Restablecer predeterminado',
    gridEditorResetCategoryLayoutDone: 'Diseño de categoría restablecido. El registro usará el orden del catálogo.',
    gridEditorGroupContents: 'Contenido del grupo',
    gridEditorGroupName: 'Nombre del grupo',
    gridEditorGroupIcon: 'Icono',
    gridEditorGroupIconHint: 'Busca o elige un icono para este grupo.',
    gridEditorGroupIconSearchPlaceholder: 'Buscar iconos (p. ej. cerveza, comida, estrella…)',
    gridEditorGroupIconNoResults: 'Ningún icono coincide con tu búsqueda.',
    gridEditorGroupIconCurrent: 'Icono actual',
    gridEditorGroupIconCustom: 'Icono personalizado',
    gridEditorGroupIcons: {
      folder: 'Carpeta',
      star: 'Estrella',
      grade: 'Mejor valorado',
      hot: 'Popular',
      quick: 'Acceso rápido',
      favorite: 'Favorito',
      bar: 'Bar / cerveza',
      sportsBar: 'Bar deportivo',
      cafe: 'Café',
      softDrink: 'Refresco',
      wine: 'Vino',
      restaurant: 'Restaurante',
      fastFood: 'Comida rápida',
      lunch: 'Almuerzo',
      dinner: 'Cena',
      breakfast: 'Desayuno',
      bakery: 'Panadería',
      cake: 'Pastel / postre',
      iceCream: 'Helado',
      pizza: 'Pizza',
      ramen: 'Ramen / fideos',
      combo: 'Combo / especial',
      grill: 'Parrilla / BBQ',
      foodDrink: 'Comida y bebida',
      water: 'Agua',
      basket: 'Canasta / mercado',
      cart: 'Carrito',
      store: 'Tienda',
      inventory: 'Inventario',
      category: 'Categoría',
      label: 'Etiqueta',
      deal: 'Oferta',
      percent: 'Descuento',
      gift: 'Regalo',
      giftCard: 'Tarjeta regalo',
      people: 'Personas / fiesta',
      celebration: 'Celebración',
      event: 'Evento',
      sunny: 'Terraza / sol',
      nightlife: 'Vida nocturna',
      spa: 'Spa / bienestar',
      pets: 'Mascotas',
      kids: 'Niños',
      schedule: 'Horario',
      time: 'Hora'
    },
    gridEditorDeleteGroup: 'Eliminar grupo',
    gridEditorGroupDialogCreateTitle: 'Nuevo grupo',
    gridEditorGroupDialogEditTitle: 'Editar grupo',
    gridEditorGroupDialogCreateHint: 'Nombra tu grupo y luego organiza los mosaicos en su cuadrícula.',
    gridEditorGroupDialogConfirm: 'OK',
    gridEditorGroupDialogDeleteTitle: '¿Eliminar grupo?',
    gridEditorGroupDialogDeleteMessage: 'Esto elimina el grupo y su mosaico de la cuadrícula raíz.',
    gridEditorGroupSpatialHint: 'Arrastra categorías y productos desde los selectores a las celdas de la cuadrícula.',
    gridEditorOrderedListHint: 'Arrastra para reordenar subcategorías y productos. El orden se guarda con la cuadrícula.',
    gridEditorEmptyCategoryOrder: 'Sin elementos. Añade categorías o productos desde los selectores.',
    gridEditorEmptyGroup: 'Sin elementos. Arrastra categorías o productos desde los selectores.',
    gridEditorSaved: 'Diseño de cuadrícula guardado',
    gridEditorSaveFailed: 'No se pudo guardar el diseño de cuadrícula',
    globalGridViewOnlyHint: 'La Cuadrícula global es compartida. Pide a un gerente que la personalice.',
    pickers: 'Selectores',
    categories: 'Categorías',
    products: 'Productos',
    searchProductsPlaceholder: 'Buscar productos',
    cancel: 'Cancelar',
    discountCannotBeNegative: 'El descuento no puede ser negativo',
    lineDiscountSyncFailed: 'No se pudo guardar el descuento de línea. Inténtelo de nuevo.',
    astroCircuitOpen: 'Astro no está disponible temporalmente. No enviaremos hasta que el servicio se recupere.',
    ptsEach: 'pts c/u',
    nonTaxable: 'No gravable',
    pointsCannotBeNegative: 'Los puntos no pueden ser negativos',
    cannotRedeemMorePoints: 'No se pueden canjear más puntos de los disponibles',
    suspendSale: 'Suspender',
    resumeSale: 'Reanudar',
    clearSale: 'Vaciar venta',
    clearSaleDisabledEmptyCart: 'Agregue artículos al carrito antes de vaciar',
    clearSaleDisabledBusy: 'Espere a que termine la acción actual',
    cartActionsMenu: 'Acciones del carrito',
    cartActionsMenuTooltip: 'Más acciones del carrito',
    suspendOk: 'Venta suspendida',
    suspendFailed: 'No se pudo suspender la venta',
    resumeOk: 'Venta reanudada',
    resumeFailed: 'No se pudo reanudar la venta',
    suspendedLines: 'Líneas',
    suspendedAt: 'Suspendido',
    suspendedRegister: 'Caja',
    resumeSuspendedTitle: 'Reanudar venta suspendida',
    resumeSuspendedScopeLocationHint:
      'Estas ventas pueden provenir de cualquier caja en esta ubicación - confirme la columna de caja antes de reanudar.',
    suspendedPickerEmpty: 'No hay ventas suspendidas para esta caja',
    suspendedPickerFilterPlaceholder: 'Buscar por cliente, usuario, caja o nota',
    suspendedPickerFilterEmpty: 'Ninguna venta suspendida coincide con la búsqueda',
    clearSaleTitle: '¿Vaciar venta?',
    clearSaleMessage:
      'Se vacía el carrito en el servidor, se quita un pago de cuenta pendiente en esta caja y se restablece el contexto de citas. Esta acción no se puede deshacer.',
    clearSaleConfirm: 'Vaciar',
    clearSaleDone: 'Venta vaciada',
    clearSaleFailed: 'No se pudo vaciar la venta',
    suspendNeedRegister: 'Seleccione una caja abierta primero',
    suspendNeedItems: 'Agregue artículos al carrito antes de suspender',
    suspendBlockedPendingTab: 'Complete o cancele el pago de cuenta pendiente antes de suspender',
    suspendBlockedScheduling: 'Termine o cancele la venta de citas antes de suspender',
    resumeNeedRegister: 'Seleccione una caja abierta primero',
    resumeNeedEmptyCart: 'El carrito debe estar vacío para reanudar - use Vaciar venta si lo necesita',
    resumeBlockedPendingTab: 'Complete o cancele el pago de cuenta pendiente antes de reanudar',
    resumeBlockedScheduling: 'Termine o cancele el contexto de citas antes de reanudar',
    suspendedListFailed: 'No se pudieron cargar las ventas suspendidas',
    resumeCartNotEmpty: 'El carrito debe estar vacío para reanudar',
    resumeRouteNeedEmptyCart: 'Vacíe el carrito antes de reanudar una venta suspendida',
    suspendedPickerSubtitle: 'Toque una fila para reanudar, o use Reanudar / Eliminar a la derecha.',
    suspendedPickerSuspendedBy: 'Suspendido por {name}',
    suspendedPickerMetaTime: 'Fecha',
    suspendedPickerMetaStaff: 'Usuario',
    suspendedPickerMetaCustomer: 'Cliente',
    suspendedPickerCustomerId: 'Cliente #{id}',
    suspendedPickerLineItems: 'Artículos en esta reserva',
    suspendedPickerMoreLines: '+{count} línea(s) más no mostradas',
    suspendedPickerDelete: 'Eliminar',
    suspendedPickerDeleteTitle: '¿Eliminar venta suspendida?',
    suspendedPickerDeleteMessage: '¿Quitar la reserva n.º {id}? Esta acción no se puede deshacer.',
    suspendedPickerDeleteDone: 'Venta suspendida eliminada',
    suspendedPickerDeleteFailed: 'No se pudo eliminar la venta suspendida',
    suspendedPickerCheckedOut: 'Abierta en otro sitio',
    suspendedTakeoverTitle: 'Venta abierta en otra ventana',
    suspendedTakeoverMessage: 'Esta reserva está activa en otra pestaña o dispositivo del POS. Toma el control para cargarla aquí y vaciar el carrito en vivo de la otra sesión.',
    suspendedTakeoverConfirm: 'Tomar control',
    suspendedAbandonForceTitle: '¿Forzar eliminación de la reserva?',
    suspendedAbandonForceMessage: 'Esta venta está activa en otro sitio. Eliminarla vaciará el carrito abierto de la otra sesión para esa reserva.',
    suspendedAbandonForceConfirm: 'Eliminar de todas formas',
    suspendedPickerOrderDiscountPct: 'Descuento de venta · {pct}%',
    suspendedPickerOrderDiscountFixed: 'Descuento de venta · ${amt}',
    suspendNoteTitle: 'Suspender venta',
    suspendNoteMessage: 'Agrega una nota opcional para encontrar esta venta más tarde.',
    suspendedSaleNoteLabel: 'Nota',
    suspendedSaleNotePlaceholder: 'p. ej. chaqueta azul, nombre del cliente, mesa…',
    suspendedSaleNoteEdit: 'Nota',
    suspendedSaleNoteSave: 'Guardar nota',
    suspendedSaleNoteUpdateOk: 'Nota guardada',
    suspendedSaleNoteUpdateFailed: 'No se pudo guardar la nota',
    suspendedPickerLayoutList: 'Lista',
    suspendedPickerLayoutGrid: 'Cuadrícula',
    suspendedPickerLayoutToggle: 'Disposición de ventas suspendidas',
    browseCustomers: 'Explorar clientes',
    customerGridTitle: 'Seleccionar cliente',
    customerGridSubtitle: 'Desplácese y toque un cliente para asociarlo a esta venta.',
    customerGridFilterPlaceholder: 'Filtrar por nombre, correo o teléfono',
    customerGridEmpty: 'No se encontraron clientes',
    customerGridLoadFailed: 'No se pudieron cargar los clientes',
    customerGridOpenTabs: '{count} cuentas abiertas · {balance}',
    customerGridTabLine: '{name} · {summary}'
  },
  products: {
    title: 'Productos',
    subtitle: 'Administrar productos, precios y disponibilidad',
    manageModifiers: 'Administrar modificadores',
    manageCategories: 'Administrar categorías',
    newProduct: 'Nuevo producto',
    search: 'Buscar',
    searchPlaceholder: 'Nombre, código de barras…',
    searchHint: 'Búsqueda en servidor (coincide con resultados del backend)',
    category: 'Categoría',
    uncategorized: 'Sin categoría',
    uncategorizedFilterHint: 'Productos sin categoría o aún asignados a Sin categoría',
    showArchived: 'Mostrar archivados',
    lowStockOnly: 'Solo bajo stock',
    apply: 'Aplicar',
    clear: 'Limpiar',
    editProduct: 'Editar producto',
    adjustPricing: 'Ajustar precios',
    justTCGFeed: 'Feed JustTCG',
    pricingHistory: 'Historial de precios',
    archiveProduct: 'Archivar producto',
    unarchiveProduct: 'Desarchivar producto',
    archived: 'Archivado',
    active: 'Activo',
    justTCGSearch: 'Búsqueda JustTCG (escribe para buscar por nombre de carta)',
    productName: 'Nombre del producto',
    cost: 'Costo',
    costCannotBeNegative: 'El costo no puede ser negativo',
    price: 'Precio',
    profitMargin: 'Margen de ganancia',
    profitAmount: 'Monto de ganancia',
    barcodeOptional: 'Código de barras (opcional)',
    lookUpBarcode: 'Buscar código de barras',
    importedImagePreview: 'Vista previa de imagen importada',
    ingestPreviewImage: 'Incorporar imagen de vista previa',
    currentProductImage: 'Imagen actual del producto',
    manageImages: 'Administrar imágenes',
    quantity: 'Cantidad',
    lowStockThreshold: 'Umbral de bajo stock (predeterminado)',
    description: 'Descripción',
    justTCGPrice: 'Precio JustTCG',
    allowFractionalQuantities: 'Permitir cantidades fraccionarias',
    ringByAmount: 'Vender por monto',
    ringByAmountHint: 'El cajero ingresa un monto en dólares en la caja (p. ej. combustible). La cantidad se calcula a partir del precio unitario.',
    alwaysEnterQuantity: 'Siempre ingresar cantidad',
    alwaysEnterQuantityHint: 'Solicita la cantidad al cajero cada vez que se agrega este producto en la caja.',
    openPrice: 'Precio abierto',
    openPriceHint: 'El cajero ingresa el precio unitario en la caja (p. ej. comida misc.). El precio y costo de catálogo son opcionales. Cada agregado crea una línea separada.',
    openPriceCatalogPrice: 'Precio de referencia (opcional)',
    priceCannotBeNegative: 'El precio no puede ser negativo',
    priceDecimalsThree: 'Precio unitario con 3 decimales',
    priceDecimalsThreeHint: 'Para combustible u otros artículos con precio al décimo de centavo (p. ej. $3.459). Los totales de venta siguen en centavos.',
    nonTaxable: 'No gravable',
    convenienceFeeMode: 'Comisión por conveniencia',
    convenienceFeeModeInherit: 'Heredar de la categoría',
    convenienceFeeModeApply: 'Aplicar comisión',
    convenienceFeeModeExempt: 'Exento de comisión',
    convenienceFeeModeHint: 'Anula la configuración de la categoría para este producto cuando se establece.',
    nonStockProduct: 'Producto sin stock',
    includeInGrid: 'Incluir en cuadrícula de caja',
    includeInGridHint: 'Muestra este producto al entrar en su categoría en la caja. Se ignora cuando la categoría tiene activado "Incluir todos los productos en la cuadrícula de caja". No afecta a los productos colocados directamente en la cuadrícula.',
    visibleOnStore: 'Mostrar en Blu Store',
    visibleOnStoreHint: 'Publica este producto en la tienda retail cuando Blu Store está activo. Requiere un slug de URL.',
    storeSlug: 'Slug de URL de tienda',
    storeSlugHint: 'Segmento de ruta en minúsculas para /products/{slug}. Déjelo vacío para generarlo desde el nombre cuando esté visible en la tienda.',
    storeBrand: 'Marca',
    storeBrandHint: 'Opcional. Se usa para filtrar por marca en Blu Store cuando está en el producto padre.',
    storeCompareAt: 'Precio comparativo en tienda',
    storeCompareAtHint: 'Opcional. Tachado solo en Blu Store. No cambia el precio original del POS ni el precio en caja.',
    storeVariantsTitle: 'Variantes de tienda',
    storeVariantsHint: 'Opciones de un solo nivel (talla/color u otras) para Blu Store. Cada variante es un SKU vendible — use el campo de código de barras; la tienda lo expone como SKU.',
    storeVariantsLoading: 'Cargando variantes…',
    storeVariantsOptionAxes: 'Claves de opción',
    storeVariantsAddAxis: 'Agregar clave',
    storeVariantsBarcodeSku: 'Código de barras (SKU tienda)',
    storeVariantsBarcodeSkuLabel: 'SKU de tienda / código de barras',
    storeVariantsBarcodeSkuHelp: 'Opcional. Se guarda como código de barras del producto; Blu Store lo muestra como SKU de la variante.',
    storeVariantsBarcodeSkuHint: 'SKU en la tienda (opcional)',
    storeVariantsReordering: 'Guardando orden de variantes…',
    storeVariantsReorderFailed: 'No se pudo guardar el orden de variantes',
    storeVariantsAddRow: 'Agregar variante',
    storeVariantsActions: 'Acciones',
    storeVariantsSaved: 'Variante guardada',
    storeVariantsSaveFailed: 'No se pudo guardar la variante',
    storeVariantsRemoved: 'Variante archivada',
    storeVariantsRemoveFailed: 'No se pudo archivar la variante',
    storeVariantsLoadFailed: 'No se pudieron cargar las variantes',
    storeVariantsOptionsRequired: 'Ingrese al menos un valor de opción',
    storeVariantsFillAllAxes: 'Complete todas las columnas de opción para esta variante',
    storeVariantsNewVariant: 'Variante',
    storeVariantsSaveParentFirst: 'Guarde el producto primero y luego agregue variantes de tienda.',
    storeVariantsEnable: 'Administrar variantes de tienda',
    storeVariantsManage: 'Administrar variantes de tienda',
    storeVariantsManageHint: 'Abra la matriz dedicada de variantes (tallas, SKU, inventario) para Blu Store.',
    storeVariantsManageOnParent: 'Administrar variantes en el producto padre',
    storeVariantsPageTitle: 'Variantes de tienda',
    storeVariantsBackToProducts: 'Volver a productos',
    storeVariantsEditParent: 'Editar producto padre',
    storeVariantsLoadingParent: 'Cargando producto…',
    storeVariantsLoadParentFailed: 'No se pudo cargar este producto',
    storeVariantsInvalidProduct: 'Producto no válido',
    storeVariantsColumn: 'Variantes de tienda',
    storeVariantsCount: '{count} variantes',
    storeVariantsStockAtsHint: '{sellable} vendibles ({onHand} en existencia, {reserved} en carritos)',
    storeVariantChildBanner: 'Esta fila es una variante de tienda. Edite opciones, precio e inventario en la página de variantes del producto padre.',
    bonusLoyaltyPoints: 'Puntos de fidelidad bonus',
    loyaltyRedemptionSettings: 'Configuración de canje de fidelidad',
    enableLoyaltyRedemption: 'Habilitar canje de fidelidad',
    redemptionCostPoints: 'Costo de canje (puntos)',
    redemptionPreview: 'Vista previa de canje',
    cancel: 'Cancelar',
    save: 'Guardar',
    changeImage: 'Cambiar imagen',
    addImage: 'Agregar imagen',
    removeImage: 'Quitar imagen',
    currentPrice: 'Precio actual',
    lastUpdated: 'Última actualización',
    variant: 'Variante',
    linked: 'Vinculado',
    variantStatistics: 'Estadísticas de variante',
    metric: 'Métrica',
    last7Days: 'Últimos 7 días',
    last30Days: 'Últimos 30 días',
    close: 'Cerrar',
    newCost: 'Nuevo costo',
    newPrice: 'Nuevo precio',
    newProfitMargin: 'Nuevo margen de ganancia',
    newProfitAmount: 'Nuevo monto de ganancia',
    operationType: 'Tipo de operación',
    notesOptional: 'Notas (opcional)',
    updatePricing: 'Actualizar precios',
    priceAdjustment: 'Ajuste de precio',
    costAdjustment: 'Ajuste de costo',
    purchase: 'Compra',
    bulkUpdate: 'Actualización masiva',
    vendorChange: 'Cambio de proveedor',
    marketAdjustment: 'Ajuste de mercado',
    date: 'Fecha',
    oldCost: 'Costo anterior',
    newCostCol: 'Nuevo costo',
    costChange: 'Cambio de costo',
    oldPrice: 'Precio anterior',
    newPriceCol: 'Nuevo precio',
    priceChange: 'Cambio de precio',
    notes: 'Notas',
    taxStatus: 'Estado fiscal',
    stock: 'Stock',
    redemption: 'Canje',
    notRedeemable: 'No canjeable',
    status: 'Estado',
    bonusPoints: 'Puntos bonus',
    tableActions: 'Acciones',
    newProductSubtitle: 'Añade detalles, precios e inventario para un artículo nuevo del catálogo.',
    editProductSubtitle: 'Actualiza campos del catálogo, reglas de fidelidad e imágenes.',
    sectionPricing: 'Precios',
    sectionSelling: 'Venta y stock',
    sectionPhotos: 'Fotos',
    sectionLoyalty: 'Fidelidad',
    adjustPricingSubtitle: 'Establece el costo y precio nuevos y registra cómo debe verse el cambio en el historial.',
    pricingHistorySubtitle: 'Consulta ajustes anteriores de costo y precio para este producto.',
    justFeedDialogSubtitle: 'Estadísticas de mercado y movimiento reciente de precio de JustTCG.',
    justVariantSearchHint: 'Al elegir una variante se completarán automáticamente nombre, descripción y precio.',
    lowStockThresholdHint: 'Se usa en todas las ubicaciones salvo que se sobrescriba por ubicación.',
    loyaltyRedeemToggleHint: 'Permite que los clientes canjeen puntos por este producto.',
    loyaltyRedemptionCostHint: 'Puntos necesarios para canjear este producto.',
    loyaltyBonusHint: 'Puntos bonus por unidad al comprar este producto (0 = usar tasa estándar).',
    redemptionPreviewPoints: 'Los clientes pueden canjear este producto por {points} puntos.',
    redemptionPreviewExample: 'Ejemplo: Con {examplePoints} puntos, un cliente podría canjear {count} unidad(es).',
    noJustPriceHistory: 'No hay historial de precios disponible.',
    noJustData: 'JustTCG no devolvió datos.',
    confirmArchiveTitle: '¿Archivar producto?',
    confirmArchiveMessage: '¿Archivar «{name}»? Podrás desarchivarlo después.',
    confirmArchive: 'Archivar',
    confirmUnarchiveTitle: '¿Desarchivar producto?',
    confirmUnarchiveMessage: '¿Restaurar «{name}» a productos activos?',
    confirmUnarchive: 'Desarchivar',
    archivedSuccess: 'Producto archivado correctamente',
    unarchivedSuccess: 'Producto desarchivado correctamente',
    archiveFailed: 'Error al archivar el producto',
    unarchiveFailed: 'Error al desarchivar el producto',
    galleryTitle: 'Imágenes del producto',
    gallerySubtitle: 'Sube, importa y organiza fotos de portada y de cuadrícula.',
    galleryUploadImage: 'Subir imagen',
    galleryUpload: 'Subir',
    galleryImportUrl: 'Importar URL de imagen',
    galleryImportUpc: 'Importar imagen de vista previa UPC',
    galleryNoImages: 'Aún no hay imágenes.',
    galleryCover: 'Portada',
    galleryGrid: 'Cuadrícula',
    gallerySortOrder: 'Orden',
    galleryDelete: 'Eliminar',
    galleryLoadFailed: 'No se pudieron cargar las imágenes',
    galleryUploadFailed: 'Error al subir',
    galleryImportFailed: 'Error al importar',
    galleryUpdateFailed: 'No se pudo actualizar la imagen',
    galleryDeleteFailed: 'No se pudo eliminar la imagen',
    inventorySetup: 'Configuración de inventario'
  },
  inventorySetup: {
    title: 'Configuración de inventario',
    subtitle: 'Escanea códigos de barras para recibir stock o crear productos rápidamente',
    locationLabel: 'Ubicación: {name}',
    backToProducts: 'Volver a productos',
    scanBarcode: 'Escanear código de barras',
    scanWithCamera: 'Escanear con cámara',
    incrementToggle: 'Incrementar productos existentes (+1)',
    incrementToggleHelp: 'Cuando está activado, escanear un producto del catálogo suma 1 al stock sin abrir el formulario.',
    existingProduct: 'Producto existente',
    newProduct: 'Producto nuevo',
    productName: 'Nombre del producto',
    barcode: 'Código de barras',
    currentStock: 'Stock actual',
    addQuantity: 'Cantidad a agregar',
    initialStock: 'Stock inicial',
    cost: 'Costo',
    price: 'Precio',
    description: 'Descripción',
    importedImagePreview: 'Vista previa de imagen importada',
    importImage: 'Importar imagen del producto',
    clear: 'Limpiar',
    saveAndNext: 'Guardar y siguiente escaneo',
    cancel: 'Cancelar',
    cameraTitle: 'Escanear con cámara',
    cameraHelp: 'Apunta la cámara al código de barras. El escaneo se detiene automáticamente al leer un código.',
    cameraUnavailable: 'La cámara no está disponible en este dispositivo.',
    cameraStartFailed: 'No se pudo iniciar la cámara. Intenta de nuevo o usa un escáner físico.',
    nameRequired: 'El nombre del producto es obligatorio',
    priceRequired: 'El precio debe ser cero o mayor',
    noLocation: 'Selecciona una ubicación antes de recibir inventario.',
    lookupNotFound: 'No se encontró un producto para este código de barras.',
    lookupRateLimit: 'Límite de búsqueda alcanzado. Intenta más tarde.',
    lookupFailed: 'La búsqueda falló. Puedes ingresar los datos manualmente.',
    nonStockIncrementWarning: 'Este producto no tiene stock. Ingresa los datos para continuar.',
    incrementSuccess: '+1 {name} → stock {stock}',
    updatedSuccess: 'Actualizado {name} → stock {stock}',
    createdSuccess: 'Creado: {name}',
    saveFailed: 'No se pudo guardar el producto'
  },
  categories: {
    title: 'Categorías',
    subtitle: 'Organizar productos para navegación, informes y precios',
    newCategory: 'Nueva categoría',
    categoryTree: 'Árbol de categorías',
    details: 'Detalles',
    edit: 'Editar',
    save: 'Guardar',
    cancel: 'Cancelar',
    move: 'Mover',
    delete: 'Eliminar',
    name: 'Nombre',
    slug: 'Slug',
    slugOptional: 'Slug (opcional)',
    active: 'Activo',
    includeAllProductsInGrid: 'Incluir todos los productos en la cuadrícula de caja',
    includeAllProductsInGridHint: 'Cuando está activado, todos los productos de esta categoría aparecen al entrar en la categoría en la caja. Si está desactivado, solo aparecen los productos marcados individualmente como "Incluir en cuadrícula".',
    icon: 'Icono',
    categoryColor: 'Color de categoría',
    clear: 'Limpiar',
    imageUnavailable: 'Imagen no disponible',
    changeImage: 'Cambiar imagen',
    addImage: 'Agregar imagen',
    removeImage: 'Quitar imagen',
    selectCategory: 'Selecciona una categoría para ver los detalles.',
    newCategoryTitle: 'Nueva categoría',
    parentOptional: 'Padre (opcional)',
    create: 'Crear',
    moveCategory: 'Mover categoría',
    newParent: 'Nuevo padre',
    selectImage: 'Seleccionar imagen',
    saveImage: 'Guardar imagen',
    close: 'Cerrar',
    confirmDeleteTitle: 'Eliminar categoría',
    confirmDeleteMessage: '¿Seguro? Esta acción no se puede deshacer.',
    confirmDelete: 'Eliminar',
    finishEditsBeforeSwitch: 'Termina o cancela los cambios antes de cambiar de categoría',
    categoryUpdated: 'Categoría actualizada',
    categoryDeleted: 'Categoría eliminada',
    categoryCreated: 'Categoría creada',
    categoryMoved: 'Categoría movida',
    updateFailed: 'Error al actualizar',
    deleteFailed: 'Error al eliminar',
    moveFailed: 'Error al mover',
    createFailed: 'Error al crear',
    imageSaved: 'Imagen guardada',
    imageSaveFailed: 'No se pudo guardar la imagen',
    slugMaxLength: 'Máximo 64 caracteres',
    slugFormatHint: 'Solo letras minúsculas, números y guiones',
    convenienceFeeMode: 'Comisión por conveniencia',
    convenienceFeeModeInherit: 'Heredar',
    convenienceFeeModeApply: 'Aplicar comisión',
    convenienceFeeModeExempt: 'Exento de comisión',
    convenienceFeeModeHint: 'La comisión con tarjeta solo aplica cuando está activada en la pasarela y esta categoría (o un ancestro) está configurada para aplicarla.'
  },
  modifiers: {
    title: 'Modificadores',
    subtitle: 'Administrar grupos de modificadores, modificadores, plantillas y adjuntos',
    howModifiersWork: 'Cómo funcionan los modificadores',
    newGroup: 'Nuevo grupo',
    newModifier: 'Nuevo modificador',
    newSet: 'Nuevo conjunto',
    groups: 'Grupos',
    modifiers: 'Modificadores',
    sets: 'Conjuntos',
    attachments: 'Adjuntos',
    searchGroups: 'Buscar grupos',
    searchGroupsPlaceholder: 'Nombre, descripción…',
    searchModifiers: 'Buscar modificadores',
    searchModifiersPlaceholder: 'Nombre, código…',
    searchSets: 'Buscar conjuntos',
    searchSetsPlaceholder: 'Nombre…',
    apply: 'Aplicar',
    clear: 'Limpiar',
    noModifierGroupsFound: 'No se encontraron grupos de modificadores',
    noModifiersFound: 'No se encontraron modificadores',
    noSetsFound: 'No se encontraron conjuntos',
    category: 'Categoría',
    product: 'Producto',
    applySetOptional: 'Aplicar conjunto (opcional)',
    load: 'Cargar',
    applySet: 'Aplicar conjunto',
    noGroupsAttached: 'No hay grupos adjuntos',
    addGroup: 'Agregar grupo',
    add: 'Agregar',
    save: 'Guardar',
    directAttachments: 'Adjuntos directos',
    noDirectAttachments: 'No hay adjuntos directos',
    overrides: 'Anulaciones',
    inherit: 'Heredar',
    noOverrides: 'No hay anulaciones',
    addOverrideGroup: 'Agregar grupo de anulación',
    productSearch: 'Producto (buscar)',
    defineGroupSubtitle: 'Definir reglas de selección y valores predeterminados para un grupo de modificadores',
    name: 'Nombre',
    descriptionInternal: 'Descripción (interna)',
    sortOrder: 'Orden',
    visibility: 'Visibilidad',
    active: 'Activo',
    selectionBehavior: 'Comportamiento de selección',
    requiredChooseOne: 'Requerido (el cliente debe elegir uno)',
    minimumSelections: 'Selecciones mínimas',
    noMaximum: 'Sin máximo',
    maximumSelections: 'Selecciones máximas',
    addModifier: 'Agregar modificador',
    noModifiersInGroup: 'Aún no hay modificadores en este grupo',
    modifiersInGroup: 'Modificadores en este grupo',
    cancel: 'Cancelar',
    group: 'Grupo',
    modifier: 'Modificador',
    code: 'Código',
    priceAdjustment: 'Ajuste de precio',
    customModifierPrices: 'Precios personalizados de modificadores',
    customModifierPricesHint:
      'Las anulaciones reemplazan el ajuste de precio del catálogo solo para este producto. Deje vacío para usar el valor del catálogo.',
    catalogDelta: 'Valor del catálogo',
    overrideDelta: 'Anulación',
    overridePlaceholder: 'Anulación (vacío = catálogo)',
    customModifierPricesEmpty:
      'Cargue un producto para ver modificadores. Adjunte grupos a nivel de categoría o producto primero.'
  },
  reports: {
    title: 'Informes',
    subtitle: 'Ejecutar informes y exportar resultados',
    inventoryLogs: 'Registros de inventario',
    pricingLogs: 'Registros de precios',
    reportType: 'Tipo de informe',
    from: 'Desde',
    to: 'Hasta',
    timeWindow: 'Ventana de tiempo',
    categories: 'Categorías',
    allCategories: 'Todas las categorías',
    run: 'Ejecutar',
    clear: 'Limpiar',
    loadFailed: 'No se pudo cargar el informe',
    retry: 'Reintentar',
    results: 'Resultados',
    excel: 'Excel',
    csv: 'CSV',
    pdf: 'PDF',
    salesSummary: 'Resumen de ventas',
    paymentBreakdown: 'Desglose de pagos',
    inventoryDetail: 'Detalle de inventario',
    loyaltySummary: 'Resumen de fidelidad',
    arAging: 'Antigüedad de cuentas por cobrar',
    salesByCategory: 'Ventas por categoría',
    customerPurchaseDetail: 'Detalle de compras por cliente',
    category: 'Categoría',
    products: 'Productos',
    allProducts: 'Todos los productos',
    noMatchingProducts: 'No hay productos coincidentes',
    openProductsDropdown: 'Abra el menú para ver productos',
    selectedProducts: 'Seleccionados',
    moreProducts: '+{count} más',
    uncategorized: 'Sin categoría',
    customerPurchaseDetailPeriod: 'Período: {start} a {end}',
    reportPeriod: 'Período: {period}',
    noRows: 'No hay filas para este informe.',
    columns: {
      date: 'Fecha',
      period: 'Período',
      total_sales: 'Total de ventas',
      total_revenue: 'Ingresos totales',
      goods_and_tips_total: 'Bienes + propinas',
      tip_total: 'Propinas',
      tax_total: 'Impuesto',
      cash_payment_total: 'Pago en efectivo',
      card_payment_total: 'Pago con tarjeta',
      convenience_fee_total: 'Tarifa de conveniencia',
      payment_method: 'Método de pago',
      total_payments: 'Total de pagos',
      total_amount: 'Importe total',
      cash_total: 'Total en efectivo',
      product_id: 'ID de producto',
      product_name: 'Producto',
      sku: 'SKU',
      starting_inventory: 'Inventario inicial',
      ending_inventory: 'Inventario final',
      net_movement: 'Movimiento neto',
      stock_in: 'Entrada',
      stock_out: 'Salida',
      unit_price: 'Precio unitario',
      inventory_value: 'Valor de inventario',
      low_stock: 'Stock bajo',
      earned: 'Ganados',
      redeemed: 'Canjeados',
      category_name: 'Categoría',
      quantity_sold: 'Cantidad vendida',
      revenue: 'Ingresos',
      customer_id: 'ID de cliente',
      current: 'Al día',
      d0_30: '1–30 días',
      d31_60: '31–60 días',
      d61_90: '61–90 días',
      d90_plus: 'Más de 90 días'
    },
    grandTotalQuantity: 'Cantidad total',
    grandTotalSubtotal: 'Subtotal total',
    grandTotalTax: 'Impuesto total',
    grandTotalAmount: 'Importe total',
    customerPurchaseDetailEmpty: 'No hay detalle de compras para el período y filtros seleccionados.',
    taxIdCustomersOnly: 'Solo clientes con ID fiscal',
    groupByCustomer: 'Agrupar por cliente',
    colCustomer: 'Cliente',
    colTaxId: 'ID fiscal',
    customerTaxIdCaption: 'ID fiscal: {taxId}',
    customerSubtotal: 'Subtotal del cliente',
    colSaleId: 'Venta #',
    colSaleDate: 'Fecha',
    colProduct: 'Producto',
    colQuantity: 'Cant.',
    colUnitPrice: 'Precio unitario',
    colSubtotal: 'Subtotal',
    colTax: 'Impuesto',
    colTotal: 'Total',
    daily: 'Diario',
    weekly: 'Semanal',
    monthly: 'Mensual',
    suspendedSalesNav: 'Ventas suspendidas',
    suspendedSalesTitle: 'Ventas suspendidas',
    suspendedSalesSubtitle: 'Ventas en espera que aún no se cobran',
    suspendedSalesExportCsv: 'Exportar CSV',
    suspendedSalesGoToRegister: 'Caja registradora',
    suspendedSalesRegisterFilter: 'Caja',
    suspendedSalesScopeLocationHint:
      'Su negocio permite reanudar desde cualquier caja en esta ubicación - la columna Caja indica dónde se guardó cada venta.',
    suspendedSalesEmpty: 'No hay ventas suspendidas',
    suspendedSalesSuspendedBy: 'Suspendido por',
    suspendedSalesCustomer: 'Cliente',
    suspendedSalesCustomerId: 'ID de cliente',
    suspendedSalesAbandon: 'Eliminar',
    suspendedSalesAbandonTitle: '¿Eliminar venta suspendida?',
    suspendedSalesAbandonMessage: '¿Quitar la reserva n.º {id}? Esta acción no se puede deshacer.',
    suspendedSalesAbandonDone: 'Venta suspendida eliminada',
    suspendedSalesAbandonFailed: 'No se pudo eliminar la venta suspendida',
    suspendedSalesLoadFailed: 'No se pudieron cargar las ventas suspendidas',
    suspendedSalesExportStarted: 'Descarga iniciada',
    suspendedSalesExportFailed: 'No se pudo exportar CSV',
    suspendedSalesAbandonNoRegister: 'A esta fila le falta la información de caja',
    suspendedSalesNote: 'Nota'
  },
  dev: {
    mockCardFlowPromptTitle: 'Pago con tarjeta simulado',
    mockCardFlowPromptBody: 'Apruebe para registrar un pago simulado exitoso en su API local. Rechace para cancelar este paso.',
    mockCardFlowApprove: 'Aprobar',
    mockCardFlowDecline: 'Rechazar',
    mockCardFlowDeclined: 'Pago simulado rechazado.',
    mockCardFlowGenericFlow: 'Pago con tarjeta',
    mockCardFlowAmountLine: 'Monto: ${amount}',
    mockCardFlowActiveBanner: 'Flujo simulado activo: los pagos se registran en local; no se usa pasarela.',
    mockCardFlowStepTapToPay: 'Tap to Pay (simulado)',
    mockCardFlowStepTerminal: 'Terminal físico (simulado)',
    mockCardFlowStepKeyed: 'Captura manual (simulado)',
    mockCardFlowStepIntegrated: 'Terminal integrado (simulado)',
    mockCardFlowStepCardOnFile: 'Tarjeta en archivo (simulado)'
  },
  registers: {
    title: 'Registradoras',
    subtitle: 'Administrar registradoras de ventas, estado, terminales y registros de auditoría',
    newRegister: 'Nueva registradora',
    createRegisterTooltip: 'Crear una nueva registradora de ventas',
    openRegisterElsewhere: 'Ya tienes una registradora abierta en',
    closeRegisterFirst: 'Cierra esa registradora (o vuelve a esa ubicación) antes de abrir una nueva.',
    totalRegisters: 'Total de registradoras',
    active: 'Activo',
    currentlyOpen: 'Abierta actualmente',
    available: 'Disponible',
    search: 'Buscar',
    searchPlaceholder: 'Nombre de registradora, etiqueta de terminal…',
    status: 'Estado',
    apply: 'Aplicar',
    clear: 'Limpiar',
    refreshTerminalStatus: 'Actualizar estado de terminal',
    refreshRegisters: 'Actualizar registradoras',
    open: 'Abrir',
    cardReader: 'Lector de tarjetas',
    viewDetails: 'Ver detalles',
    edit: 'Editar',
    closeRegister: 'Cerrar registradora',
    openRegister: 'Abrir registradora',
    manageTerminal: 'Administrar terminal',
    assignTerminal: 'Asignar terminal',
    auditLog: 'Registro de auditoría',
    delete: 'Eliminar',
    noRegistersFound: 'No se encontraron registradoras',
    createFirstRegister: 'Crear primera registradora',
    registerName: 'Nombre de registradora',
    description: 'Descripción',
    cancel: 'Cancelar',
    update: 'Actualizar',
    create: 'Crear',
    registerDetails: 'Detalles de registradora',
    basicInformation: 'Información básica',
    name: 'Nombre',
    location: 'Ubicación',
    currentStatus: 'Estado actual',
    currentUser: 'Usuario actual',
    openedAt: 'Abierto en',
    performanceMetrics: 'Métricas de rendimiento',
    totalSales: 'Ventas totales',
    totalRevenue: 'Ingresos totales',
    avgTransaction: 'Transacción promedio',
    currentTerminal: 'Terminal actual',
    unknown: 'Desconocido',
    unassignTerminal: 'Desasignar terminal',
    assignNewTerminal: 'Asignar nueva terminal',
    selectTerminal: 'Seleccionar terminal',
    close: 'Cerrar',
    auditEntries: 'Entradas de auditoría',
    noAuditEntries: 'No se encontraron entradas de auditoría',
    statusAll: 'Todos',
    statusInactive: 'Inactivo',
    statusMaintenance: 'Mantenimiento',
    cardPaymentMode: 'Enrutamiento de pago con tarjeta',
    cardPaymentModeHint: 'Elija un método exclusivo por caja.',
    cardPaymentModeAlwaysAsk: 'Dejar elegir al cajero',
    cardPaymentModePhysicalTerminalOnly: 'Solo terminal física',
    cardPaymentModeTapOnPhoneOnly: 'Solo pagar tocando el teléfono',
    cardPaymentModeKeyedOnly: 'Solo captura manual de tarjeta',
    cardPaymentModeIntegratedOnly: 'Solo terminal Dejavoo integrada (DvPay Lite)',
    cardPaymentTopDisabledAndroid: 'Para Tap on Phone use la app Android de Blu POS.',
    cardPaymentTopDisabledIpad: 'Tap to Pay en iPhone solo está disponible en un iPhone físico. Use otro método de pago en iPad.',
    cardPaymentTopDisabledDevice: 'Este modelo de iPhone no admite Tap to Pay en iPhone. Use iPhone Xs o posterior.',
    cardPaymentTopDisabledOs: 'Actualice este iPhone a la última versión de iOS para usar Tap to Pay en iPhone.',
    cardPaymentTopDisabledConfig: 'Tap on Phone no está configurado para este comercio.',
    cardPaymentTopDisabledDejavooTerminal: 'Tap on Phone no se usa en terminales de pago Dejavoo. Use el cobro integrado (DvPayLite).',
    cardPaymentIntegratedDisabledWhitelist: 'Agregue este dispositivo a la lista blanca Dejavoo antes de habilitar el cobro integrado.',
    cardPaymentIntegratedDisabledDeviceClass: 'El cobro integrado (DvPayLite) solo está disponible en terminales Dejavoo en la lista blanca.',
    cardPaymentKeyedDisabledGateway: 'La captura manual no está habilitada en su pasarela.',
    cardPaymentKeyedDisabledEcomCapability: 'El terminal asignado no tiene Ecom activado.',
    cardPaymentKeyedDisabledDetail: '{detail}',
    cardPaymentIntegratedDisabledPlatform: 'El cobro integrado requiere la app Android de Blu POS.',
    cardPaymentIntegratedDisabledCapability: 'El terminal asignado no admite cobro integrado (DvPay Lite).',
    cardPaymentPhysicalDisabled: 'Asigne un terminal que pueda aceptar pagos con tarjeta física.',
    cardPaymentModeOptionsFilteredNote: 'Las opciones no disponibles aparecen deshabilitadas con una breve razón.'
  },
  dashboard: {
    title: 'Panel de control',
    subtitle: 'Resultados y análisis de hoy',
    refresh: 'Actualizar',
    iphoneTopBanner: {
      title: 'Tap to Pay en iPhone',
      body: 'Acepte pagos sin contacto en este iPhone—sin lector extra. Complete la configuración única para cobrar en la caja.',
      ctaSetup: 'Configurar Tap to Pay en iPhone',
      ctaAskAdmin: 'Pedir a un gerente',
      learnMore: 'Más información'
    },
    loadFailed: 'No se pudo cargar el panel',
    todaysSales: 'Ventas de hoy',
    percentFromYesterday: 'respecto a ayer',
    productsSold: 'Productos vendidos',
    lowStockItems: 'Artículos con bajo stock',
    needsAttention: 'Requiere atención',
    allGood: 'Todo bien',
    recentSales: 'Ventas recientes',
    lowStock: 'Bajo stock',
    products: 'Productos',
    low: 'Bajo',
    status: 'Estado',
    noSalesYet: 'Aún no hay ventas.',
    noLowStockItems: 'No hay artículos con bajo stock.',
    lowStockOnHand: 'En existencia: {count}',
    lowStockThreshold: 'Umbral: {count}',
    tableSaleNumber: 'Venta #',
    tableDate: 'Fecha',
    tableCustomer: 'Cliente',
    tableTotal: 'Total',
    tableAmount: 'Monto',
    pulse: {
      ordersToday: '{count} pedidos hoy',
      vsLastWeekday: '{percent}% vs el {weekday} pasado',
      updatedAgo: 'Actualizado {time}',
      updatedJustNow: 'Actualizado ahora',
      allClear: 'Todo en orden - no necesitas hacer nada ahora.',
      attentionTitle: 'Requiere atención',
      statusNeedsAttention: '{count} elementos requieren tu atención',
      statusAhead: 'Buen ritmo - {percent}% por encima del {weekday} pasado',
      statusBehind: 'Día más lento - {percent}% por debajo del {weekday} pasado',
      statusEven: 'Similar al {weekday} pasado',
      tiles: {
        registers: 'Cajas',
        registersValue: '{open} de {active} abiertas',
        orderAhead: 'Pedidos anticipados',
        orderAheadWaiting: '{count} en espera',
        orderAheadClear: 'Cola vacía',
        openTabs: 'Cuentas abiertas',
    tabsList: 'Tabs',
        openTabsValue: '{count} · {balance}',
        lowStock: 'Bajo stock',
        lowStockValue: '{count} artículos'
      },
      attention: {
        lowStock: '{name} con bajo stock ({stock} restantes)',
        queueStale: 'Pedido esperando {minutes}+ min',
        noRegistersOpen: 'No hay cajas abiertas',
        openTabLiability: '{count} cuentas abiertas · {balance} pendiente'
      },
      weekdays: {
        monday: 'lunes',
        tuesday: 'martes',
        wednesday: 'miércoles',
        thursday: 'jueves',
        friday: 'viernes',
        saturday: 'sábado',
        sunday: 'domingo'
      },
      rhythmTitle: 'Ritmo de hoy',
      rhythmSubtitle: 'Comparado con el {weekday} pasado',
      chartToday: 'Hoy',
      chartLastWeekday: 'El {weekday} pasado',
      chartRevenue: 'Ingresos',
      chartOrders: 'Pedidos',
      goalProgressLabel: '{today} de {target} hacia la meta de hoy',
      goalRingCaption: 'Meta diaria',
      averageTicket: 'Ticket promedio',
      tipsToday: 'Propinas hoy',
      topSellersTitle: 'Más vendidos hoy',
      topSellerRow: '{rank}. {name} - {quantity}',
      topSellerQuantity: '{quantity} vendidos',
      noSalesYetToday: 'Aún no hay ventas hoy.',
      chartTooltipOrders: '{count} pedidos'
    }
  },
  events: {
    title: 'Eventos',
    subtitle: 'Crear y gestionar eventos e inscripciones',
    createEvent: 'Crear evento',
    editEvent: 'Editar evento',
    formSubtitle: 'Detalles del evento, horario, ubicación y configuración de inscripción',
    detailSubtitle: 'Detalles del evento, enlaces de inscripción e inscritos',
    backToEvents: 'Volver a eventos',
    noEventsFound: 'No se encontraron eventos.',
    view: 'Ver',
    edit: 'Editar',
    unlimited: 'Ilimitado',
    remaining: 'restantes',
    tickets: 'entradas',
    noLimit: 'Sin límite',
    free: 'Gratis',
    titleCol: 'Título',
    start: 'Inicio',
    end: 'Fin',
    status: 'Estado',
    registrants: 'Inscritos',
    capacity: 'Capacidad',
    price: 'Precio',
    copyLink: 'Copiar enlace',
    downloadQr: 'Descargar QR',
    openPublic: 'Abrir público',
    publishToEnableLinks: 'Publica el evento para habilitar enlaces públicos',
    schedule: 'Horario',
    location: 'Ubicación',
    registrationLinks: 'Enlaces de inscripción',
    newLink: 'Nuevo enlace',
    noLinksYet: 'Aún no hay enlaces. El enlace público por slug siempre está disponible.',
    customLink: 'Enlace personalizado',
    ticketPackages: 'Paquetes de entradas',
    newPackage: 'Nuevo paquete',
    exportCsv: 'Exportar CSV',
    addRegistrant: 'Añadir inscrito',
    resend: 'Reenviar',
    refund: 'Reembolsar',
    addRegistrantTitle: 'Añadir inscrito',
    name: 'Nombre',
    email: 'Correo electrónico',
    phone: 'Teléfono',
    cancel: 'Cancelar',
    add: 'Añadir',
    newRegistrationLink: 'Nuevo enlace de inscripción',
    freeLink: 'Enlace gratuito',
    create: 'Crear',
    packageName: 'Nombre',
    description: 'Descripción',
    quantity: 'Cantidad',
    useDefaultTicketPrice: 'Usar precio de entrada por defecto',
    packagePrice: 'Precio del paquete',
    save: 'Guardar',
    deletePackage: 'Eliminar paquete',
    delete: 'Eliminar',
    confirmRefund: 'Confirmar reembolso',
    refundRegistrant: 'Reembolsar inscrito',
    resendRegistrationEmail: 'Reenviar correo de inscripción',
    to: 'Para',
    ccMe: 'En copia a mí',
    send: 'Enviar',
    addressLine1: 'Línea de dirección 1',
    addressLine2: 'Línea de dirección 2',
    city: 'Ciudad',
    stateRegion: 'Estado/Región',
    postalCode: 'Código postal',
    startRequired: 'La hora de inicio es obligatoria',
    capacityHint: 'Obligatorio a menos que marques sin límite',
    noLimitToggle: 'Sin límite',
    showTicketsRemaining: 'Mostrar entradas restantes en la página pública',
    publishHintCapacity: 'Cambia a Borrador y guarda antes de cambiar la capacidad, luego vuelve a publicar.',
    priceHint: 'Obligatorio a menos que marques gratis',
    freeToggle: 'Gratis',
    publishHintPrice: 'Cambia a Borrador y guarda antes de cambiar el precio, luego vuelve a publicar.',
    publishHintPriceCapacity: 'Este evento fue publicado. Cambia a Borrador y guarda antes de cambiar precio/capacidad, luego vuelve a publicar.',
    coverImage: 'Imagen de portada',
    viewCurrent: 'Ver',
    current: 'Actual',
    saveEvent: 'Guardar evento',
    draft: 'Borrador',
    published: 'Publicado',
    cancelled: 'Cancelado',
    loading: 'Cargando...',
    nameRequired: 'El nombre es obligatorio',
    registrantAdded: 'Inscrito añadido',
    registrantRefunded: 'Inscrito reembolsado',
    eventSaved: 'Evento guardado',
    registrationEmailSent: 'Correo de inscripción enviado',
    unableToSendEmail: 'No se pudo enviar el correo de inscripción',
    qty: 'Cant.',
    amount: 'Monto',
    package: 'Paquete',
    registered: 'Inscrito',
    actions: 'Acciones',
    noPackagesYet: 'Aún no hay paquetes.',
    noRegistrantsYet: 'Aún no hay inscritos.',
    manualRegistrationsHint: 'Las inscripciones manuales no cobran; esto es solo para seguimiento de asistencia.',
    editTicketPackage: 'Editar paquete de entradas',
    newTicketPackage: 'Nuevo paquete de entradas',
    defaultTicketPrice: 'Precio de entrada por defecto',
    deletePackageConfirm: '¿Eliminar "{name}"? No se puede deshacer.',
    refundConfirmMessage: 'Reembolsar marcará al inscrito como reembolsado y liberará su lugar. ¿Continuar?',
    refundCannotUndone: 'Los reembolsos no se pueden deshacer aquí; vuelve a inscribir para añadirlos de nuevo.',
    packagePriceHint: 'Si "Usar precio de entrada por defecto" está activado, el precio del paquete se calcula como precio del evento × cantidad.'
  },
  groups: {
    title: 'Grupos',
    subtitle: 'Gestionar grupos de clientes y propiedad',
    detailTitle: 'Perfil del grupo',
    editGroup: 'Editar grupo',
    editGroupTitle: 'Editar grupo',
    editGroupSubtitle: 'Actualice propietario, estado y contacto de facturación',
    noAddressOnFile: 'Sin dirección registrada',
    contactSameAsOwner: 'Facturación y contacto igual que el propietario',
    contactSameAsOwnerHint: 'Al guardar, copiaremos correo, teléfono y dirección del propietario.',
    contactSameAsOwnerPickOwner: 'Elija un propietario para usar sus datos de contacto.',
    contactSameAsOwnerBadge: 'Coincide con el contacto del propietario',
    customContactHint: 'Use un correo, teléfono o dirección de facturación distinto para este grupo.',
    ownerContactIncomplete: 'Este cliente aún no tiene correo, teléfono ni dirección.',
    ownerContactLoadFailed: 'No se pudieron cargar los datos de contacto del propietario',
    newGroup: 'Nuevo grupo',
    searchGroups: 'Buscar grupos',
    searchPlaceholder: 'Buscar por nombre del grupo…',
    activeOnly: 'Solo activos',
    apply: 'Aplicar',
    clear: 'Limpiar',
    loadFailed: 'No se pudieron cargar los grupos',
    retry: 'Reintentar',
    status: 'Estado',
    tableActions: 'Acciones',
    viewGroup: 'Ver grupo',
    noGroupsFound: 'No se encontraron grupos.',
    noGroupsHint: 'Cree un grupo para compartir cuentas y facturación entre clientes.',
    createGroup: 'Crear grupo',
    createGroupSubtitle: 'Elija un propietario — el contacto de facturación sale de su perfil',
    basicDetails: 'Datos básicos',
    ownership: 'Propiedad',
    name: 'Nombre',
    nameOptional: 'Nombre (opcional)',
    notes: 'Notas',
    ownerOptional: 'Propietario (opcional)',
    ownerRequired: 'Se requiere un cliente propietario.',
    createFailed: 'Error al crear el grupo',
    active: 'Activo',
    cancel: 'Cancelar',
    save: 'Guardar',
    membersHint: 'Clientes que pueden usar cuentas bajo este grupo.',
    noMembers: 'Aún no hay miembros. Busque arriba para añadir clientes.',
    removeMember: 'Quitar miembro',
    removeMemberConfirm: '¿Quitar a {name} de este grupo?',
    memberRemoved: 'Miembro quitado',
    unnamedGroup: 'Grupo sin nombre',
    groupId: 'Grupo #',
    inactive: 'Inactivo',
    back: 'Volver',
    contact: 'Contacto',
    website: 'Sitio web',
    address: 'Dirección',
    addressLine1: 'Línea de dirección 1',
    addressLine2: 'Línea de dirección 2',
    city: 'Ciudad',
    stateRegion: 'Estado / Región',
    postalCode: 'Código postal',
    country: 'País',
    owner: 'Propietario',
    members: 'Miembros',
    addMember: 'Añadir miembro',
    add: 'Añadir',
    runningTotals: 'Totales acumulados',
    perMemberTotals: 'Totales acumulados por miembro (cuentas abiertas de grupo)',
    noRunningTotals: 'No hay totales acumulados disponibles.',
    customer: 'Cliente',
    charges: 'Cargos',
    credits: 'Créditos',
    net: 'Neto',
    groupSaved: 'Grupo guardado',
    failedToSaveGroup: 'Error al guardar el grupo',
    viewDevLog: 'Ver registro de desarrollo',
    hideDevLog: 'Ocultar registro de desarrollo',
    billingPortal: {
      title: 'Cuenta de facturación del grupo',
      notEligible: 'Asigne un propietario activo y un correo de facturación para habilitar el portal.',
      missingEmail: 'Agregue un correo de facturación en este grupo para enviar el enlace de acceso.',
      emailConflict: 'Ese correo ya está vinculado a otro cliente. Corrija el duplicado antes de enviar.',
      inactive: 'Active este grupo antes de enviar un enlace de facturación.',
      neverInvited: 'El contacto de facturación puede iniciar sesión para pagar facturas del grupo — aún no se envió enlace.',
      linkSent: 'Enlace enviado — aún no usado',
      linkSentAt: 'Último enlace enviado {date}',
      active: 'El contacto de facturación ya inició sesión en el portal',
      lastSignIn: 'Último acceso {date}',
      sendLink: 'Enviar enlace de cuenta',
      resendLink: 'Reenviar enlace de cuenta',
      sendSuccess: 'Enlace del portal enviado al correo de facturación del grupo.',
      sendFailed: 'No se pudo enviar el enlace del portal.',
      firstInviteTitle: '¿Enviar primer enlace de cuenta?',
      firstInviteMessage: 'Esta dirección de facturación no ha recibido un enlace de grupo antes. Envíelo solo si lo solicitaron. El correo abre la facturación del grupo en Mi cuenta, no es un mensaje promocional.',
      firstInviteConfirm: 'Enviar enlace'
    },
    member: 'Miembro',
    customerId: 'Cliente #'
  },
  tabs: {
    title: 'Cuentas',
    subtitle: 'Monitorear cuentas abiertas y gestionar saldos',
    exportCsv: 'Exportar CSV',
    exportXlsx: 'Exportar Excel',
    export: 'Exportar',
    failedToExportXlsx: 'Error al exportar Excel',
    newTab: 'Nueva cuenta',
    location: 'Ubicación',
    status: 'Estado',
    search: 'Buscar',
    searchPlaceholder: 'Cliente, grupo o cuenta #',
    apply: 'Aplicar',
    clear: 'Limpiar',
    creditDisplay: 'Cr {amount}',
    openTabs: 'Cuentas abiertas',
    tabsList: 'Tabs',
    viewTab: 'Ver cuenta',
    payTabAtRegister: 'Pagar cuenta en caja',
    tab: 'Cuenta',
    tabNumber: 'Cuenta #{id}',
    moreActions: 'Más',
    addEntrySubtitle: 'Cargo, crédito o ajuste',
    entryType: 'Tipo de entrada',
    entryTypeCharge: 'Cargo a cuenta',
    entryTypeCredit: 'Crédito / pago',
    entryTypeAdjustment: 'Ajuste',
    amountLabel: 'Monto',
    amountHint: 'Requerido — monto a cargar o acreditar',
    amountRequired: 'El monto es obligatorio.',
    taxOptional: 'Impuesto (opcional)',
    quantity: 'Cantidad',
    description: 'Descripción',
    chargeToTabTitle: 'Cargo a cuenta',
    chargeToTabHint: 'Elige una cuenta abierta o crea una nueva',
    selectExistingTab: 'Seleccionar cuenta existente',
    chooseOpenTab: 'Elegir una cuenta abierta',
    openTabsCustomerHint: 'Solo se listan las cuentas abiertas de este cliente.',
    createNewTab: 'Crear cuenta nueva',
    chargeAmount: 'Monto del cargo',
    cartTotal: 'Total del carrito',
    chargeSelectedTab: 'Cargar a cuenta seleccionada',
    createTabAndCharge: 'Crear cuenta y cargar',
    posChargeDefault: 'Cargo POS',
    customerLabel: 'Cliente',
    customerNumber: 'Cliente #{id}',
    generateLinkTitle: 'Generar enlace de pago',
    generateLinkSubtitle: 'El enlace vence en 7 días',
    generateLinkFailed: 'No se pudo generar el enlace',
    maxPaymentOptional: 'Monto máximo de pago (opcional)',
    linkClickCopy: 'Enlace (clic para copiar)',
    clickToCopy: 'Clic para copiar',
    copied: '¡Copiado!',
    copyFailed: 'Error al copiar',
    copyNotSupported: 'Copia no compatible',
    copySecureContextRequired: 'El portapapeles requiere un contexto seguro (HTTPS).',
    copyManual: 'No se pudo copiar. Copia manualmente.',
    linkCopied: 'Enlace de pago copiado al portapapeles.',
    generate: 'Generar',
    close: 'Cerrar',
    emailLinkTitle: 'Enviar enlace de pago por correo',
    recipientEmail: 'Correo del destinatario',
    recipientEmailRequired: 'El correo del destinatario es obligatorio.',
    subjectOptional: 'Asunto (opcional)',
    send: 'Enviar',
    emailLinkSent: 'Enlace de pago enviado por correo.',
    emailLinkFailed: 'No se pudo enviar el enlace de pago.',
    ledgerWhen: 'Cuándo',
    ledgerType: 'Tipo',
    ledgerCustomer: 'Cliente',
    ledgerDescription: 'Descripción',
    ledgerQty: 'Cant.',
    ledgerAmount: 'Monto',
    ledgerStatus: 'Estado',
    ledgerVoided: 'Anulado',
    voidEntry: 'Anular',
    restoreEntry: 'Restaurar',
    voidEntryConfirmTitle: '¿Anular entrada del libro mayor?',
    voidEntryConfirmMessage: 'Esta entrada se excluirá de los totales de la cuenta pero permanecerá en el libro mayor para auditoría.',
    restoreEntryConfirmTitle: '¿Restaurar entrada del libro mayor?',
    restoreEntryConfirmMessage: 'Esta entrada volverá a contar en los totales de la cuenta.',
    voidEntrySuccess: 'Entrada anulada.',
    voidEntryFailed: 'No se pudo anular la entrada.',
    restoreEntrySuccess: 'Entrada restaurada.',
    restoreEntryFailed: 'No se pudo restaurar la entrada.',
    owner: 'Propietario',
    people: 'Personas',
    opened: 'Abierta',
    lastActivity: 'Última actividad',
    currentTotal: 'Total actual',
    payments: 'Pagos',
    balance: 'Saldo',
    daysOpen: 'Días abierta',
    actions: 'Acciones',
    group: 'Grupo',
    customer: 'Cliente',
    allLocations: 'Todas las ubicaciones',
    all: 'Todas',
    open: 'Abierta',
    closed: 'Cerrada',
    suspended: 'Suspendida',
    writtenOff: 'Cancelada',
    addEntry: 'Añadir entrada',
    generateLink: 'Generar enlace',
    paymentLink: 'Enlace de pago',
    paymentLinkTitle: 'Enlace de pago',
    paymentLinkEmailSection: 'Enviar enlace por correo (opcional)',
    emailLink: 'Enviar enlace por correo',
    payTab: 'Pagar cuenta',
    payTabTooltip: 'Abrir el Registro de ventas para pagar esta cuenta',
    closeTab: 'Cerrar cuenta',
    tabActions: 'Acciones de cuenta',
    markClosed: 'Marcar cerrada',
    markClosedConfirmTitle: '¿Marcar cuenta como cerrada?',
    markClosedConfirmMessage: 'Esto cierra la cuenta cuando el saldo es cero. ¿Continuar?',
    tabClosedSuccess: 'Cuenta cerrada',
    tabClosedFailed: 'No se pudo cerrar la cuenta',
    editTabName: 'Editar nombre de cuenta',
    editWalkInBarTabNote: 'Editar nota de cuenta',
    walkInBarTabNoteTitle: 'Nota de cuenta',
    walkInBarTabNoteHint: 'Etiqueta opcional para identificar esta cuenta bar sin cliente (por ejemplo, color de chaqueta o asiento).',
    editCreditLimit: 'Editar límite de crédito',
    creditLimitLabel: 'Límite de crédito',
    noCreditLimit: 'Sin límite',
    creditLimitInvalid: 'Ingrese un límite de crédito válido',
    tabUpdated: 'Cuenta actualizada',
    tabUpdateFailed: 'No se pudo actualizar la cuenta',
    noBalanceDue: 'Sin saldo pendiente',
    balanceLabel: 'Saldo',
    summary: 'Resumen',
    netChargesLabel: 'Cargos netos',
    storeCreditsLabel: 'Créditos de tienda',
    creditOnTabLabel: 'Crédito en cuenta',
    currentTotalLabel: 'Total actual',
    paymentsLabel: 'Pagos',
    balanceLabelAlt: 'Saldo',
    groupOwnedTab: 'Cuenta de grupo',
    customerOwnedTab: 'Cuenta de cliente',
    groupOwner: 'Propietario del grupo',
    participants: 'Participantes',
    addCustomerToTab: 'Añadir cliente a la cuenta',
    add: 'Añadir',
    ledger: 'Libro mayor',
    openNewTab: 'Abrir nueva cuenta',
    chooseOwner: 'Elige un cliente o propietario de grupo',
    ownerType: 'Tipo de propietario',
    creditLimitOptional: 'Límite de crédito (opcional)',
    creditLimitHint: 'Establece un saldo máximo para esta cuenta',
    ownerDescription: 'El propietario puede ser un cliente individual o un grupo de clientes. Puedes cambiar o cerrar la cuenta más tarde desde la página de Cuentas.',
    openTab: 'Abrir cuenta',
    secureTabWithCard: 'Asegurar cuenta con tarjeta',
    secureTabWithCardHint: 'Opcionalmente valida o añade una tarjeta en archivo para esta cuenta.',
    cardSetupDescription: 'Añade una tarjeta en archivo para asegurar esta cuenta. Puedes validar una tarjeta guardada existente o omitir para añadir una cuando el cliente pague mediante enlace de pago.',
    validateSavedCard: 'Validar tarjeta guardada',
    noSavedCardHint: 'No hay tarjeta guardada para este cliente. El cliente puede añadir una tarjeta al pagar mediante enlace de pago.',
    skip: 'Omitir',
    cardValidated: 'Tarjeta validada correctamente',
    cardSaved: 'Tarjeta guardada para la cuenta',
    tapCardAtTerminal: 'Pasar tarjeta en terminal',
    tapCardAtTerminalHint: 'El cliente pasa, inserta o desliza la tarjeta en el terminal físico',
    openAsBarTab: 'Cuenta de bar (mismo día, tarjeta obligatoria)',
    openAsBarTabHint: 'El cliente debe verificar una tarjeta antes de cargar consumos. No se puede omitir.',
    openAsBarTabHintOptional: 'Opcionalmente verifique una tarjeta al abrir la cuenta. Puede omitir si no se necesita tarjeta.',
    barTabCardSetupDescription: 'Verifique la tarjeta del cliente para esta cuenta de bar: terminal, tarjeta guardada o añadir tarjeta antes de registrar ítems.',
    barTabBadge: 'Cuenta de bar',
    barTabCardRequired: 'Cuenta bar · Tarjeta requerida',
    barTabVerified: 'Cuenta bar · Verificada',
    barTabSameDayExpired: 'Mismo día vencido',
    barTabSameDayChargeBlocked: 'Esta cuenta bar solo puede recibir cargos el mismo día calendario en que se abrió.',
    openingPreauthLabel: 'Retención inicial con tarjeta',
    cofVerifiedBadge: 'Tarjeta verificada',
    cofNotVerifiedBadge: 'Tarjeta no verificada',
    cofNoneBadge: 'Sin tarjetas guardadas',
    cofCountBadge: '{count} tarjeta(s) guardada(s)',
    manageCardsOnFile: 'Gestionar tarjetas guardadas',
    chargeSavedCard: 'Cobrar tarjeta guardada',
    chargeSavedCardConfirmTitle: '¿Cobrar con tarjeta guardada?',
    chargeSavedCardConfirmMessage: 'Se cobrará la tarjeta guardada del cliente por el saldo total de la cuenta ({amount}) cuando el cliente no pudo pagar en persona.',
    chargeSavedCardSuccess: 'Cargo con tarjeta realizado',
    chargeSavedCardFailed: 'No se pudo cobrar la tarjeta guardada',
    convert: {
      action: 'Convertir a factura',
      title: 'Convertir cuenta a factura',
      subtitle: 'Emita una factura por un rango de fechas y traslade el saldo a cuentas por cobrar.',
      startDate: 'Fecha inicial',
      endDate: 'Fecha final',
      createInvoice: 'Crear factura',
      invoiceTotal: 'Total de factura',
      appliedPaymentsNote: 'Incluye {amount} de pagos de cuenta aplicados a este período.',
      previewFailed: 'No se pudo cargar la vista previa de conversión.',
      success: 'Factura creada desde la cuenta.',
      failed: 'No se pudo convertir la cuenta a factura.',
      lineFallback: 'Cargo de cuenta',
      colTransactionDate: 'Fecha',
      paymentLinkToggle: 'Crear factura del período y enviar enlace de pago de factura',
      paymentLinkHint: 'Crea una factura emitida para las fechas seleccionadas y devuelve un enlace de pago de factura (no un enlace del portal de cuenta).',
      paymentLinkSubtitle: 'Enlace de pago de factura para el período seleccionado'
    },
    statement: {
      title: 'Estado de cuenta del tab',
      subtitle: 'Entradas activas del libro mayor y resumen de saldo',
      viewStatement: 'Ver estado de cuenta',
      statement: 'Estado de cuenta',
      print: 'Imprimir',
      email: 'Correo',
      text: 'Texto',
      emailTitle: 'Enviar estado de cuenta por correo',
      textTitle: 'Enviar estado de cuenta por texto',
      exportCsv: 'Exportar CSV',
      exportXlsx: 'Exportar Excel',
      exportCsvSuccess: 'Estado de cuenta exportado como CSV',
      exportXlsxSuccess: 'Estado de cuenta exportado como Excel',
      exportCsvFailed: 'Error al exportar CSV del estado de cuenta',
      exportXlsxFailed: 'Error al exportar Excel del estado de cuenta',
      downloadPdf: 'PDF',
      downloadPdfFailed: 'No se pudo descargar el PDF del estado de cuenta',
      loadFailed: 'No se pudo cargar el estado de cuenta',
      emailSuccess: 'Estado de cuenta enviado por correo',
      emailFailed: 'No se pudo enviar el estado de cuenta por correo',
      textSuccess: 'Estado de cuenta enviado por texto',
      textFailed: 'No se pudo enviar el estado de cuenta por texto',
      printFailed: 'No se pudo compartir el PDF del estado de cuenta',
      thermalFallback: 'Impresora térmica no disponible; use la impresión del navegador',
      phoneRequired: 'El número de teléfono es obligatorio',
      phoneUsOnly: 'Los SMS solo se pueden enviar a números de EE. UU.',
      owner: 'Titular',
      startedOn: 'Iniciada el',
      printedOn: 'Impreso el',
      chargedOn: 'Cargado el',
      undatedCharges: 'Cargos sin fecha',
      barTab: 'Tab de barra',
      charges: 'Cargos',
      credits: 'Créditos',
      paymentsLabel: 'Pagos a la fecha',
      netChargesLabel: 'Cargos netos',
      currentTotalLabel: 'Total actual',
      balanceDue: 'Saldo pendiente',
      balanceDueHint: 'Este monto aún no ha sido pagado.',
      creditBalance: 'Saldo a favor',
      noBalanceDue: 'Sin saldo pendiente',
      paymentsSection: 'Pagos'
    },
    cardSetupMethodSavedCard: 'Tarjeta guardada',
    cardSetupMethodNewCard: 'Tarjeta nueva',
    cardSetupMethodKeyedEntry: 'Entrada manual',
    selectSavedCard: 'Seleccionar tarjeta guardada',
    verifyCardWithKeyedEntry: 'Verificar tarjeta (entrada manual)',
    verifyCardAction: 'Verificar tarjeta',
    unverifiedBarTabBanner: 'Esta cuenta de bar requiere una tarjeta verificada en archivo antes de registrar cargos.',
    optionalBarTabBanner: 'Aún no hay tarjeta en archivo. Puede registrar cargos o verificar una tarjeta para asegurar esta cuenta.',
    cardSetupCancel: 'Cancelar',
    cardSetupFailed: 'Error al verificar la tarjeta',
    cardSetupSaveModeTitle: 'Guardar tarjeta en archivo',
    cardSetupSaveModeMessage: 'Este cliente ya tiene tarjetas guardadas. ¿Cómo deseas guardar la nueva tarjeta?',
    cardSetupSaveModeAdd: 'Añadir como tarjeta adicional',
    cardSetupSaveModeReplaceDefault: 'Reemplazar tarjeta predeterminada',
    cardSetupSaveModeReplaceSpecific: 'Reemplazar una tarjeta específica',
    selectCardToReplace: 'Seleccionar tarjeta a reemplazar',
    chargeSavedCardSelectTitle: 'Seleccionar tarjeta para cobrar',
    barTabNoCardOptionsHint: 'No hay tarjeta guardada ni terminal disponible. Usa entrada manual, lector integrado o configura un terminal SPIn.',
    continue: 'Continuar',
    failedToExportCsv: 'Error al exportar CSV',
    clearCurrentSale: '¿Limpiar venta actual?',
    clearCartMessage: 'El Registro de ventas tiene artículos en el carrito. Pagar esta cuenta es una transacción independiente y limpiará esos artículos. ¿Deseas continuar?',
    proceedAndClearCart: 'Continuar y vaciar carrito',
    cancel: 'Cancelar',
    failedToClearCart: 'Error al limpiar el carrito actual; no se puede iniciar el pago de la cuenta.',
    unableToVerifyCart: 'No se pudo verificar el contenido del carrito. Continuar iniciará un pago de cuenta independiente.'
  },
  leads: {
    title: 'Prospectos',
    subtitle: 'Envíos del formulario de captación',
    formSettings: 'Configuración del formulario',
    status: 'Estado',
    product: 'Producto',
    from: 'Desde',
    to: 'Hasta',
    name: 'Nombre',
    email: 'Correo electrónico',
    phone: 'Teléfono',
    date: 'Fecha',
    view: 'Ver',
    convertToCustomer: 'Convertir en cliente',
    leadDetails: 'Detalles del prospecto',
    address: 'Dirección',
    message: 'Mensaje',
    all: 'Todos',
    productSearchHint: 'Escriba al menos {count} caracteres para buscar productos',
    productSearchMinChars: 'Ingrese al menos {count} caracteres para buscar',
    productSearchNoResults: 'No hay productos coincidentes',
    search: 'Buscar',
    exportCsv: 'Exportar CSV',
    exportSuccess: 'Prospectos exportados',
    exportFailed: 'Error al exportar prospectos',
    new: 'Nuevo',
    contacted: 'Contactado',
    converted: 'Convertido',
    closed: 'Cerrado',
    failedToLoad: 'Error al cargar prospectos',
    statusUpdated: 'Estado actualizado',
    failedToUpdate: 'Error al actualizar',
    failedToLoadDetails: 'Error al cargar detalles',
    convertTitle: 'Convertir en cliente',
    convertMessage: '¿Crear un cliente desde {name}?',
    customerCreated: 'Cliente creado',
    failedToConvert: 'Error al convertir'
  },
  taxSettings: {
    title: 'Configuración de impuestos',
    subtitle: 'Gestionar reglas de impuestos por ubicación y previsualizar impuestos correctos',
    backToSettings: 'Volver a configuración',
    location: 'Ubicación',
    bannerText: 'Las tasas de impuestos son aditivas. Las categorías excluidas tienen prioridad sobre las incluidas.',
    ruleName: 'Nombre de regla',
    ratePercent: 'Tasa (%)',
    priority: 'Prioridad',
    active: 'Activo',
    saveRule: 'Guardar regla',
    includeCategories: 'Incluir categorías',
    excludeCategories: 'Excluir categorías',
    cancelEdit: 'Cancelar edición',
    refresh: 'Actualizar',
    includes: 'Incluye',
    excludes: 'Excluye',
    inactive: 'Inactivo',
    noRulesYet: 'Aún no hay reglas de impuestos para esta ubicación.',
    taxRuleSaved: 'Regla de impuestos guardada.',
    failedToSaveRule: 'Error al guardar la regla de impuestos.',
    taxRuleDeleted: 'Regla de impuestos eliminada.',
    failedToDeleteRule: 'Error al eliminar la regla de impuestos.',
    failedToLoad: 'Error al cargar configuración de impuestos: {error}'
  },
  integrations: {
    title: 'Integraciones',
    subtitle: 'Conectar loyalty, feeds de datos y servicios de terceros',
    refresh: 'Actualizar',
    backToSettings: 'Volver a configuración',
    errorBanner: 'No se pudieron cargar algunos estados de integración. Aún puedes abrir una integración para configurarla.',
    astroLoyalty: 'Astro Loyalty',
    astroDescription: 'Comprador frecuente, ofertas, cupones y puntos',
    justTCG: 'JustTCG',
    justTCGDescription: 'Datos y precios de cartas coleccionables',
    installed: 'Instalado',
    notInstalled: 'No instalado',
    configure: 'Configurar'
  },
  staffDirectory: {
    title: 'Personal',
    subtitle: 'Proveedores de servicios, usuarios vinculados y disponibilidad',
    backToSettings: 'Volver a Configuración',
    open: 'Abrir Personal',
    settingsTileHint: 'Administre proveedores reservables y horarios semanales',
    linkedUser: 'Usuario vinculado',
    serviceProviderSection: 'Perfil de proveedor de servicios',
    offersBookableServices: 'Ofrece servicios reservables',
    manageAvailability: 'Administrar disponibilidad'
  },
  adminUsers: {
    title: 'Gestión de usuarios',
    subtitle: 'Invita a tu equipo y gestiona el acceso',
    manageRoles: 'Gestionar roles',
    newUser: 'Nuevo usuario',
    backToSettings: 'Volver a configuración',
    loadError: 'Error al cargar usuarios. Actualiza e intenta de nuevo.',
    search: 'Buscar',
    searchPlaceholder: 'Nombre o correo...',
    roles: 'Roles',
    rolesPlaceholder: 'Filtrar por roles',
    apply: 'Aplicar',
    clear: 'Limpiar',
    users: 'Usuarios',
    noUsersFound: 'No se encontraron usuarios.',
    editUser: 'Editar usuario',
    createUser: 'Crear usuario',
    name: 'Nombre',
    email: 'Correo electrónico',
    passwordOptional: 'Contraseña (opcional)',
    cancel: 'Cancelar',
    save: 'Guardar',
    actions: 'Acciones',
    failedToLoad: 'Error al cargar usuarios',
    userUpdated: 'Usuario actualizado',
    userCreated: 'Usuario creado',
    userDeleted: 'Usuario eliminado',
    saveFailed: 'Error al guardar',
    deleteFailed: 'Error al eliminar'
  },
  adminRoles: {
    title: 'Roles',
    subtitle: 'Definir capacidades de roles y acceso al sistema',
    newRole: 'Nuevo rol',
    backToSettings: 'Volver a configuración',
    loadError: 'Error al cargar roles. Actualiza e intenta de nuevo.',
    search: 'Buscar',
    searchPlaceholder: 'Nombre o título...',
    type: 'Tipo',
    apply: 'Aplicar',
    clear: 'Limpiar',
    roles: 'Roles',
    noRolesFound: 'No se encontraron roles.',
    editRole: 'Editar rol',
    createRole: 'Crear rol',
    name: 'Nombre',
    titleLabel: 'Título',
    abilities: 'Capacidades',
    cancel: 'Cancelar',
    save: 'Guardar',
    actions: 'Acciones',
    system: 'Sistema',
    custom: 'Personalizado',
    all: 'Todos',
    failedToLoad: 'Error al cargar roles',
    roleUpdated: 'Rol actualizado',
    roleCreated: 'Rol creado',
    roleDeleted: 'Rol eliminado',
    saveFailed: 'Error al guardar',
    deleteFailed: 'Error al eliminar'
  },
  shared: {
    switchLocation: 'Cambiar ubicación',
    selectLocation: 'Seleccionar ubicación',
    manageLocations: 'Gestionar ubicaciones',
    manageLocationsCaption: 'Añadir, editar o eliminar ubicaciones',
    switchedTo: 'Cambiado a {name}',
    registerOpenInLocation: 'Ya tienes un registro abierto en {location}. {action}',
    closeBeforeSwitch: 'Ciérralo antes de cambiar de ubicación.',
    removeCustomer: 'Quitar cliente',
    openInAstro: 'Abrir en Astro',
    searchCustomer: 'Buscar cliente',
    groupMember: 'Miembro del grupo',
    noCustomersFound: 'No se encontraron clientes',
    typeToSearchCustomers: 'Escriba para buscar clientes por nombre, correo o teléfono.',
    searchingCustomers: 'Buscando…',
    openDropdownForRecentCustomers: 'Abre el desplegable de búsqueda para ver clientes recientes.',
    newCustomer: 'Nuevo cliente',
    noCustomersYet: 'Aún no hay clientes',
    recentCustomers: 'Clientes recientes',
    quickAddSubtitle: 'Añadir rápidamente al seleccionar un cliente',
    firstName: 'Nombre',
    lastName: 'Apellido',
    firstNameRequired: 'El nombre es obligatorio',
    lastNameRequired: 'El apellido es obligatorio',
    suffixOptional: 'Sufijo (opcional)',
    suffixPlaceholder: 'Jr., Sr., III, etc.',
    email: 'Correo electrónico',
    emailRequired: 'El correo es obligatorio',
    invalidEmail: 'Formato de correo inválido',
    phone: 'Teléfono',
    phoneRequired: 'El teléfono es obligatorio',
    cancel: 'Cancelar',
    ok: 'Aceptar',
    create: 'Crear',
    customer: 'Cliente',
    group: 'Grupo',
    failedToCreateCustomer: 'Error al crear el cliente',
    customers: 'Clientes',
    phoneNumbers: 'Números de teléfono',
    addPhone: 'Añadir teléfono',
    primary: 'Principal',
    editPhone: 'Editar teléfono',
    deletePhone: 'Eliminar teléfono',
    noPhonesYet: 'Aún no hay números de teléfono',
    editPhoneTitle: 'Editar teléfono',
    addPhoneTitle: 'Añadir teléfono',
    phoneNumber: 'Número de teléfono',
    phoneRequiredValidation: 'El número de teléfono es obligatorio',
    labelOptional: 'Etiqueta (opcional)',
    labelPlaceholder: 'ej., Móvil, Trabajo, Casa',
    setPrimaryPhone: 'Establecer como teléfono principal',
    save: 'Guardar',
    confirmDelete: 'Confirmar eliminación',
    confirmDeletePhone: '¿Estás seguro de que quieres eliminar {phone}?',
    phoneUpdated: 'Teléfono actualizado correctamente',
    phoneAdded: 'Teléfono añadido correctamente',
    phoneDeleted: 'Teléfono eliminado correctamente',
    failedToLoadPhones: 'Error al cargar teléfonos',
    errorSavingPhone: 'Error al guardar el teléfono',
    errorDeletingPhone: 'Error al eliminar el teléfono',
    emailAddresses: 'Direcciones de correo',
    addEmail: 'Añadir correo',
    editEmail: 'Editar correo',
    deleteEmail: 'Eliminar correo',
    noEmailsYet: 'Aún no hay direcciones de correo',
    editEmailTitle: 'Editar correo',
    addEmailTitle: 'Añadir correo',
    emailAddress: 'Dirección de correo',
    emailLabelPlaceholder: 'ej., Trabajo, Personal',
    setPrimaryEmail: 'Establecer como correo principal',
    confirmDeleteEmail: '¿Estás seguro de que quieres eliminar {email}?',
    emailUpdated: 'Correo actualizado correctamente',
    emailAdded: 'Correo añadido correctamente',
    emailDeleted: 'Correo eliminado correctamente',
    failedToLoadEmails: 'Error al cargar correos',
    errorSavingEmail: 'Error al guardar el correo',
    errorDeletingEmail: 'Error al eliminar el correo',
    taxPreview: 'Vista previa de impuestos',
    previewLocation: 'Ubicación de vista previa',
    previewBanner: 'La vista previa usa el mismo cálculo de impuestos que el checkout.',
    product: 'Producto',
    qty: 'Cant.',
    unitPrice: 'Precio unitario',
    lineDiscount: 'Descuento de línea',
    discountType: 'Tipo de descuento',
    runPreview: 'Ejecutar vista previa',
    previewTotals: 'Totales de vista previa',
    subtotal: 'Subtotal',
    tax: 'Impuesto',
    grandTotal: 'Total general',
    taxBreakdown: 'Desglose de impuestos',
    rate: 'Tasa',
    base: 'Base',
    noTaxComponents: 'No se devolvieron componentes de impuestos para esta vista previa.',
    fixed: 'Fijo ($)',
    percentage: 'Porcentaje (%)',
    taxable: 'gravable',
    nonTaxable: 'no gravable',
    selectPaymentTerminal: 'Seleccionar terminal de pago',
    terminalRequired: 'El terminal es obligatorio',
    noTerminalsAvailable: 'No hay terminales disponibles',
    contactAdminForTerminals: 'Contacta a tu administrador para configurar terminales de pago',
    chooseLocationForPreview: 'Elige una ubicación para ejecutar la vista previa de impuestos.',
    chooseProductForPreview: 'Elige un producto para ejecutar la vista previa de impuestos.',
    quantityMustBePositive: 'La cantidad debe ser mayor que 0.',
    previewLocationUnavailable: 'La ubicación de vista previa seleccionada no está disponible.',
    switchedForPreview: 'Ubicación actual cambiada a {name} para vista previa precisa.',
    failedToRunPreview: 'Error al ejecutar la vista previa de impuestos.'
  },
  error: {
    nothingHere: 'Ups. No hay nada aquí...',
    pageNotFound: 'La página que buscas no existe.',
    goHome: 'Ir al inicio'
  },
  payments: {
    title: 'Procesamiento de pagos',
    subtitle: 'Gestionar pasarelas y configuración de terminales',
    backToSettings: 'Volver a configuración',
    connextPayMx: 'ConnextPay / Mx',
    connextPayMxDesc: 'Gestionar configuración de Mx Merchant',
    dejavoo: 'Dejavoo',
    dejavooDesc: 'Ver el estado de configuración Dejavoo y asignar terminales a registros',
    iphoneTopSetupDesc: 'Registre este iPhone para Apple Tap to Pay y vincúlelo a Blu',
    backToPayments: 'Volver a pagos',
    gateway: {
      colGateway: 'Pasarela',
      colStatus: 'Estado',
      settlementStatus: 'Liquidación: {status}',
      viewTimeline: 'Eventos de pasarela',
      timelineTitle: 'Actividad de la pasarela',
      timelineLoadFailed: 'No se pudieron cargar los detalles de la transacción.',
      klarnaRequestId: 'Solicitud de pago Klarna',
      referenceKlarnaRequest: 'Solicitud Klarna {id}',
      referenceProcessor: 'Referencia {gateway} {id}',
      processorReference: 'Referencia {gateway}',
      noEvents: 'Aún no hay eventos registrados.',
      filterAll: 'Todas las pasarelas',
      filterKlarna: 'Solo Klarna',
      status: {
        pending: 'Pendiente',
        approved: 'Aprobado',
        settled: 'Liquidado',
        declined: 'Rechazado',
        error: 'Error',
        created: 'Creado',
        voided: 'Anulado',
        refunded: 'Reembolsado',
      },
    },
    dejavooSettings: {
      pageSubtitleReadOnly: 'La configuración del procesador la administra Blu. Asigne terminales a registros abajo.',
      adminManagedBanner: 'Las credenciales y terminales los configura el soporte de Blu. Aún puede administrar las tarifas de conveniencia abajo.',
      readinessTitle: 'Estado de configuración',
      readinessLead: 'Las marcas verdes indican que esa vía está lista. Advertencias o errores pueden bloquear Tap to Pay, captura manual o tarjeta presente.',
      readinessAllClear: 'Todos los canales de pago están listos.',
      readinessIncomplete: 'Uno o más canales de pago aún no están listos. Resuelva los elementos anteriores o contacte al soporte de Blu para credenciales.',
      summaryTitle: 'Resumen de configuración',
      summaryLead: 'Ajustes no secretos de este comercio (administrados por Blu).',
      configured: 'Configurado',
      notConfigured: 'No configurado',
      scenarioCnp: 'En línea / manual (CNP)',
      scenarioCardPresent: 'Tarjeta presente (SPIn)',
      scenarioTapOnPhone: 'Tap to Pay (Android)',
      scenarioBnpl: 'Klarna BNPL (web)',
      assignmentsTitle: 'Registros y terminales',
      assignmentsLead: 'Puede asignar terminales existentes a registros de venta. Credenciales del procesador requieren Blu Admin.',
      openRegisters: 'Abrir gestión de registros',
      pageSubtitle: 'ID de comercio, autenticación SPIn API, FTD, Google Pay, comisiones, captura manual y terminales',
      loadFailed: 'No se pudieron cargar los ajustes de pago. Actualice la página e inténtelo de nuevo.',
      sectionFtd: 'Pasarela Dejavoo',
      sectionFtdLead: 'Ajustes compartidos para SPIn REST, FTD y cobro sin tarjeta presente (portales, facturas, cuentas abiertas, Google Pay), comisiones por conveniencia y opciones del registro de ventas.',
      gatewayAuthKey: 'Clave de autenticación de la pasarela (SPIn)',
      gatewayAuthKeyHint: 'Credencial REST SPIn del lado del servidor. El valor guardado no se muestra; solo si hay uno configurado.',
      gatewayAuthKeyConfigured: 'Hay una clave de autenticación de pasarela guardada para este comercio.',
      gatewayAuthKeyNotConfigured: 'No hay ninguna clave de autenticación de pasarela guardada.',
      gatewayAuthKeyPendingRemoval: 'La clave guardada se eliminará al guardar.',
      gatewayAuthKeyClear: 'Eliminar clave guardada',
      gatewayAuthKeyUndoClear: 'Deshacer eliminación',
      mid: 'ID de comercio (MID)',
      midHint: 'MID asignado por Dejavoo para este comercio',
      ecomTerminal: 'Terminal de comercio electrónico',
      ecomTerminalHint: 'Terminal para Ecom (tabs, portales y similares)',
      ecomTerminalHintEmpty: 'No hay terminales. Añada un terminal Ecom o Tap to Pay en Gestión de terminales.',
      ecomTerminalNoOption: 'No hay terminales Dejavoo. Cree primero un terminal Ecom o Tap to Pay en Gestión de terminales.',
      ftdMode: 'Modo FTD',
      gpayMerchantId: 'ID de comercio Google Pay',
      gpayMode: 'Modo Google Pay',
      modeTest: 'Pruebas',
      modeProduction: 'Producción',
      keyedEntry: 'Permitir captura manual en el registro de ventas',
      keyedEntryHint: 'Requiere FTD de Dejavoo y un terminal Ecom con token de autenticación válido (igual que los pagos en línea).',
      convenienceFee: 'Comisión por conveniencia',
      convenienceFeeLead: 'Recargo opcional solo con tarjeta sobre categorías y productos elegibles (importe más propina, prorrateado). No modifica el saldo de la venta o factura.',
      convenienceFeeScopeHint: 'Cuando está activada, la comisión solo aplica a productos en categorías marcadas para aplicarla (o productos configurados explícitamente). Las categorías y productos exentos quedan fuera.',
      convenienceFeeEnable: 'Activar comisión por conveniencia',
      convenienceFeePercent: 'Comisión por conveniencia %',
      convenienceFeePercentHint: 'Ejemplo: 3.50',
      convenienceFeeInvalid: 'El % de comisión debe ser un número no negativo',
      save: 'Guardar ajustes',
      saveConvenienceFee: 'Guardar tarifa de conveniencia',
      saved: 'Ajustes guardados',
      saveFailed: 'No se pudieron guardar los ajustes',
      terminalsSection: 'Terminales',
      terminalsSectionLead: 'Terminales Dejavoo activos de este comercio. Gestione equipos y asignaciones en Gestión de terminales.',
      openTerminalMgmt: 'Abrir gestión de terminales',
      activeTerminals: 'Terminales activos',
      noActiveTerminals: 'No hay terminales Dejavoo activos',
      colId: 'ID',
      colLabel: 'Etiqueta',
      colStatus: 'Estado',
      colExternalId: 'ID externo',
      terminalsLoadFailed: 'Error al cargar terminales',
    },
    open: 'Abrir',
    cardOptionTapToPay: 'Pago sin contacto (este teléfono)',
    cardOptionTapToPayIos: 'Tap to Pay en iPhone',
    cardOptionTapToPayAndroid: 'Pago sin contacto (este teléfono)',
    tapToPayOnIphoneBanner: 'El cliente paga con Tap to Pay en iPhone. Apruebe el monto y complete la venta en la pantalla de Tap to Pay.',
    tapToPayAndroidBanner: 'El cliente paga con Tap to Pay en este teléfono (NFC). Apruebe el monto y complete la venta.',
    tapToPayNfcOffWarning: 'Este dispositivo indica que NFC está apagado o no disponible. El pago puede no iniciarse. Elija terminal físico si el registro tiene uno.',
    cardOptionPhysicalTerminal: 'Terminal física',
    cardOptionKeyedEntry: 'Captura manual (tarjeta)',
    cardOptionIntegratedTerminal: 'Terminal integrada (DvPayLite)',
    integratedReaderCapture: 'Usar lector integrado',
    integratedReaderCaptureHint: 'El cliente acerca, inserta o desliza la tarjeta en este dispositivo. Se retiene ${amount} para asegurar la tarjeta de la cuenta.',
    integratedReaderCaptureZeroHoldHint: 'El cliente acerca, inserta o desliza la tarjeta en este dispositivo. La tarjeta se verifica y guarda sin retención.',
    integratedReaderCaptureWalletHint: 'El cliente acerca, inserta o desliza la tarjeta en este dispositivo. Se retiene $1.00 para verificar y se anula al guardar la tarjeta.',
    integratedCaptureFailed: 'No se pudo capturar la tarjeta en el lector integrado. Inténtelo de nuevo u otro método.',
    integratedCaptureNoToken: 'No se pudo guardar la tarjeta. El terminal no devolvió un token de bóveda.',
    integratedCaptureCancelled: 'Se canceló la captura de la tarjeta.',
    cardOptionCardOnFile: 'Tarjeta guardada',
    barTabCofPayWith: 'Pagar con tarjeta en archivo: {card}',
    barTabCofSelectCard: 'Seleccionar tarjeta en archivo',
    barTabCofDeclined: 'La tarjeta en archivo fue rechazada. Prueba otro método de pago.',
    sandbox: {
      title: 'Pagos en sandbox',
      lead: 'Los cargos con tarjeta en este entorno son solo de prueba. No se capturará dinero real.',
      ftdMode: 'Modo FTD: {mode}'
    },
    keyedEntryChecking: 'Comprobando entrada manual…',
    keyedEntryBanner: 'Ingrese los datos de la tarjeta manualmente. El PAN se envía a Dejavoo para tokenización; Blu nunca almacena el número completo.',
    keyedEntryNotReady: 'La entrada manual está activada pero faltan datos FTD. Guarde la configuración de Dejavoo y asegure un token en el terminal Ecom.',
    keyedEntryFtdLoading: 'Cargando entrada segura de tarjeta…',
    cardholderName: 'Titular',
    cardNumber: 'Número de tarjeta',
    cardExpiry: 'Vencimiento (MM/AA)',
    cardCvc: 'Código de seguridad',
    keyedEntryCardholderRequired: 'Ingrese el nombre del titular tal como aparece en la tarjeta.',
    keyedEntryNotReadyShort: 'El formulario de captura manual no está listo.',
    keyedEntryTokenMissing: 'No se pudo obtener un token de pago de Dejavoo. Revise los datos de la tarjeta e intente nuevamente.',
    keyedEntryDeclined: 'Tarjeta rechazada.',
    keyedEntryFailed: 'No se pudo completar el pago manual.',
    keyedEntryFailedDetail: 'Error en el pago manual: {detail}',
    keyedEntryTokenFailed: 'Falló la tokenización. Revise los datos de la tarjeta y la red.',
    keyedEntrySaleNote: 'Captura manual (Dejavoo FTD)',
    stripeKeyedEntryBanner: 'Ingrese la tarjeta en el formulario seguro de Stripe. Los datos van a Stripe; Blu no almacena números de tarjeta.',
    stripeKeyedEntrySaleNote: 'Captura manual (Stripe)',
    keyedEntrySpinnerTitle: 'Procesando el pago',
    keyedEntrySpinnerSub: 'No abandone esta pantalla.',
    convenienceFeeFullPreview: 'Comisión por conveniencia ({percent}%): ${fee} • El cliente paga: ${total}',
    convenienceFeePartialPreview: 'Comisión por conveniencia ({percent}%): ${fee} sobre ${eligible} elegible • El cliente paga: ${total}',
    integratedTerminalBanner: 'El cliente pagará en el lector de tarjetas integrado en este dispositivo. Cuando se complete el pago, se registrará automáticamente en Blu.',
    integratedTerminalRequiresAndroidApp: 'El cobro con lector integrado requiere la app Blu Android en este dispositivo.',
    integratedTerminalRequiresDejavooDevice: 'El cobro con lector integrado solo está disponible en terminales Dejavoo en la lista blanca.',
    integratedTerminalRequiresDejavooWhitelist: 'Este terminal Dejavoo aún no está en la lista blanca. Capture su identidad desde Dejavoo PoC y actualice la configuración.',
    integratedTerminalSpinnerTitle: 'Procesando pago',
    integratedTerminalSpinnerSub: 'Siga las indicaciones en el lector de tarjetas.',
    tapToPayIosSpinnerTitle: 'Tap to Pay en iPhone',
    tapToPayIosSpinnerSub: 'Siga la pantalla de Tap to Pay. Acerque la tarjeta o el teléfono del cliente a la parte superior del iPhone hasta ver Aprobado o Rechazado.',
    tapToPayIosTimeout: 'Tap to Pay no terminó a tiempo. Compruebe la conexión a internet, complete o cancele en la pantalla de Tap to Pay e intente de nuevo.',
    integratedTerminalRecordFailed: 'El pago se aprobó en el lector pero no se pudo registrar. Mantenga esta venta abierta para revisión.',
    integratedTerminalDeclined: 'El pago no fue aprobado.',
    tapToPayFailed: 'No se pudo completar Tap to Pay. Revise la configuración de Stripe e intente de nuevo.',
    integratedTerminalCancelled: 'Pago cancelado',
    integratedTerminalLaunchedNotice: 'Complete el pago en el lector de tarjetas.',
    integratedTerminalLaunchFailed: 'No se pudo abrir el lector de tarjetas.',
    integratedTerminalAwaitManualConfirm: 'Si el pago se completó en el lector, confirme o registre desde el historial de pagos.',
    integratedTerminalRegisterFailed: 'No se pudo configurar el lector de tarjetas. Verifique el TPN de la terminal en Gestión de terminales.',
    integratedTerminalDeclinedWithSale: 'Pago rechazado: {message}. Venta retenida (#{saleId}).',
    integratedTerminalCancelledWithSale: 'Pago cancelado: {message}. Venta retenida (#{saleId}).',
    integratedTerminalTip: {
      title: 'Agregar propina',
      saleTotal: 'Total de venta: {amount}',
      preset15: '15%',
      preset18: '18%',
      preset20: '20%',
      noTip: 'Sin propina',
      custom: 'Personalizada',
      customAmount: 'Monto de propina personalizado',
      chargeTotal: 'Total a cobrar'
    },
    terminalPaymentProcessingTitle: 'Procesando pago en terminal',
    terminalPaymentProcessingSub: 'El cliente debe completar el pago en la terminal física',
    terminalPaymentAwaitingTerminal: 'Esperando a que el cliente termine en la terminal',
    terminalPaymentDoNotRetry: 'No inicie otro cobro con tarjeta — la terminal puede estar procesando este pago.',
    terminalPaymentInFlight: 'Ya hay un cobro con tarjeta en curso para esta venta. Esperando la terminal…',
    terminalPaymentAlreadyPaid: 'Esta venta ya está pagada por completo.',
    terminalPaymentFailedGeneric: 'El pago con tarjeta no se completó. Puede intentar de nuevo u otro método de pago.',
    terminalPaymentTimeout: 'Se agotó el tiempo esperando la terminal. Confirme la transacción e intente de nuevo u use otro método.',
    terminalPaymentFailedTitle: 'El pago con tarjeta no se completó',
    terminalPaymentErrorAcknowledge: 'Cerrar',
    terminalPaymentReference: 'Referencia',
    posDialogTitle: 'Procesar pago',
    posDialogSubtitle: 'Confirme el cobro y complete la venta',
    posDialogAmountDue: 'Importe adeudado',
    cashDue: 'Efectivo adeudado',
    exactTotal: 'Total exacto',
    pennyRounding: 'Redondeo de centavos',
    posDialogProcess: 'Procesar pago',
    noCardPaymentOptions: 'No hay opciones de pago con tarjeta disponibles.',
    noCardPaymentOptionsTapToPay: 'Para Tap to Pay, use la app Blu para Android en un teléfono compatible. Si no aparece, abra Configuración → Pagos → Dejavoo o contacte a soporte Blu.',
    noCardPaymentOptionsTapToPayIos: 'Tap to Pay en iPhone no está listo en este dispositivo. Abra Configuración → Pagos → Dejavoo → configuración de Tap to Pay en iPhone, o contacte a soporte Blu.',
    noCardPaymentOptionsPhysicalTerminal: 'Para un terminal físico, asigne un terminal activo a esta caja.',
    noCardPaymentOptionsBarTabCof: 'Para tarjeta en archivo de barra, verifique una tarjeta en la cuenta antes del cierre.',
    splitAmountDue: 'Importe adeudado',
    splitAllocated: 'Asignado',
    splitRemaining: 'Restante',
    splitEvenlyComingSoon: 'Dividir en partes iguales (próximamente)',
    splitPaymentNumber: 'Pago {n}',
    splitRemoveRow: 'Eliminar pago',
    splitMethodCash: 'Efectivo',
    splitMethodCard: 'Tarjeta',
    splitAmountLabel: 'Importe',
    splitAddPayment: 'Agregar pago',
    splitCardTerminalLabel: 'Seleccionar terminal de tarjeta',
    splitCardHelper: 'El cliente completa el pago con tarjeta en el terminal físico.',
    splitFeeCalculating: 'Calculando comisión por conveniencia…',
    splitFeeQuoteError: 'No se pudo calcular la comisión por conveniencia',
    splitWizardStepMethodTitle: '¿Cómo es este pago?',
    splitWizardStepAmountTitle: 'Importe del pago',
    splitWizardStepCashAmountTitle: 'Importe en efectivo',
    splitWizardStepCardTitle: 'Terminal de tarjeta',
    splitWizardProgressMethod: 'Pago {n} — elija método',
    splitWizardProgressAmount: 'Pago {n} — ingrese importe',
    splitWizardProgressDetails: 'Pago {n} — completar detalles',
    splitWizardUseRemaining: 'Usar saldo restante completo',
    splitWizardContinue: 'Continuar',
    splitWizardBack: 'Atrás',
    splitWizardAddAnother: 'Agregar siguiente pago',
    splitWizardFinish: 'Revisar división',
    splitWizardAddedPayments: 'Agregados hasta ahora',
    splitWizardReviewTitle: 'Listo para procesar',
    splitWizardReviewReady: 'Todos los pagos están ingresados. Procese cuando esté listo.',
    splitWizardEditLast: 'Editar último pago',
    splitWizardBackToReview: 'Volver a revisión',
    splitPlanTitle: 'Dividir entre pagadores',
    splitPayerCount: 'Número de pagadores',
    splitEvenly: 'Dividir en partes iguales',
    splitPayerLabelOptional: 'Etiqueta (opcional)',
    splitMethodLabel: 'Método',
    splitEditPlan: 'Editar plan de división',
    splitCollectProgress: 'Pago {current} de {total}',
    splitCollectAmount: 'Cobrar {amount}',
    splitCollectFailed: 'Este pago no se completó. Puede reintentar o cancelar.',
    splitCollectRetry: 'Reintentar pago',
    splitCollectCancel: 'Cancelar división',
    splitCollectIncomplete: 'La división no terminó. Cobre cada pago antes de completar la venta.',
    splitMultiCardDisabled: 'La división multi-tarjeta no está habilitada para este negocio.'
  },
  terminals: {
    title: 'Terminales',
    subtitle: 'Monitorear terminales de pago, estado y asignaciones de registradoras',
    newTerminal: 'Nuevo terminal',
    createTerminalTooltip: 'Crear un nuevo terminal de pago',
    totalTerminals: 'Total de terminales',
    healthy: 'Saludables',
    issues: 'Problemas',
    assigned: 'Asignados',
    search: 'Buscar',
    searchPlaceholder: 'Etiqueta, id externo, registradora…',
    filter: 'Filtrar',
    apply: 'Aplicar',
    clear: 'Limpiar',
    refreshTooltip: 'Actualizar terminales',
    manage: {
      filterAll: 'Todos',
      filterHealthy: 'Sin incidencias',
      filterIssues: 'Con incidencias',
      filterUnassigned: 'Sin asignar',
      chipReady: 'Listo',
      chipIssue: 'Revisar',
      unknownGateway: 'Pasarela desconocida',
      registerChip: 'Registradora: {name}',
      unassigned: 'Sin asignar',
      capabilitiesLead: 'Capacidades',
      menuViewDetails: 'Ver detalles',
      menuEdit: 'Editar',
      menuDelete: 'Eliminar',
      emptyTitle: 'No hay terminales',
      emptyFiltered: 'Ningún terminal coincide con los filtros.',
      emptyNoneYet: 'Aún no hay terminales para esta ubicación.',
      emptyCreateFirst: 'Crear terminal',
      emptyViewPaymentStatus: 'Ver estado de pagos',
      adminProvisionedBanner: 'Las credenciales y capacidades las configura Blu. Puede cambiar la etiqueta aquí; asigne registros en Gestión de registros.',
      formTitleNew: 'Nuevo terminal',
      formTitleEdit: 'Editar terminal',
      label: 'Etiqueta del terminal',
      labelRequired: 'La etiqueta es obligatoria',
      externalId: 'ID externo',
      externalIdRequired: 'El ID externo es obligatorio',
      paymentGateway: 'Pasarela de pago',
      gatewayRequired: 'La pasarela es obligatoria',
      ecomAuthToken: 'Token de autenticación e-commerce',
      ecomAuthTokenHint: 'Obligatorio cuando Ecom está activado. Se guarda cifrado; se conserva al desactivar Ecom.',
      ecomAuthTokenRequiredWhenEnabled: 'El token e-commerce es obligatorio cuando la capacidad Ecom está activada.',
      ecomAuthTokenRequired: 'El token e-commerce es obligatorio para terminales Dejavoo',
      merchantCodeOptional: 'Código de comercio / MID (Tap to Pay en Android)',
      capabilitiesSection: 'Capacidades del terminal',
      capabilitiesHint: 'Un TPN puede admitir varios flujos. Active solo los que use este dispositivo.',
      hardwareCapsSection: 'Opciones de hardware',
      capSpin: 'SPIn REST (terminal físico)',
      capSpinHint: 'Envía pagos con tarjeta presente al terminal físico vía SPIn.',
      capEcom: 'Ecom / Transact (manual y en línea)',
      capEcomHint: 'Habilita captura manual y Transact en línea para este TPN. Al desactivar, el token se conserva.',
      capDvpayliteIntegrated: 'Integrado (DvPayLite)',
      capDvpayliteIntegratedHint: 'Entrega la venta a la app DvPayLite en el mismo dispositivo Android.',
      capTapOnPhone: 'Tap to Pay (móvil)',
      capTapOnPhoneHint: 'Tap to Pay NFC en la app Android.',
      capabilityLabel: {
        contactless: 'Sin contacto',
        chip: 'Chip',
        swipe: 'Banda magnética',
        print: 'Impresión',
        signature: 'Firma'
      },
      dejavooType: 'Tipo de terminal Dejavoo',
      dejavooTypeHint:
        'Presente físico usa SPIn; E-commerce para captura manual y en línea; Tap to Pay para NFC en Android.',
      typeSpin: 'Tarjeta presente (SPIn)',
      typeEcom: 'Solo e-commerce / en línea',
      typeTop: 'Tap to Pay (móvil)',
      statusField: 'Estado',
      statusActive: 'Activo',
      statusInactive: 'Inactivo',
      statusMaintenance: 'Mantenimiento',
      statusDisconnected: 'Desconectado',
      noGatewayAccounts:
        'No hay cuentas de pasarela configuradas. Configure una pasarela en Pagos antes de crear terminales.',
      cancel: 'Cancelar',
      saveCreate: 'Crear',
      saveUpdate: 'Actualizar',
      detailsTitle: 'Detalle del terminal',
      detailFor: '{name}',
      basicInfo: 'Información general',
      fieldLabel: 'Etiqueta',
      fieldExternalId: 'ID externo',
      fieldGateway: 'Pasarela',
      fieldStatus: 'Estado',
      fieldHealth: 'Estado técnico',
      statusUnknown: 'Desconocido',
      healthOk: 'En buen estado',
      healthWarn: 'Requiere atención',
      assignSection: 'Asignación a registradora',
      fieldRegister: 'Registradora',
      fieldRegisterId: 'ID de registradora',
      fieldLocation: 'ID de ubicación',
      noRegisterTitle: 'Sin registradora',
      noRegisterLead: 'Asigne el terminal desde Gestión de registradoras.',
      capsSection: 'Capacidades',
      noCaps: 'Sin capacidades registradas',
      metricsSection: 'Actividad (muestra)',
      metricsTotalTxn: 'Transacciones de muestra',
      metricsSuccessRate: 'Tasa de éxito de muestra',
      metricsLastUsed: 'Último uso',
      metricsNever: 'Nunca',
      close: 'Cerrar',
      editFromDetails: 'Editar terminal',
      manageAssignment: 'Gestionar asignación',
      assignmentSoon: 'La asignación desde este cuadro estará disponible pronto.',
      confirmDeleteTitle: '¿Eliminar terminal?',
      confirmDeleteMessage:
        '¿Eliminar «{name}»? Desasócielo primero en las registradoras si sigue en uso. No se puede deshacer.',
      loadFailedDetail: 'No se pudieron cargar los terminales: {message}',
      loadFailedGeneric: 'Error al cargar terminales',
      refreshFailed: 'Error al actualizar terminales',
      created: 'Terminal creado',
      updated: 'Terminal actualizado',
      saveFailedDetail: 'No se pudo guardar el terminal: {message}',
      saveFailedGeneric: 'Error al guardar el terminal',
      deleted: 'Terminal eliminado',
      deleteFailedDetail: 'No se pudo eliminar el terminal: {message}',
      deleteFailedGeneric: 'Error al eliminar el terminal'
    },
    tokenHints: {
      setOrReplace: 'Introduzca un token para definir o sustituir la credencial e-commerce de este terminal.',
      notSetYet: 'Aún no hay token e-commerce Dejavoo para este terminal.',
      currentBoth: 'El token guardado empieza por {first} y termina en {last}. Introduzca uno nuevo para sustituirlo.',
      currentLast: 'El token guardado termina en {last}. Introduzca uno nuevo para sustituirlo.',
      configuredObscured: 'Ya hay un token guardado. Introduzca uno nuevo para sustituirlo.'
    }
  },
  storeOrders: {
    title: 'Cola de recogida en tienda',
    featureDisabled: 'Blu Store no está activado para este negocio.',
    noOrders: 'No hay pedidos en tienda en espera de recogida.',
    noHistory: 'Aún no hay pedidos en tienda completados o cancelados.',
    tabActive: 'Activos',
    tabHistory: 'Historial',
    historyHint: 'Pedidos en línea completados o cancelados en esta ubicación.',
    colOrder: 'Pedido',
    colCustomer: 'Cliente',
    colTotal: 'Total',
    colFulfillment: 'Entrega',
    colStatus: 'Estado',
    colUpdated: 'Actualizado',
    historySearchPlaceholder: 'Buscar por n.º de pedido, nombre o correo',
    guestCustomer: 'Invitado',
    updateFailed: 'No se pudo actualizar el estado del pedido.',
    pickupLabel: 'Recogida en tienda',
    viewSale: 'Ver venta',
    saleDetailTitle: 'Pedido de tienda #{id}',
    saleDetailSubtitle: 'Líneas, totales y detalles de pago',
    saleDetailLoadFailed: 'No se pudieron cargar los detalles de la venta.',
    channelContext: 'Pedido en línea de Blu Store',
    customerEmailLine: 'Correo del cliente: {email}',
    noEmailOnFile: 'Sin correo del cliente registrado',
    fulfillmentShipped: 'Enviado',
    markShipped: 'Marcar enviado',
    fulfillmentModePickup: 'Recoger',
    fulfillmentModeShip: 'Envío',
    lineItemCount: '{count} artículos',
    shipDialogTitle: 'Enviar pedido #{id}',
    shipDialogHint: 'El transportista y el número de seguimiento opcionales se incluyen en el correo de envío y en la página del pedido.',
    shipCarrierLabel: 'Transportista',
    shipCarrierUsps: 'USPS',
    shipCarrierUps: 'UPS',
    shipCarrierFedex: 'FedEx',
    shipCarrierDhl: 'DHL',
    shipCarrierOther: 'Otro',
    shipCarrierOtherLabel: 'Nombre del transportista',
    shipTrackingLabel: 'Número de seguimiento',
    shipTrackingHint: 'Opcional',
    shipConfirm: 'Marcar como enviado',
    markReturned: 'Marcar devuelto',
    markReturnedConfirmTitle: '¿Marcar pedido como devuelto?',
    markReturnedConfirmMessage: 'El pedido #{id} quedará registrado como devuelto y se repondrá el inventario. Los reembolsos con tarjeta siguen el flujo de anulación de venta.',
    markReturnedConfirmOk: 'Marcar devuelto',
    markReturnedSuccess: 'Pedido marcado como devuelto e inventario actualizado.',
    cancelDialogTitle: '¿Cancelar este pedido de tienda?',
    cancelDialogMessage:
      'El pedido #{id} se marcará como cancelado y se repondrá el inventario de recogida o envío. Los reembolsos con tarjeta siguen el flujo de anulación de venta.',
    cancelDialogOk: 'Cancelar pedido',
    cancelPendingLine: 'El pedido #{id} se cancelará'
  },
  kds: {
    titleKitchenQueue: 'Cola de cocina',
    titleKitchenDisplay: 'Pantalla de cocina',
    toggleChimeAria: 'Activar o desactivar sonido de pedido nuevo',
    signOutDevice: 'Cerrar sesión del dispositivo',
    noOrders: 'No hay pedidos en cola.',
    featureDisabled: 'La cola de pedidos anticipados está desactivada para este negocio. Actívela en Configuración > Información del negocio.',
    start: 'Iniciar',
    ready: 'Listo',
    complete: 'Completar',
    cancelOrder: 'Cancelar pedido',
    printTicket: 'Imprimir ticket',
    itemFallback: 'Artículo',
    feedbackPreparing: 'En preparación',
    feedbackReady: 'Listo',
    feedbackCompleted: 'Completado',
    orderNumberLine: 'Pedido #{id}',
    feedbackAllFinished: '¡Todo listo!',
    overlayCancelled: 'Cancelado',
    cancelPendingLine: 'El pedido #{id} se cancelará',
    undoInSeconds: 'Deshacer en {n}s',
    undoSeparator: ' · ',
    undo: 'Deshacer',
    dialogCancelTitle: '¿Cancelar este pedido?',
    dialogCancelMessage: 'El pedido #{id} se marcará como cancelado en la cola de cocina.',
    dialogKeep: 'Conservar',
    dialogConfirmCancel: 'Cancelar pedido',
    notPaired: 'Este dispositivo no está vinculado. Abre primero /kds/setup.',
    failedLoadQueue: 'No se pudo cargar la cola',
    updateFailed: 'No se pudo actualizar',
    cancelFailed: 'No se pudo cancelar',
    fulfillment: {
      queued: 'En cola',
      in_progress: 'En preparación',
      ready: 'Listo',
      shipped: 'Enviado',
      cancelled: 'Cancelado',
      completed: 'Completado'
    },
    relativeJustNow: 'Ahora mismo',
    relativeMinutesAgo: 'hace {n} min',
    relativeHoursAgo: 'hace {n} h',
    relativeOneDayAgo: 'hace 1 día',
    relativeDaysAgo: 'hace {n} días',
    printDocTitle: 'Pedido #{id}',
    printHeading: 'Pedido #{id}',
    customerGuest: 'Invitado',
    openStaffKitchenQueue: 'Abrir cola de cocina del personal',
    backToEquipment: 'Volver a Equipos'
  },
  scheduling: {
    title: 'Citas',
    subtitle: 'Ver y administrar citas de esta ubicación.',
    settingsSubtitle: 'Configurar servicios, personal y disponibilidad.',
    columnTime: 'Hora',
    columnCustomer: 'Cliente',
    columnStatus: 'Estado',
    refreshList: 'Recargar citas',
    dialogBookSubtitle: 'Elija el servicio y luego la fecha y hora en el calendario.',
    dialogAppointmentSubtitle: 'Revise los detalles y continúe.',
    editService: 'Editar servicio',
    dialogServiceSubtitle: 'Cada servicio debe vincularse a un producto para cobrar el precio correcto.',
    dialogStaffSubtitle: 'Elija qué servicios puede realizar esta persona.',
    dialogRuleSubtitle: 'Defina el horario semanal habitual del personal seleccionado.',
    dialogExceptionSubtitle: 'Bloquee un día completo u horario especial para una fecha.',
    selectNoServices: 'No hay servicios disponibles. Agréguelos en la configuración de Citas.',
    selectNoMatchingServices: 'Ningún servicio coincide con la búsqueda.',
    selectNoStaff: 'No hay personal configurado. Agréguelo en la configuración de Citas.',
    selectNoStaffOffersService: 'Ningún miembro del personal ofrece este servicio. Actualice al personal en la configuración.',
    selectNoMatchingStaff: 'Ningún miembro del personal coincide con la búsqueda.',
    selectNoTimeSlots: 'No hay horarios disponibles para esta selección. Pruebe con otro miembro del personal o revise la disponibilidad.',
    selectNoMatchingTimeSlots: 'Ningún horario coincide con la búsqueda.',
    selectTimeSlotsNeedDate: 'Primero elija la fecha de la cita.',
    selectTimeSlotsNeedServiceStaff: 'Primero elija un servicio y un miembro del personal.',
    slotPickerTitle: 'Fecha y hora',
    slotPickerSubtitle: 'Los días con punto tienen disponibilidad. Elija un día y luego una hora.',
    slotPickerNeedService: 'Primero elija un servicio.',
    slotPickerLegend: 'Colores del personal',
    slotPickerSummaryFailed: 'No se pudo cargar el calendario. Intente de nuevo.',
    slotPickerPickDate: 'Seleccione una fecha en el calendario.',
    slotPickerLoadFailed: 'No se pudieron cargar los horarios. Intente de nuevo.',
    slotPickerNoSlotsDay: 'No hay horarios este día para este servicio.',
    slotPickerOneTime: '1 horario',
    slotPickerTimesCount: '{count} horarios',
    slotPickerBack: 'Atrás',
    slotPickerChoose: 'Elegir fecha y hora',
    slotPickerChange: 'Cambiar fecha y hora',
    slotPickerSelectServiceFirst: 'Seleccione un servicio para continuar.',
    bookingSelectionLabel: 'Cita',
    dayPartMorning: 'Mañana',
    dayPartAfternoon: 'Tarde',
    dayPartEvening: 'Noche',
    noServicesYet: 'Aún no hay servicios. Agregue uno para comenzar.',
    noStaffYet: 'Aún no hay personal. Agregue un miembro del equipo.',
    settings: 'Configuración',
    back: 'Volver',
    today: 'Hoy',
    calendar: 'Calendario',
    calLayoutGrid: 'Cuadrícula',
    calLayoutList: 'Lista',
    calDay: 'Día',
    calWeek: 'Semana',
    calMonth: 'Mes',
    calPrev: 'Período anterior',
    calNext: 'Período siguiente',
    calToday: 'Hoy',
    calPickDate: 'Ir a fecha',
    filterByStaff: 'Filtrar por personal',
    newAppointment: 'Nueva cita',
    noAppointments: 'Sin citas',
    date: 'Fecha',
    service: 'Servicio',
    staff: 'Personal',
    staffMember: 'Miembro del personal',
    staffName: 'Nombre',
    timeSlot: 'Hora',
    book: 'Reservar',
    appointment: 'Cita',
    checkIn: 'Registrar llegada',
    startSale: 'Iniciar venta',
    cancelAppointment: 'Cancelar cita',
    cancelAppointmentConfirmTitle: '¿Cancelar esta cita?',
    cancelAppointmentConfirmMessage:
      'Se quitará del calendario. Los clientes con enlace al portal pueden verla como cancelada. Puede restaurarla después si fue un error.',
    cancelAppointmentConfirmAction: 'Sí, cancelar',
    restoreAppointment: 'Restaurar cita',
    restoreAppointmentConfirmTitle: '¿Restaurar esta cita?',
    restoreAppointmentConfirmMessage: 'Volverá a estar programada y aparecerá en su calendario.',
    appointmentRestored: 'Cita restaurada',
    statusChangeFailed: 'No se pudo actualizar la cita. Intente de nuevo.',
    saved: 'Guardado',
    checkedIn: 'Registrado',
    cancelled: 'Cancelado',
    servicesTitle: 'Servicios',
    staffTitle: 'Personal',
    addService: 'Agregar servicio',
    addStaff: 'Agregar personal',
    editStaff: 'Editar miembro del personal',
    serviceName: 'Nombre del servicio',
    servicePrice: 'Precio',
    durationMinutes: 'Duración (minutos)',
    product: 'Producto',
    productOptionalHint: 'Opcional: vincule un producto del TPV para cobrar en caja, o déjelo vacío y establezca un precio arriba.',
    services: 'Servicios',
    servicesOffered: 'Servicios ofrecidos',
    availabilityTitle: 'Disponibilidad',
    availabilityHint: 'Elija un miembro del personal para editar horario y excepciones.',
    weeklyRules: 'Horario semanal',
    exceptions: 'Excepciones',
    setSchedule: 'Definir horario',
    setScheduleSubtitle: 'Elija los días y agregue uno o más horarios por día.',
    preset247: 'Disponible 24/7',
    presetWeekdays: 'Entre semana (lun–vie)',
    presetWeekend: 'Fin de semana (sáb–dom)',
    addTimeSlot: 'Agregar horario',
    allDayThisDay: 'Todo el día (este día)',
    scheduleSelectDayHint: 'Seleccione un día a la izquierda para editar.',
    scheduleNeedSlotPerDay: 'Agregue al menos un horario para cada día seleccionado.',
    scheduleInvalidSlot: 'La hora de fin debe ser posterior a la de inicio.',
    scheduleSyncFailed: 'No se pudo guardar. No se permiten horarios superpuestos el mismo día.',
    scheduleWindowCount: '{n} franja(s) horaria(s)',
    addException: 'Agregar excepción',
    dayOfWeek: 'Día de la semana',
    day: 'Día',
    opens: 'Apertura',
    closes: 'Cierre',
    closedAllDay: 'Cerrado todo el día',
    closed: 'Cerrado',
    hours: 'Horas',
    createNewProduct: 'Crear producto nuevo…',
    selectNoProductData: 'No hay productos. Busque o cree uno nuevo.',
    selectNoMatchingProducts: 'Ningún producto coincide con la búsqueda.',
    inlineProductHint:
      'El producto nuevo se guarda sin inventario en Sin categoría. Puede editarlo después en Productos.',
    inlineProductName: 'Nombre del producto',
    inlineProductPrice: 'Precio',
    inlineProductRequired: 'Indique el nombre del producto y un precio válido (0 o mayor).',
    productCreateForbidden:
      'No tiene permiso para crear productos. Enlace uno existente o pida ayuda a un administrador.',
    fillRequired: 'Faltan campos obligatorios.',
    completeSaleLinkFailed: 'La venta se completó, pero no se pudo vincular la cita. Actualícela en Citas.',
    days: {
      sun: 'Domingo',
      mon: 'Lunes',
      tue: 'Martes',
      wed: 'Miércoles',
      thu: 'Jueves',
      fri: 'Viernes',
      sat: 'Sábado'
    }
  },
  booking: {
    title: 'Reservas',
    subtitle: 'Ver y administrar reservas de esta ubicación.',
    settingsSubtitle: 'Configurar servicios, personal, disponibilidad, pagos y reservas en su sitio web.',
    columnTime: 'Hora',
    columnCustomer: 'Cliente',
    columnStatus: 'Estado',
    columnPayment: 'Pago',
    refreshList: 'Recargar reservas',
    dialogBookSubtitle: 'Elija un servicio y luego fecha y hora en el calendario.',
    dialogAppointmentSubtitle: 'Revise los detalles y tome acción.',
    editService: 'Editar servicio',
    dialogServiceSubtitle: 'Indique nombre, duración y precio del servicio reservable.',
    dialogStaffSubtitle: 'Elija qué servicios puede realizar este miembro del equipo.',
    dialogRuleSubtitle: 'Configure horario semanal regular para el personal seleccionado.',
    dialogExceptionSubtitle: 'Bloquee un día completo o defina horario especial para una fecha.',
    selectNoServices: 'No hay servicios. Agregue servicios en la configuración de Reservas.',
    selectNoMatchingServices: 'Ningún servicio coincide con la búsqueda.',
    selectNoStaff: 'No hay personal configurado. Agregue personal en la configuración de Reservas.',
    selectNoStaffOffersService: 'Ningún miembro está asignado a este servicio. Actualice el personal en configuración.',
    selectNoMatchingStaff: 'Ningún miembro coincide con la búsqueda.',
    selectNoTimeSlots: 'No hay horarios disponibles. Pruebe otro miembro o revise la disponibilidad.',
    selectNoMatchingTimeSlots: 'Ningún horario coincide con la búsqueda.',
    selectTimeSlotsNeedDate: 'Elija primero una fecha.',
    selectTimeSlotsNeedServiceStaff: 'Seleccione servicio y personal primero.',
    slotPickerTitle: 'Fecha y hora',
    slotPickerSubtitle: 'Los días con punto tienen disponibilidad. Toque un día y luego una hora.',
    slotPickerNeedService: 'Seleccione un servicio primero.',
    slotPickerLegend: 'Colores del personal',
    slotPickerSummaryFailed: 'No se pudo cargar el calendario. Intente de nuevo.',
    slotPickerPickDate: 'Seleccione una fecha en el calendario.',
    slotPickerLoadFailed: 'No se pudieron cargar los horarios. Intente de nuevo.',
    slotPickerNoSlotsDay: 'No hay horarios abiertos este día para este servicio.',
    slotPickerOneTime: '1 horario',
    slotPickerTimesCount: '{count} horarios',
    slotPickerBack: 'Atrás',
    slotPickerChoose: 'Elegir fecha y hora',
    slotPickerChange: 'Cambiar fecha y hora',
    slotPickerSelectServiceFirst: 'Seleccione un servicio para habilitar la reserva.',
    bookingSelectionLabel: 'Reserva',
    dayPartMorning: 'Mañana',
    dayPartAfternoon: 'Tarde',
    dayPartEvening: 'Noche',
    noServicesYet: 'Aún no hay servicios. Agregue uno para comenzar.',
    noStaffYet: 'Aún no hay personal. Agregue un miembro del equipo.',
    settings: 'Configuración',
    back: 'Volver',
    today: 'Hoy',
    calendar: 'Calendario',
    calLayoutGrid: 'Cuadrícula',
    calLayoutList: 'Lista',
    calDay: 'Día',
    calWeek: 'Semana',
    calMonth: 'Mes',
    calPrev: 'Periodo anterior',
    calNext: 'Periodo siguiente',
    calToday: 'Hoy',
    calPickDate: 'Ir a fecha',
    filterByStaff: 'Filtrar por personal',
    newAppointment: 'Nueva reserva',
    noAppointments: 'Sin reservas',
    date: 'Fecha',
    service: 'Servicio',
    staff: 'Personal',
    staffMember: 'Miembro del personal',
    staffName: 'Nombre',
    timeSlot: 'Hora',
    book: 'Reservar',
    appointment: 'Reserva',
    checkIn: 'Registrar llegada',
    startSale: 'Iniciar venta',
    cancelAppointment: 'Cancelar reserva',
    statusChangeFailed: 'No se pudo actualizar la reserva. Intente de nuevo.',
    saved: 'Guardado',
    checkedIn: 'Registrado',
    cancelled: 'Cancelado',
    servicesTitle: 'Servicios',
    staffTitle: 'Personal',
    addService: 'Agregar servicio',
    addStaff: 'Agregar personal',
    editStaff: 'Editar miembro',
    serviceName: 'Nombre del servicio',
    servicePrice: 'Precio',
    durationMinutes: 'Duración (minutos)',
    product: 'Producto',
    productOptionalHint: 'Opcional: vincule un producto del TPV para cobrar en caja, o déjelo vacío y establezca un precio arriba.',
    services: 'Servicios',
    servicesOffered: 'Servicios ofrecidos',
    availabilityTitle: 'Disponibilidad',
    availabilityHint: 'Elija un miembro del personal para editar horario semanal y excepciones.',
    weeklyRules: 'Horario semanal',
    exceptions: 'Excepciones',
    setSchedule: 'Definir horario',
    setScheduleSubtitle: 'Elija los días y agregue una o más ventanas horarias para cada uno.',
    preset247: 'Disponible 24/7',
    presetWeekdays: 'Entre semana (lun–vie)',
    presetWeekend: 'Fin de semana (sáb–dom)',
    addTimeSlot: 'Agregar franja horaria',
    allDayThisDay: 'Todo el día (este día)',
    scheduleSelectDayHint: 'Seleccione un día a la izquierda para editar sus horas.',
    scheduleNeedSlotPerDay: 'Agregue al menos una ventana horaria para cada día seleccionado.',
    scheduleInvalidSlot: 'Cada ventana debe terminar después de la hora de inicio.',
    scheduleSyncFailed: 'No se pudo guardar. No se permiten horarios superpuestos el mismo día.',
    scheduleWindowCount: '{n} ventana(s) horaria(s)',
    addException: 'Agregar excepción',
    dayOfWeek: 'Día de la semana',
    day: 'Día',
    opens: 'Abre',
    closes: 'Cierra',
    closedAllDay: 'Cerrado todo el día',
    closed: 'Cerrado',
    hours: 'Horas',
    createNewProduct: 'Crear producto nuevo…',
    selectNoProductData: 'No hay productos. Busque o cree uno nuevo.',
    selectNoMatchingProducts: 'Ningún producto coincide con la búsqueda.',
    inlineProductHint:
      'El producto nuevo se guarda sin inventario en Sin categoría. Puede editarlo después en Productos.',
    inlineProductName: 'Nombre del producto',
    inlineProductPrice: 'Precio',
    inlineProductRequired: 'Indique el nombre del producto y un precio válido (0 o mayor).',
    productCreateForbidden:
      'No tiene permiso para crear productos. Enlace uno existente o pida ayuda a un administrador.',
    fillRequired: 'Faltan campos obligatorios.',
    completeSaleLinkFailed: 'La venta se completó, pero no se pudo vincular la reserva. Actualícela en Reservas.',
    paymentStatusUnpaid: 'Sin pagar',
    collectPayment: 'Cobrar pago',
    collectPaymentTitle: 'Cobrar pago',
    collectPaymentSubtitle: 'Cargue una tarjeta, use una guardada, envíe un enlace o registre un pago manual.',
    collectPaymentSuccess: 'Pago registrado',
    collectPaymentFailed: 'No se pudo completar el pago',
    amountDue: 'Monto adeudado',
    collectTabCard: 'Tarjeta',
    collectTabSavedCard: 'Tarjeta guardada',
    collectTabSendLink: 'Enviar enlace',
    collectTabManual: 'Manual',
    collectCardUnavailable: 'La entrada de tarjeta no está configurada para esta ubicación.',
    collectAmountOptional: 'Monto (opcional)',
    collectNoSavedCards: 'Este cliente no tiene tarjetas guardadas.',
    collectSubmitCard: 'Cobrar tarjeta',
    collectSubmitSavedCard: 'Cobrar tarjeta guardada',
    collectEmailTo: 'Correo del destinatario',
    collectEmailRequired: 'Indique un correo electrónico',
    collectManualAmount: 'Monto',
    collectManualAmountRequired: 'Indique un monto válido',
    collectManualMethod: 'Método de pago',
    collectManualReference: 'Referencia (opcional)',
    collectManualNotes: 'Notas (opcional)',
    collectSubmitManual: 'Registrar pago',
    manualMethodCash: 'Efectivo',
    manualMethodCheck: 'Cheque',
    manualMethodCardExternal: 'Tarjeta externa',
    manualMethodBankTransfer: 'Transferencia bancaria',
    manualMethodOther: 'Otro',
    paymentLinkLabel: 'Enlace de pago',
    generatePaymentLink: 'Generar enlace',
    generatePaymentLinkFailed: 'No se pudo generar el enlace de pago',
    emailPaymentLink: 'Enviar enlace',
    emailPaymentLinkSent: 'Enlace de pago enviado',
    emailPaymentLinkFailed: 'No se pudo enviar el enlace de pago',
    paymentLinkEmailSection: 'Enviar enlace por correo',
    paymentLinkSmsSection: 'Enviar enlace por SMS',
    collectSmsTo: 'Teléfono del destinatario',
    collectSmsRequired: 'Ingrese un número de teléfono',
    collectSmsUsOnly: 'Los SMS solo se pueden enviar a números de EE. UU.',
    sendPaymentLinkEmail: 'Enviar correo',
    sendPaymentLinkSms: 'Enviar SMS',
    smsPaymentLinkSent: 'Enlace de pago enviado por SMS',
    smsPaymentLinkFailed: 'No se pudo enviar el enlace de pago por SMS',
    paymentLinkCopied: 'Enlace de pago copiado',
    paymentLinkCopyFailed: 'No se pudo copiar el enlace',
    generalSettingsTitle: 'Configuración de reservas',
    embedSettingsTitle: 'Widget de reservas en su sitio',
    embedSettingsHint:
      'Copie el bloque de código siguiente en su sitio web. El área de reservas ajusta la altura automáticamente en cada paso.',
    embedCodeTitle: 'Código para su sitio web',
    embedIframeTitle: 'Reservas en línea',
    copyEmbedCode: 'Copiar código del sitio',
    embedCodeCopied: 'Código copiado',
    embedCodeCopyFailed: 'No se pudo copiar el código',
    previewEmbed: 'Vista previa',
    enablePublicBooking: 'Permitir reservas en su sitio web',
    posIntegrationEnabled: 'Habilitar integración POS (Iniciar venta)',
    embedTitle: 'Título del widget',
    embedWelcomeMessage: 'Mensaje de bienvenida',
    successMessage: 'Mensaje de éxito',
    depositPolicy: 'Política de depósito',
    depositPolicyNone: 'Sin depósito',
    depositPolicyFixed: 'Monto fijo',
    depositPolicyPercent: 'Porcentaje',
    depositPolicyFullPrepay: 'Prepago total',
    depositAmount: 'Monto del depósito',
    depositPercent: 'Porcentaje del depósito',
    depositEmbedHint: 'El formulario público muestra el monto de hoy y el saldo restante cuando hay política de depósito.',
    requirePaymentToConfirm: 'Requerir pago para confirmar reserva',
    pendingPaymentTtlMinutes: 'Tiempo de retención en checkout (minutos)',
    pendingPaymentTtlHint: 'Las reservas sin pago en línea retienen la salida durante este tiempo y luego se liberan automáticamente.',
    bookingStyleLabel: 'Estilo de reserva',
    bookingStyleColumn: 'Estilo',
    bookingStyle: {
      appointment: 'Cita',
      experience: 'Experiencia / viaje',
      transport: 'Transporte'
    },
    serviceDescription: 'Descripción',
    fixedStartTime: 'Hora de salida',
    fixedStartTimeHint: 'Hora fija de salida del viaje (zona horaria de la ubicación). Obligatoria para experiencias.',
    fixedStartTimeRequired: 'Las experiencias requieren una hora de salida.',
    maxPartySize: 'Tamaño máximo del grupo',
    maxPartySizeHint: 'Máximo de huéspedes por salida mostrado en su sitio web.',
    showInPublicEmbed: 'Mostrar en su sitio web',
    durationLabel: 'Duración',
    durationPresetsHint: 'Opciones rápidas para duraciones habituales',
    durationCustomLabel: 'O define una duración personalizada',
    durationCustomDays: 'Días',
    durationCustomHours: 'Horas',
    durationCustomMinutes: 'Minutos',
    durationSelectedHint: 'Las reservas bloquean {duration} en el calendario.',
    durationFormatDays: '{count} día | {count} días',
    durationFormatHours: '{count} hora | {count} horas',
    durationFormatMinutes: '{count} minuto | {count} minutos',
    durationFormatMixed: '{days}d {hours}h {minutes}m',
    durationPreset: {
      '30m': '30 min',
      '1h': '1 hora',
      '2h': '2 horas',
      '4h': '4 horas',
      '6h': '6 horas',
      '8h': '8 horas',
      '12h': '12 horas',
      '1d': 'Día completo (24h)',
      '2d': '2 días',
      '3d': '3 días'
    },
    leadTimeDays: 'Anticipación mínima (días)',
    leadTimeHours: 'Horas',
    leadTimeHint: 'Los clientes no pueden reservar antes de {total} horas desde ahora.',
    cancellationWindowHours: 'Ventana de cancelación (horas)',
    cancellationWindowHint: 'Los viajes que salen dentro de este plazo se muestran como no reembolsables y bloquean la cancelación en línea.',
    customerCanCancel: 'Permitir cancelación en línea por clientes',
    pricingModeLabel: 'Base de precio',
    pricingMode: {
      fixed: 'Precio fijo',
      tiered: 'Por tamaño de grupo',
      quote: 'Cotización (precio manual)'
    },
    pricingModeQuoteHint: 'Los clientes solicitan cotización; establezca el precio cotizado en cada reserva del calendario.',
    priceTiersTitle: 'Niveles de precio por grupo',
    priceTiersHint: 'Total fijo del viaje para cada rango de huéspedes. Los niveles deben cubrir del 1 al tamaño máximo del grupo sin huecos.',
    tierMinParty: 'Mín. huéspedes',
    tierMaxParty: 'Máx. huéspedes',
    tierPrice: 'Total del viaje',
    addPriceTier: 'Agregar nivel',
    priceTiersRequired: 'Agregue al menos un nivel de precio.',
    priceTiersInvalidRange: 'Cada nivel necesita conteos mínimo y máximo válidos.',
    priceTiersInvalidPrice: 'Cada nivel necesita un precio válido (0 o mayor).',
    priceTiersGap: 'Los niveles deben cubrir cada tamaño de grupo del 1 al {max} sin huecos.',
    priceTiersExceedMaxParty: 'Un nivel supera el tamaño máximo del grupo.',
    priceTiersMaxReached: 'Todos los tamaños de grupo ya están cubiertos.',
    priceTiersFleetUnitSizeRequired: 'Defina huéspedes por unidad antes de configurar niveles de precio de flota.',
    fleetSettingsTitle: 'Capacidad de flota',
    fleetSettingsHint: 'Pool global de unidades (botes, vehículos, etc.) compartido entre servicios en modo flota. Un tope de 0 desactiva reservas en línea para servicios de flota en ese período.',
    fleetSize: 'Tamaño de flota (unidades máx.)',
    capacityUnitLabelSingular: 'Etiqueta de unidad (singular)',
    capacityUnitLabelPlural: 'Etiqueta de unidad (plural)',
    defaultCapacityUnitSize: 'Huéspedes por unidad (predeterminado)',
    fleetPeriodRulesTitle: 'Topes estacionales de flota',
    fleetPeriodStartsOn: 'Desde',
    fleetPeriodEndsOn: 'Hasta',
    fleetPeriodMaxUnits: 'Unidades máx.',
    fleetPeriodMaxUnitsHint: 'Use 0 para bloquear reservas en línea de servicios de flota en este período.',
    fleetPeriodNotes: 'Notas',
    addFleetPeriodRule: 'Agregar regla de período',
    noFleetPeriodRules: 'No hay topes estacionales configurados.',
    fleetServiceRulesTitle: 'Reglas de capacidad por servicio',
    fleetServiceRuleService: 'Servicio',
    fleetServiceRuleBlackout: 'Bloqueo (sin reserva en línea)',
    fleetServiceRuleMaxUnitsPerBooking: 'Unidades máx. por reserva',
    fleetServiceRuleTimeFrom: 'Salida permitida desde',
    fleetServiceRuleTimeTo: 'Salida permitida hasta',
    addFleetServiceRule: 'Agregar regla de servicio',
    noFleetServiceRules: 'No hay reglas de servicio configuradas.',
    capacityModeLabel: 'Modo de capacidad',
    capacityMode: {
      simple: 'Simple (una reserva exclusiva por salida)',
      fleet_units: 'Unidades de flota (pool compartido, varias reservas)'
    },
    capacityModeSimpleHint: 'Una reserva ocupa toda la salida. Los niveles aplican al grupo completo.',
    capacityModeFleetHint: 'Varias reservas comparten un pool hasta agotar unidades. Los niveles aplican por unidad (1 hasta huéspedes por unidad).',
    capacityUnitSize: 'Huéspedes por unidad',
    maxUnitsPerBooking: 'Unidades máx. por reserva',
    priceTiersFleetHint: 'Precio por unidad para cada cantidad de huéspedes del 1 al máximo por unidad. Grupos grandes usan varias unidades (ej. 5 huéspedes con 4 por unidad = una unidad llena más una de 1 huésped).',
    priceTiersExceedUnitSize: 'Un nivel supera los huéspedes por unidad.',
    tripStaffMembers: 'Capitanes del viaje',
    tripStaffMembersHint: 'El capitán principal se usa para conflictos de horario. Agregue co-capitanes para reportes.',
    saveStaffMembers: 'Guardar capitanes',
    capacityUnitsReserved: 'Unidades de flota reservadas',
    capacityUnitsCount: '{count} {unit}',
    settingsTabGeneral: 'General',
    settingsTabEmbed: 'Sitio web',
    settingsTabFleet: 'Capacidad de flota',
    settingsTabServices: 'Servicios',
    backToBookingSettings: 'Volver a configuración de reservas',
    settingsHubSubtitle: 'Configuración general, servicios y capacidad de flota',
    settingsGeneralSubtitle: 'Reservas en su sitio web, pagos y políticas para clientes',
    settingsServicesSubtitle: 'Administre servicios reservables, precios y modos de capacidad',
    settingsFleetSubtitle: 'Tamaño de flota, topes estacionales y reglas de reserva por servicio',
    settingsTileGeneral: 'General',
    settingsTileGeneralEnabled: 'Reservas públicas activadas',
    settingsTileGeneralDisabled: 'Reservas públicas desactivadas',
    settingsTileServices: 'Servicios',
    settingsTileServicesDesc: 'Viajes, citas, niveles de precio y capacidad de flota por servicio',
    settingsTileServicesCount: '{count} servicio configurado | {count} servicios configurados',
    settingsTileFleet: 'Capacidad de flota',
    settingsTileFleetDesc: 'Pool de {count} unidades, topes estacionales, bloqueos y límites',
    fleetPeriodRulesHint: 'Ajuste cuántas unidades de flota están disponibles en línea durante rangos de fechas.',
    fleetServiceRulesHint: 'Bloquee reservas, limite unidades por reserva o restrinja horarios de salida por servicio.',
    fleetRulesViewList: 'Lista',
    fleetRulesViewCalendar: 'Calendario',
    fleetRuleColumnDateRange: 'Rango de fechas',
    fleetRuleColumnSummary: 'Efecto',
    fleetRuleAlways: 'Siempre',
    fleetRuleSummaryBlocked: 'Bloquear reserva en línea',
    fleetRuleSummaryCap: 'Tope: {count} unidades',
    fleetRuleSummaryFullFleet: 'Flota completa ({count})',
    fleetRuleChipBlock: 'Bloquear reserva en línea',
    fleetRuleChipFullFleet: 'Flota completa ({count})',
    editFleetPeriodRule: 'Editar tope estacional',
    editFleetServiceRule: 'Editar regla de servicio',
    fleetPeriodRuleDialogSubtitle: 'Defina un rango de fechas y cuántas unidades pueden reservarse en línea.',
    fleetServiceRuleDialogSubtitle: 'Restrinja reservas en línea para un servicio específico.',
    fleetServiceRuleTypeLabel: 'Tipo de regla',
    fleetServiceRuleTypeBlackout: 'Bloquear reserva en línea',
    fleetServiceRuleTypeMaxUnitsLabel: 'Limitar unidades por reserva',
    fleetServiceRuleTypeTimeWindowLabel: 'Restringir horarios de salida',
    fleetServiceRuleTypeMaxUnits: 'Máx. {count} unidades por reserva',
    fleetServiceRuleTypeTimeWindow: 'Salidas {from} – {to}',
    fleetServiceRuleDateOptionalHint: 'Deje las fechas vacías para aplicar la regla en todo momento.',
    fleetServiceRuleBlackoutHint: 'Los clientes no pueden reservar este servicio en línea mientras la regla esté activa.',
    fleetServiceRuleMaxUnitsHint: 'Limita cuántas unidades de flota puede consumir una reserva.',
    fleetServiceRuleTimeRequired: 'Defina al menos un límite de horario de salida.',
    fleetDateRangeHint: 'Seleccione fecha de inicio y fin en el calendario, o use los campos avanzados.',
    fleetDateRangeAdvanced: 'Entrada avanzada de fechas',
    fleetCalendarLegend: 'Leyenda',
    fleetCalendarLegendBlocked: 'Bloqueado / blackout',
    fleetCalendarLegendReducedCap: 'Tope de flota reducido',
    fleetCalendarLegendBlackout: 'Blackout de servicio',
    fleetCalendarLegendMaxUnits: 'Límite de unidades',
    fleetCalendarLegendTimeWindow: 'Ventana horaria',
    fleetCalendarRulesOnDate: 'Reglas el {date}',
    fleetCalendarNoRulesOnDate: 'No hay reglas para esta fecha.',
    fleetCalendarAddForDate: 'Agregar regla para esta fecha',
    fleetCalendarFilterService: 'Filtrar por servicio',
    fleetCalendarAllServices: 'Todos los servicios',
    addFirstFleetPeriodRule: 'Agregue su primer tope estacional',
    addFirstFleetServiceRule: 'Agregue su primera regla de servicio',
    serviceTabBasics: 'Básico',
    serviceTabCapacity: 'Capacidad y precio',
    serviceTabProduct: 'Producto',
    serviceCapacityExperienceOnly: 'La capacidad y flota aplican a servicios de experiencia (viaje).',
    settingsSaveFailed: 'No se pudo guardar la configuración de reservas',
    runSetupWizard: 'Ejecutar asistente de configuración',
    setupWizardTitle: 'Configuración de reservas',
    setupWizardSubtitle: 'Agregue su primer servicio, personal, horario y código para su sitio web.',
    setupStepService: 'Servicio',
    setupStepStaff: 'Personal',
    setupStepHours: 'Horario',
    setupStepEmbed: 'Sitio web',
    setupStepServiceHint: 'Cree el primer servicio reservable que los clientes pueden elegir.',
    setupStepStaffHint: 'Agregue un proveedor que realice este servicio.',
    setupStepHoursHint: 'Defina cuándo los clientes pueden reservar en línea.',
    setupStepEmbedHint: 'Active las reservas en su sitio y copie el bloque de código completo.',
    setupSoloProvider: 'Soy el único proveedor',
    setupBack: 'Atrás',
    setupContinue: 'Continuar',
    setupFinish: 'Finalizar',
    setupComplete: 'Configuración de reservas completada',
    setupSaveFailed: 'No se pudo guardar la configuración',
    setupStaffMissing: 'Agregue personal antes de definir horarios.',
    days: {
      sun: 'Domingo',
      mon: 'Lunes',
      tue: 'Martes',
      wed: 'Miércoles',
      thu: 'Jueves',
      fri: 'Viernes',
      sat: 'Sábado'
    }
  },
  projects: {
    title: 'Proyectos',
    subtitle: 'Seguimiento de rentabilidad por trabajo con facturas y gastos',
    listTitle: 'Todos los proyectos',
    emptyList: 'No hay proyectos con estos filtros. Cree uno o ajuste la búsqueda.',
    refreshList: 'Actualizar lista',
    backToProjects: 'Volver a proyectos',
    detailSubtitle: 'Facturas vinculadas, gastos y rentabilidad del trabajo.',
    formSubtitle: 'Cliente, fechas, presupuesto y notas del trabajo.',
    projectDetails: 'Detalles del proyecto',
    financialSummary: 'Resumen financiero',
    invoicesTabHint: 'Vincule facturas existentes o cree una nueva para este proyecto.',
    invoicesEmpty: 'Aún no hay facturas vinculadas. Vincule facturas o cree una desde aquí.',
    deleteExpenseTitle: '¿Eliminar gasto?',
    newProject: 'Nuevo proyecto',
    editProject: 'Editar proyecto',
    search: 'Buscar proyectos',
    number: 'Número',
    name: 'Nombre',
    customer: 'Cliente',
    customerOrCompany: 'Cliente o empresa',
    status: 'Estado',
    budget: 'Presupuesto',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de fin',
    description: 'Descripción',
    internalNotes: 'Notas internas',
    nameRequired: 'El nombre del proyecto es obligatorio',
    statusDraft: 'Borrador',
    statusActive: 'Activo',
    statusOnHold: 'En pausa',
    statusCompleted: 'Completado',
    statusCancelled: 'Cancelado',
    tabOverview: 'Resumen',
    tabInvoices: 'Facturas',
    tabExpenses: 'Gastos',
    revenueBilled: 'Facturado',
    revenueCollected: 'Cobrado',
    outstanding: 'Pendiente',
    expensesTotal: 'Gastos',
    margin: 'Margen',
    linkInvoices: 'Vincular facturas',
    linkInvoicesSubtitle: 'Seleccione las facturas que pertenecen a este proyecto.',
    linkSelected: 'Vincular seleccionadas',
    searchInvoices: 'Buscar facturas sin vincular',
    createInvoice: 'Crear factura',
    snapReceipt: 'Fotografiar recibo',
    choosePhoto: 'Elegir foto',
    chooseReceipt: 'Elegir foto o PDF',
    receiptPdfAttached: 'Recibo PDF adjunto',
    receiptFileTypeInvalid: 'Elija una foto (JPEG, PNG, WebP) o un PDF.',
    enterManually: 'Ingresar manualmente',
    addExpense: 'Agregar gasto',
    addExpenseSubtitle: 'Fotografíe o suba un recibo, o ingrese los datos manualmente.',
    newExpense: 'Nuevo gasto',
    newExpenseSubtitle: 'Revise los datos y guarde cuando esté listo.',
    editExpenseSubtitle: 'Actualice monto, fecha o reemplace el recibo.',
    expensesTabHint: 'Registre costos del trabajo con recibos o entradas manuales.',
    expensesEmpty: 'Aún no hay gastos. Agregue un recibo o ingrese uno manualmente.',
    saveExpense: 'Guardar gasto',
    editExpense: 'Editar gasto',
    replaceReceipt: 'Reemplazar recibo',
    deleteExpenseConfirm: '¿Eliminar este gasto? Esta acción no se puede deshacer.',
    vendor: 'Proveedor',
    amount: 'Monto',
    expenseDate: 'Fecha del gasto',
    category: 'Categoría',
    notes: 'Notas',
    amountRequired: 'El monto es obligatorio',
    ocrPending: 'Leyendo recibo…',
    ocrFailed: 'No se pudo leer el recibo automáticamente. Ingrese los datos manualmente.'
  },
  nav: {
    dashboard: 'Panel de control',
    salesRegister: 'Registro de ventas',
    sales: 'Ventas',
    customers: 'Clientes',
    leads: 'Prospectos',
    invoices: 'Facturas',
    projects: 'Proyectos',
    tabs: 'Cuentas',
    rentals: 'Alquileres',
    events: 'Eventos',
    scheduling: 'Citas',
    booking: 'Reservas',
    products: 'Productos',
    registers: 'Registradoras',
    reports: 'Informes',
    settings: 'Configuración',
    dejavoo: 'PoC Dejavoo'
  },
  stripeConnect: {
    hubTitle: 'Pagos con Stripe',
    hubDesc: 'Registro, pedido de hardware y cobros con tarjeta',
    title: 'Configuración de pagos Stripe',
    subtitle: 'Complete el registro para aceptar pagos en línea y en persona.',
    ready: 'Listo para aceptar pagos',
    notReady: 'Configuración pendiente',
    accountId: 'Cuenta conectada',
    createAccount: 'Iniciar configuración Stripe',
    continueOnboarding: 'Continuar configuración',
    accountCreated: 'Cuenta Stripe creada',
    createFailed: 'No se pudo crear la cuenta Stripe',
    sessionFailed: 'No se pudo iniciar la sesión de registro',
    statusFailed: 'No se pudo cargar el estado de Stripe',
    testMode: 'Modo de prueba',
    tabOnboarding: 'Configuración de cuenta',
    tabHardware: 'Pedir hardware',
    tabReaders: 'Lectores y Tap to Pay',
    hardwareDesc: 'Pida lectores Stripe Terminal y accesorios con envío a su negocio.',
    hardwareHeroTitle: 'Obtenga lectores para su tienda',
    hardwareHeroSubtitle: 'Pida hardware oficial Stripe Terminal con envío a su ubicación y regístrelo en Blu cuando llegue.',
    hardwareStepLabel: 'Paso {n}',
    hardwareStepOrder: 'Elija hardware',
    hardwareStepOrderDesc: 'Seleccione un lector para su mostrador—Stripe envía con checkout seguro abajo.',
    hardwareStepShip: 'Siga el envío',
    hardwareStepShipDesc: 'Stripe envía correos con seguimiento. Expanda el historial de pedidos para ver el estado.',
    hardwareStepRegister: 'Registre en Blu',
    hardwareStepRegisterDesc: 'Ingrese el código de emparejamiento de la etiqueta del lector para usarlo en caja.',
    hardwareShopTitle: 'Tienda de hardware Stripe',
    hardwareShopLoading: 'Cargando tienda…',
    hardwareOrdersTitle: 'Historial y seguimiento',
    hardwareOrdersDesc: 'Vea pedidos anteriores y estado de entrega en Stripe.',
    hardwareOrderPlacedTitle: 'Pedido realizado',
    hardwareOrderPlacedBody: 'Cuando llegue su lector, abra Lectores y Tap to Pay e ingrese el código de la etiqueta.',
    hardwareOrderPlacedCta: 'Registrar lector',
    hardwareOrderPlacedDismiss: 'Seguir comprando',
    hardwareAfterOrderHint: 'Cuando Stripe envíe su lector, regístrelo con el código de emparejamiento de la etiqueta del dispositivo.',
    openReadersTab: 'Lectores y Tap to Pay',
    registrationCodeHint: 'Impreso en la etiqueta del lector o en la confirmación de pedido de Stripe.',
    currentLocation: 'Ubicación: {name}',
    readersEmptyTitle: 'Aún no hay lectores en esta ubicación',
    readersEmptyHint: 'Registre un lector con su código o sincronice desde Stripe después de registrarlo en el panel de Stripe.',
    androidTapToPayTitle: 'Tap to Pay en este teléfono (Android)',
    androidTapToPayHint: 'Use la app Blu en un teléfono Android con NFC en caja. Permita ubicación cuando se solicite. No se requiere lector aparte si Tap to Pay está en verde arriba.',
    tapToPayLocationDenied: 'Se requiere permiso de ubicación para Stripe Tap to Pay. Active ubicación para Blu en ajustes del sistema e intente de nuevo.',
    tapToPayUnavailable: 'Tap to Pay no está disponible en este dispositivo.',
    missingPublishableKey: 'Stripe no está configurado en el servidor (falta la clave publicable).',
    registerReaderTitle: 'Registrar un lector que ya tiene',
    registerReaderHint: 'Ingrese el código de emparejamiento de la etiqueta del lector; luego asígnelo a una caja en Configuración de equipos.',
    registrationCode: 'Código de registro',
    readerLabel: 'Etiqueta del lector (opcional)',
    registerReader: 'Registrar lector',
    readerRegistered: 'Lector Stripe registrado para esta ubicación',
    readerRegisterFailed: 'No se pudo registrar el lector',
    selectLocation: 'Seleccione una ubicación en el POS antes de registrar un lector.',
    readinessTitle: 'Preparación de pagos',
    readinessLead: 'Las marcas verdes indican que esa vía está lista. Corrija los errores antes de cobrar en persona o con Tap to Pay.',
    readinessAllClear: 'Todas las vías de pago Stripe están listas.',
    readinessIncomplete: 'Complete los elementos siguientes antes de salir en vivo.',
    scenarioCardPresent: 'Tarjeta presente (lectores)',
    scenarioTapOnPhone: 'Tap to Pay (teléfono)',
    scenarioCnp: 'Captura manual / en línea (CNP)',
    readersAtLocation: 'Lectores en esta ubicación',
    syncReaders: 'Sincronizar desde Stripe',
    readersSynced: 'Lectores Stripe sincronizados para esta ubicación',
    syncReadersFailed: 'No se pudieron sincronizar los lectores Stripe',
    colReaderLabel: 'Etiqueta',
    colReaderId: 'ID de lector Stripe',
    colReaderStatus: 'Estado'
  },
  iphoneTopSetup: {
    title: 'Tap to Pay en iPhone',
    subtitle: 'Configure este iPhone para aceptar pagos sin contacto con Apple Tap to Pay y Dejavoo.',
    continue: 'Continuar',
    iosOnly: 'Abra Blu en un iPhone físico para ejecutar esta configuración.',
    notConfigured: 'Tap to Pay en iPhone aún no está configurado para este negocio. Contacte a soporte Blu si esperaba que estuviera listo.',
    noIphoneTpn: 'No hay un terminal Apple Tap to Pay provisionado para este negocio. El personal de Blu lo habilita en Admin al dar de alta su TPN de iPhone.',
    terminalLabel: 'Terminal: {label}',
    locationDenied: 'Se requiere permiso de ubicación para Tap to Pay en iPhone.',
    deviceIpadUnsupported: 'Tap to Pay en iPhone solo está disponible en iPhone. Abra Blu en un iPhone compatible para aceptar pagos sin contacto.',
    deviceModelUnsupported: 'Este iPhone no admite Tap to Pay en iPhone. Use iPhone Xs o posterior.',
    osVersionNotSupported: 'Actualice este iPhone a iOS 17.6 o posterior para usar Tap to Pay en iPhone.',
    registerSuccess: 'Este iPhone está registrado para Tap to Pay.',
    bluLinkSuccess: 'Este iPhone está vinculado a su cuenta Blu.',
    testSaleApproved: 'Pago de prueba aprobado.',
    testSaleDeclined: 'El pago de prueba no fue aprobado.',
    testSaleFailed: 'No se pudo completar el pago de prueba.',
    promoTitle: 'Tap to Pay en iPhone',
    promoBody: 'Acepte pagos sin contacto en este iPhone—sin hardware extra. Complete la configuración única para habilitar la caja.',
    promoCta: 'Configurar Tap to Pay en iPhone',
    configuringTitle: 'Configurando Tap to Pay en iPhone',
    configuringSubtitle: 'Este iPhone aún no está listo para pagos. Mantenga la app abierta hasta terminar.',
    checkoutBlocked: 'Complete la configuración de Tap to Pay en iPhone antes de cobrar.',
    checkoutDialogTitle: 'Configurar Tap to Pay en iPhone',
    checkoutDialogMessage: 'Este iPhone necesita una configuración única (términos de Apple y registro Dejavoo). Solo toma unos minutos.',
    checkoutDialogCta: 'Iniciar configuración',
    adminRequiredTitle: 'Se requiere gerente o propietario',
    adminRequiredBody: 'Solo un propietario o gerente puede aceptar los términos de Tap to Pay de Apple y registrar este iPhone. Pídales que abran Ajustes → Tap to Pay en iPhone o inicie sesión con una cuenta autorizada.',
    steps: {
      welcome: {
        title: 'Bienvenida',
        body: 'Registrará este iPhone como terminal seguro Tap to Pay. Blu ya provisionó su TPN—no ingrese códigos aquí.',
        bulletUsRegion: 'Región del dispositivo en Estados Unidos',
        bulletDevice: 'iPhone Xs o posterior con iOS 17.6+',
        bulletSandboxAppleId: 'Apple ID de sandbox en este iPhone (UAT / pruebas)',
        bulletProvisioned: 'Blu Admin completó la configuración Tap to Pay del comercio'
      },
      permissions: {
        title: 'Ubicación',
        body: 'Blu usa su ubicación durante el pago para cumplir requisitos de las redes de tarjetas.',
        cta: 'Permitir ubicación'
      },
      register: {
        title: 'Registrar este iPhone',
        body: 'Toque abajo para descargar parámetros del terminal y preparar Apple Tap to Pay en este dispositivo.',
        appleTermsHint: 'Apple puede mostrar términos de Tap to Pay en este paso—revíselos y acéptelos para continuar.',
        cta: 'Registrar con Dejavoo',
        acceptTermsCta: 'Aceptar términos y registrar'
      },
      bluLink: {
        title: 'Vincular con Blu',
        body: 'Conecte este iPhone a su registro de terminal móvil en Blu para ventas e informes.',
        cta: 'Vincular este iPhone'
      },
      done: {
        title: 'Listo',
        body: 'Cobre con Tap to Pay en la caja o pruebe su primer pago sin contacto ahora.',
        tryItCta: 'Probar Tap to Pay en iPhone',
        testSale: 'Prueba de $0.01',
        registers: 'Abrir caja de ventas',
        backToPayments: 'Volver a ajustes Dejavoo'
      }
    }
  },
  iphoneTopMarketing: {
    title: 'Tap to Pay en iPhone',
    bulletContactless: 'Acepte tarjetas de crédito y débito sin contacto directamente en su iPhone.',
    bulletNoHardware: 'Sin lector extra—los clientes acercan su tarjeta o teléfono al suyo.',
    bulletFastCheckout: 'Agilice la caja en el registro de ventas Blu.',
    ctaSetup: 'Configurar Tap to Pay en iPhone',
    ctaLater: 'Ahora no'
  },
  dejavooPoc: {
    resultDialogTitle: 'Resultado de callback Dejavoo',
    requestId: 'ID de solicitud',
    status: 'Estado',
    rawUrl: 'URL sin procesar',
    payload: 'Carga útil',
    copied: 'Copiado',
    iphoneTopTitle: 'Tap to Pay en iPhone (SDK integrado)',
    iphoneTopHint: 'UAT: región US, Apple ID sandbox, Info.plist Environment UAT. NFC requiere un iPhone físico.',
    iphoneLoadConfig: 'Cargar config ToP del backend',
    iphoneIsAvailable: 'Comprobar disponibilidad del plugin',
    iphoneWarmSession: 'Registrar / precalentar sesión',
    iphoneTestSale: 'Venta de prueba (solo SDK)',
    iphoneClearSession: 'Borrar sesión del SDK',
    iphoneLastResult: 'Último resultado ToP iPhone',
    iphoneConfigIncomplete: 'La config Tap to Pay está desactivada o faltan TPN / código de comercio.',
    iphoneSaleAmountPrompt: 'Importe de venta (USD)',
    iphoneInvalidAmount: 'Introduce un importe válido mayor que cero.'
  },
  rentals: {
    title: 'Alquileres',
    subtitle: 'Gestione unidades, acuerdos y facturación',
    mapView: 'Mapa',
    listView: 'Lista',
    location: 'Ubicación',
    building: 'Edificio',
    unit: 'Unidad',
    status: 'Estado',
    customer: 'Cliente',
    rate: 'Tarifa',
    billingTerm: 'Periodo de facturación',
    balance: 'Saldo',
    nextDue: 'Próximo vencimiento',
    actions: 'Acciones',
    apply: 'Aplicar',
    clear: 'Limpiar',
    allLocations: 'Todas las ubicaciones',
    allBuildings: 'Todos los edificios',
    allStatuses: 'Todos los estados',
    pastDueOnly: 'Solo vencidos',
    unitsList: 'Unidades',
    exportCsv: 'Exportar CSV',
    exportFailed: 'Error al exportar',
    settings: 'Configuración',
    newAgreement: 'Nuevo acuerdo',
    editLayout: 'Editar diseño',
    noBuildings: 'No hay edificios configurados para esta ubicación.',
    emptySlot: 'Vacío',
    statusVacant: 'Vacante',
    statusOccupied: 'Ocupada',
    statusPastDue: 'Vencido',
    statusMaintenance: 'Mantenimiento',
    statusReserved: 'Reservada',
    viewAgreement: 'Ver acuerdo',
    back: 'Volver',
    unitDetailTitle: 'Unidad {unit}',
    agreementDetailTitle: 'Acuerdo de alquiler',
    agreementOverview: 'Detalles del acuerdo',
    agreementStatusPending: 'Pendiente',
    agreementStatusActive: 'Activo',
    agreementStatusEnded: 'Finalizado',
    endAgreementConfirm: '¿Finalizar este acuerdo de alquiler? La unidad quedará vacante y la facturación recurrente se detendrá.',
    recurringBilling: 'Facturación recurrente',
    recurringBillingNote: 'Finalizar este acuerdo también termina la programación recurrente.',
    noInvoicesYet: 'Aún no hay facturas',
    currentAgreement: 'Acuerdo actual',
    size: 'Tamaño',
    notes: 'Notas',
    monthly: 'Mensual',
    quarterly: 'Trimestral',
    annual: 'Anual',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de fin',
    activate: 'Activar',
    endAgreement: 'Finalizar acuerdo',
    generateInvoice: 'Generar factura',
    invoiceHistory: 'Historial de facturas',
    invoiceNumber: 'Factura #',
    issueDate: 'Fecha de emisión',
    total: 'Total',
    agreementActivated: 'Acuerdo activado',
    agreementEnded: 'Acuerdo finalizado',
    invoiceGenerated: 'Factura generada',
    actionFailed: 'Acción fallida',
    settingsTitle: 'Configuración de alquileres',
    settingsSubtitle: 'Políticas, edificios y unidades',
    policies: 'Políticas',
    newPolicy: 'Nueva política',
    editPolicy: 'Editar política',
    defaultPolicy: 'Política predeterminada',
    policyName: 'Nombre de política',
    gracePeriodDays: 'Periodo de gracia (días)',
    autoEmailInvoices: 'Enviar facturas por correo automáticamente',
    depositRequired: 'Depósito requerido',
    defaultDeposit: 'Depósito predeterminado',
    defaultMonthlyRate: 'Tarifa mensual predeterminada',
    defaultRateLabel: '{rate}/mes',
    ratePlan: 'Plan de tarifa',
    policyRateNotConfigured: 'Este plan no tiene una tarifa mensual predeterminada configurada.',
    buildings: 'Edificios',
    newBuilding: 'Nuevo edificio',
    editBuilding: 'Editar edificio',
    buildingName: 'Nombre del edificio',
    sortOrder: 'Orden',
    unitCount: '{count} unidades',
    addUnit: 'Agregar unidad',
    unitNumber: 'Número de unidad',
    cancel: 'Cancelar',
    save: 'Guardar',
    create: 'Crear',
    policySaved: 'Política guardada',
    buildingSaved: 'Edificio guardado',
    unitSaved: 'Unidad guardada',
    saveFailed: 'Error al guardar',
    editLayoutTitle: 'Diseño — {name}',
    gridSize: 'Tamaño de cuadrícula',
    rows: 'Filas',
    cols: 'Columnas',
    unplacedUnits: 'Unidades sin colocar',
    allUnitsPlaced: 'Todas las unidades colocadas',
    layoutPreview: 'Vista previa del diseño',
    saveLayout: 'Guardar diseño',
    layoutSaved: 'Diseño guardado',
    layoutSaveFailed: 'Error al guardar diseño',
    dropHere: 'Soltar aquí',
    layoutDragHint: 'Arrastre unidades a la cuadrícula o entre celdas',
    clickSlotToPlace: 'Haga clic en una casilla vacía para colocar la unidad',
    missingRequiredFields: 'Unidad y cliente son obligatorios',
    agreementCreated: 'Acuerdo creado',
    agreementCreateFailed: 'Error al crear acuerdo',
    editUnit: 'Editar unidad',
    deleteUnit: 'Eliminar unidad',
    deleteUnitConfirm: '¿Eliminar unidad {unit}?',
    unitDeleted: 'Unidad eliminada',
    unitLabel: 'Etiqueta',
    operationalStatus: 'Estado operativo',
    opStatusAvailable: 'Disponible',
    generateUnits: 'Generar unidades',
    unitPrefix: 'Prefijo',
    startNumber: 'Número inicial',
    unitCountField: 'Cantidad',
    zeroPad: 'Relleno con ceros',
    generate: 'Generar',
    bulkGenerateResult: 'Se crearon {created} unidades ({skipped} omitidas)',
    noUnitsInBuilding: 'Aún no hay unidades en este edificio.',
    unplacedUnitsMap: 'Unidades sin colocar',
    registerRentUnit: 'Alquilar unidad',
    unitNotAvailableForRent: 'Esta unidad no está disponible para alquilar',
    startRecurringInvoices: 'Iniciar facturas recurrentes para periodos futuros',
    addToRegister: 'Agregar a caja',
    issueInvoiceAndPay: 'Crear contrato y pagar facturas',
    agreementActivatedPayInvoices: 'Contrato creado. Cobre las facturas abiertas.',
    registerCheckoutTotal: 'Total: {total}',
    registerCheckoutFailed: 'Error al preparar el alquiler en caja',
    rentAtRegister: 'Alquilar en caja',
    viewInvoices: 'Ver facturas',
    sendPortalLink: 'Enviar enlace del portal',
    portalLinkTitle: 'Enviar enlace del portal',
    portalLinkSubtitle: 'Envíe por correo o SMS al cliente un enlace seguro para ver y pagar facturas de alquiler',
    portalLinkEmailSection: 'Enviar por correo',
    portalLinkSmsSection: 'Enviar por SMS',
    portalLinkTo: 'Correo del destinatario',
    portalLinkPhone: 'Teléfono del destinatario',
    portalLinkPhoneUsOnly: 'Los SMS solo se pueden enviar a números de EE. UU.',
    portalLinkSubjectOptional: 'Asunto (opcional)',
    portalLinkMessageOptional: 'Mensaje (opcional)',
    portalLinkSendEmail: 'Enviar correo',
    portalLinkSendText: 'Enviar SMS',
    portalLinkSend: 'Enviar enlace',
    portalLinkDefaultSubject: 'Su portal de alquiler — Unidad {unit}',
    portalLinkEmailSent: 'Enlace del portal enviado por correo',
    portalLinkSmsSent: 'Enlace del portal enviado por SMS',
    portalLinkSmsFailed: 'Error al enviar enlace del portal por SMS',
    portalLinkSent: 'Enlace del portal enviado',
    portalLinkFailed: 'Error al enviar enlace del portal',
    allowedFrequencies: 'Frecuencias de facturación permitidas',
    defaultTerms: 'Términos de factura predeterminados'
  },
  storeBuilder: {
    title: 'Editor visual de la tienda',
    titleProductTemplate: 'Plantilla de página de producto',
    subtitle: 'Editor con vista previa en vivo',
    openVisualEditor: 'Editor visual',
    openProductTemplate: 'Plantilla de producto',
    pageSwitcher: {
      home: 'Página de inicio',
      product: 'Plantilla de producto',
    },
    contentPages: {
      manage: 'Páginas de contenido',
      title: 'Páginas de contenido',
      subtitle: 'Páginas estáticas (Acerca de, Contacto, etc.) usan las mismas secciones que la página de inicio.',
      create: 'Nueva página',
      createTitle: 'Crear página de contenido',
      pageTitle: 'Título de la página',
      pageSlug: 'Slug de URL',
      pageSlugHint: 'Se usa en el enlace de la página que comparte con clientes (minúsculas, números, guiones)',
      edit: 'Editar',
      duplicate: 'Duplicar',
      empty: 'Aún no hay páginas de contenido.',
      createFailed: 'No se pudo crear la página.',
      duplicated: 'Página duplicada.',
      duplicateFailed: 'No se pudo duplicar la página.',
      deleteTitle: 'Eliminar página',
      deleteConfirm: '¿Eliminar “{title}”? Los cambios no se reflejan en la tienda hasta volver a publicar.',
      deleted: 'Página eliminada.',
      deleteFailed: 'No se pudo eliminar la página.',
      editTitle: 'Editar: {title}',
    },
    undo: 'Deshacer',
    redo: 'Rehacer',
    publish: 'Publicar',
    publishSuccess: 'Tienda publicada: los clientes verán esta versión.',
    publishFailed: 'No se pudo publicar. Guarda el borrador e inténtalo de nuevo.',
    storeDisabledBanner: 'Active Blu Store en ajustes para editar y guardar la página de inicio.',
    previewFrameTitle: 'Vista previa de la tienda',
    previewLoading: 'Cargando vista previa…',
    previewLoadFailed: 'No se pudo cargar el borrador de la tienda desde el servidor.',
    viewportDesktop: 'Escritorio',
    viewportMobile: 'Móvil',
    savedNotify: 'Borrador guardado',
    savedLocalNotify: 'Borrador guardado solo en este dispositivo — reconecte para sincronizar con el servidor.',
    savedLocalFallback: 'No se pudo contactar al servidor — borrador guardado solo en este navegador.',
    savedGlobalsFailed: 'Borrador guardado, pero el estilo del sitio no se sincronizó. Recargue el editor y guarde de nuevo.',
    saveStatus: {
      idle: 'Cambios guardados',
      unsaved: 'Cambios sin guardar',
      saving: 'Guardando…',
      saved: 'Guardado',
      savedLocal: 'Guardado localmente',
      error: 'Error al guardar',
    },
    inspector: {
      section: 'Sección',
      siteStyle: 'Estilo del sitio',
      chrome: 'Encabezado y pie',
      selectSection: 'Seleccione una sección en la lista o la vista previa.',
    },
    sectionGallery: {
      title: 'Agregar sección',
      hint: 'Elija un bloque para agregar a la página.',
    },
    chrome: {
      title: 'Chrome de la tienda',
      hint: 'Enlaces de navegación y pie en todas las páginas.',
      announcementEnabled: 'Mostrar barra de anuncio',
      announcementText: 'Texto del anuncio',
      announcementLinkLabel: 'Etiqueta del enlace opcional',
      announcementStyle: 'Colores de la barra',
      announcementStyleTheme: 'Usar primario del tema',
      announcementStyleCustom: 'Colores personalizados',
      announcementBg: 'Fondo de la barra',
      announcementTextColor: 'Color del texto',
      announcementMarquee: 'Texto desplazable (marquesina)',
      announcementDismissible: 'Permitir que el cliente cierre la barra',
      navLinks: 'Navegación del encabezado',
      socialLinks: 'Redes sociales',
      addSocialLink: 'Agregar red social',
      socialIconPreset: 'Icono predefinido',
      socialIconUrl: 'URL del icono (HTTPS)',
      socialIconUrlHint: 'URL PNG o SVG; reemplaza el predefinido si se indica.',
      socialIconNone: 'Ninguno',
      socialIconInstagram: 'Instagram',
      socialIconFacebook: 'Facebook',
      socialIconTiktok: 'TikTok',
      socialIconPinterest: 'Pinterest',
      socialIconYoutube: 'YouTube',
      socialIconX: 'X (Twitter)',
      policyLinks: 'Enlaces de políticas (pie)',
      footerWave: 'Onda curva sobre el pie',
      footerColumns: 'Columnas del pie',
      footerColumn: 'Columna {n}',
      columnTitle: 'Título de columna',
      linkLabel: 'Etiqueta',
      linkHref: 'URL o ruta',
      addLink: 'Agregar enlace',
      addColumn: 'Agregar columna',
      removeColumn: 'Eliminar columna',
    },
    restore: {
      open: 'Restaurar',
      title: 'Restaurar una versión publicada',
      hint: 'Carga esa versión en sus borradores. La tienda en vivo no cambia hasta que publique de nuevo.',
      releaseLabel: 'Versión #{id}',
      empty: 'Aún no hay versiones publicadas.',
      success: 'Borrador restaurado desde la versión.',
      failed: 'No se pudo restaurar.',
    },
    sectionList: {
      title: 'Secciones',
      moveUp: 'Subir sección',
      moveDown: 'Bajar sección',
      duplicate: 'Duplicar sección',
      remove: 'Eliminar sección',
    },
    section: {
      heroLayout: 'Diseño del héroe',
      heroLayoutSplit: 'Dividido (imagen + texto)',
      heroLayoutStack: 'Apilado',
      heroImageHint: 'Sube una foto o pega una URL HTTPS para diseños dividido/apilado.',
      imageUpload: 'Subir imagen',
      imageUploadHint: 'JPEG, PNG o WebP desde tu dispositivo.',
      imageUploadFailed: 'No se pudo subir la imagen. Intenta de nuevo o usa un archivo más pequeño.',
      imageRemove: 'Quitar imagen',
      heroCta: 'Botón de llamada a la acción',
      heroCtaLabel: 'Etiqueta del botón',
      heroCtaLink: 'Enlace del botón',
      heroCtaLinkHint: 'Ruta de la tienda (p. ej. /) o URL https:// completa.',
      focalPoint: 'Punto focal de la imagen',
      focalCenter: 'Centro',
      focalTop: 'Arriba',
      focalBottom: 'Abajo',
      focalLeft: 'Izquierda',
      focalRight: 'Derecha',
      productDetailsLocked: 'Obligatorio en cada página de producto. Solo puede ajustar opciones de visualización.',
      productDetailsShowTitle: 'Mostrar título del producto',
    },
    siteStyle: {
      title: 'Estilo del sitio',
      hint: 'Tokens de diseño globales junto con el tema predefinido.',
      primaryColor: 'Color primario',
      accentColor: 'Color de acento',
      backgroundColor: 'Color de fondo',
      headerColor: 'Fondo del encabezado',
      textColor: 'Color de texto',
      accentColorHint: 'Acentos secundarios en la tienda en vivo (no el marco de selección del editor).',
      fontPair: 'Par de fuentes',
      fontInter: 'Inter — moderno y limpio (retail general)',
      fontOutfit: 'Outfit — contemporáneo geométrico',
      fontNunitoSans: 'Nunito Sans — suave y cercano',
      fontRubik: 'Rubik — redondeado y accesible',
      fontMonoAccent: 'Space Grotesk + IBM Plex — tecnología y makers',
      fontBarlow: 'Barlow Condensed + Barlow — industrial y audaz',
      fontOswaldOpenSans: 'Oswald + Open Sans — deporte y outdoor',
      fontPlayfairSource: 'Playfair + Source Sans — boutique editorial',
      fontCormorantMontserrat: 'Cormorant + Montserrat — moda de lujo',
      fontDmSerifDmSans: 'DM Serif + DM Sans — elegante y minimal',
      fontJosefinLato: 'Josefin + Lato — belleza y bienestar',
      fontSerifModern: 'Libre Baskerville + Inter — clásico legible',
      fontLoraInter: 'Lora + Inter — artesanía',
      fontMerriweatherLato: 'Merriweather + Lato — café y hospitalidad',
      fontCrimsonInter: 'Crimson Pro + Inter — literatura y regalos',
      fontEbGaramondInter: 'EB Garamond + Inter — tradicional formal',
      fontPtSerifInter: 'PT Serif + Inter — noticias y editorial',
      fontFrauncesWorkSans: 'Fraunces + Work Sans — alimentos especiales',
      buttonShape: 'Forma del botón',
      buttonSquare: 'Cuadrado',
      buttonRounded: 'Redondeado',
      buttonPill: 'Píldora',
      buttonVariant: 'Estilo del botón',
      buttonVariantSolid: 'Relleno sólido',
      buttonVariantOutline: 'Contorno',
      buttonVariantFlat: 'Tinte plano',
      buttonVariantElevated: 'Elevado',
      buttonVariantGloss: 'Brillo',
      buttonLabelColor: 'Texto del botón',
      buttonLabelAuto: 'Auto (negro o blanco)',
      buttonLabelLight: 'Claro',
      buttonLabelDark: 'Oscuro',
      cornerTreatment: 'Esquinas',
      cornerSharp: 'Agudas',
      cornerSoft: 'Suaves',
      spacingDensity: 'Espaciado',
      spacingCompact: 'Compacto',
      spacingComfortable: 'Cómodo',
      spacingSpacious: 'Amplio',
      contentWidth: 'Ancho del contenido',
      widthNarrow: 'Estrecho',
      widthStandard: 'Estándar',
      widthWide: 'Ancho',
      colorDefault: 'Predeterminado del tema',
      colorInk: 'Tinta',
      colorNavy: 'Azul marino',
      colorBlue: 'Azul',
      colorTeal: 'Verde azulado',
      colorGreen: 'Verde',
      colorAmber: 'Ámbar',
      colorRose: 'Rosa',
      colorWhite: 'Blanco',
      colorCloud: 'Nube',
      colorSand: 'Arena',
      customColor: 'Color personalizado',
      hexValue: 'Hex',
      enableScrollReveal: 'Animar secciones al desplazar',
      enableScrollRevealHint: 'Aparición suave en inicio y plantilla de producto. Desactivado en la vista previa del editor.',
      enableAddToCartFly: 'Animación volar al carrito',
      enableAddToCartFlyHint: 'La imagen del producto vuela al icono del carrito al añadir (PDP y añadir rápido). Respeta movimiento reducido.',
    },
  },
  richText: {
    link: 'Enlace',
    linkTip: 'Insertar hipervínculo'
  }
}
